// Spanish translations - TODO: fill in translations
// This file should mirror the structure of en.js exactly
export default {
  general: {
    searchAll: 'Buscar todo',
    pleaseContactUs: 'Póngase en contacto con nosotros si necesita ayuda adicional.',
    editThisAccount: 'Editar esta cuenta',
  },
  btn: {
    reloadNow: 'Recargar ahora',
    addNew: 'Añadir nuevo',
    Download: 'Descargar',
    metrics: 'Métricas',
    cancelLastChanges: 'Cancelar los últimos cambios',
    confirmBtn: 'Confirmar',
    acceptResults: 'Aceptar resultados',
    verifyAndGenerate: 'Verificar y generar',
    addAssessment: 'Añadir evaluación',
    enableClaim: 'Habilitar reclamación',
    clearFilter: 'Borrar filtro',
    applyChanges: 'Aplicar cambios',
    login: 'Iniciar sesión',
    proceed: 'Continuar',
    forgotPassword: '¿Has olvidado la contraseña?',
    cancel: 'Cancelar',
    remove: 'Eliminar',
    save: 'Guardar',
    modifyDemographics: 'Modificar datos demográficos',
    submit: 'Enviar',
    send: 'Enviar',
    sendCode: 'Enviar código',
    verify: 'Verificar',
    backToSignIn: 'Volver a iniciar sesión',
    returnToDashboard: 'Volver al panel',
    confirmAndContinue: 'Confirmar y continuar',
    create: 'Crear',
    patient: 'Paciente',
    addPatient: 'Añadir paciente',
    editPatient: 'Editar paciente',
    addAccount: 'Añadir cuenta',
    addOrder: 'Añadir pedido',
    createAccount: 'Crear cuenta',
    generateReport: 'Generar informe',
    createPatient: 'Crear paciente',
    createOrder: 'Crear pedido',
    createProgram: 'Crear programa',
    programs: 'Servicios',
    journeys: 'Programas',
    overview: 'Resumen',
    contactSupport: 'Contactar con el servicio de asistencia',
    copyToClipboard: 'Copiar esta sección',
    createAssessment: 'Crear evaluación',
    createResource: 'Añadir recurso',
    startProgram: 'Iniciar programa',
    select: 'Seleccionar',
    readMore: 'Leer más',
    back: 'Atrás',
    selected: 'Seleccionado',
    current: 'Actual',
    setPasswordLogIn: 'Establecer contraseña',
    updatePassword: 'Actualizar contraseña',
    export: 'Exportar',
    close: 'Cerrar',
    openAssessmentIntoNewTab: 'Abrir evaluación en otra pestaña',
    acceptContinue: 'Aceptar y continuar',
    ok: 'Ok',
    logOut: 'Cerrar sesión',
    stayLoggedIn: 'Mantener sesión',
    resendInvitation: 'Reenviar invitación',
    goToListOfPatients: 'Ir a la lista de pacientes',
    orders: 'Pedidos',
    assessments: 'Evaluaciones',
    resource: 'Recursos',
    billing: 'Facturación',
    billingReports: 'Informes de facturación',
    claimsReporting: 'Reclamaciones',
    claimReport: 'Informe de reclamación',
    reportable: 'Notificable',
    reportables: 'Informes',
    takeInClinic: 'Aceptar en la clínica',
    sendAnInvite: 'Enviar una invitación',
    closeAll: 'Cerrar todo',
    expandAll: 'Expandir todo',
    collapseAll: 'Contraer todo',
    exportPdf: 'Exportar PDF',
    default: 'Predeterminado',
    apply: 'Aplicar',
    next: 'Siguiente',
    verifyEmail: 'Verificar correo',
    addToAccount: 'Añadir a la cuenta',
    applyFilter: 'Aplicar filtro',
    applySorting: 'Aplicar ordenación',
    downloadPDF: 'Descargar informe de reclamaciones pendientes',
    downloadCSV: 'Descargar CSV',
    downloadZIP: 'Descargar ZIP',
    download: 'Descargar',
    refresh: 'Actualizar',
    acknowledge: 'Confirmar',
    noReportsToCompare: 'Aún no hay otros informes que comparar.',
    selectorEndMessage: '¡Genial! Lo has visto todo',
    searchByICDCode: 'Buscar por código ICD',
    continue: 'Continuar',
    selectAllOption: 'Seleccionar todo',
    deleting: 'Eliminando...',
    permanentlyDeleteUser: 'Eliminar definitivamente',
    retry: 'Reintentar',
    openInDrive: 'Abrir en Drive',
    retryAndClearFilters: 'Reintentar y borrar filtros',
    editMultiple: 'Editar varios',
    cancelBulk: 'Cancelar masivo',
    applyToAccounts: 'Aplicar a {{count}} cuentas',
    manageAccess: 'Gestionar acceso',
    discard: 'Descartar cambios',
    keepEditing: 'Seguir editando',
    retryFailed: 'Reintentar fallidos',
    add: 'Agregar',
    edit: 'Editar',
    removeAccess: 'Quitar acceso',
    saving: 'Guardando',
    applying: 'Aplicando',
    reload: 'Recargar',
    addAccounts: 'Añadir cuentas',
    compareWith: 'Comparar con',
    done: 'Listo',
  },
  nav: {
    resetPassword: 'Restablecer contraseña',
    logOut: 'Cerrar sesión',
    build: 'Compilación',
    env: 'ENTORNO',
    dev: 'DESARROLLO',
    testing: 'PRUEBAS',
    qhsLabs: 'QHS Lab',
    privacy: 'Privacidad',
    terms: 'Condiciones',
    hippa_baa: 'HIPPA BAA',
  },
  titles: {
    authorizeAccess: 'Autorizar acceso',
    deleteUser: 'Eliminar acceso a la cuenta',
    deleteUserLoading: 'Cargando información del usuario...',
    deleteUserSubtitle: 'El usuario será eliminado definitivamente de esta cuenta',
    deleteUserSubtitle2: 'El usuario será eliminado definitivamente de estas cuentas',
    deleteUserFinalTitle: 'Se requiere autorización final',
    resource: 'recurso',
    allowedAccounts: 'Cuentas permitidas',
    availableAccounts: 'Cuentas disponibles',
    selectedAccounts: 'Cuentas seleccionadas',
    selectAccountsInfo:
      'Seleccione las cuentas a las que desea conceder acceso al nuevo usuario. Puede configurar roles y permisos específicos en el siguiente paso.',
    accountSettingsInfo:
      'Configure el rol y los permisos que se aplicarán a todas las cuentas seleccionadas',
    importFromExisting: 'Importar de cuenta existente',
    noAccountsSelected: 'No hay cuentas seleccionadas',
    unlimitedAccessEnabled: 'El acceso ilimitado está habilitado',
    unlimitedAccessDescription:
      'Este usuario tiene acceso a todas las cuentas. Seleccione cuentas específicas de la tabla para restringir el acceso.',
    selectAccountsFromTable: 'Seleccionar cuentas de la tabla de la izquierda',
    removeFromSelection: 'Eliminar de la selección',
    multipleSelection: 'Selección múltiple',
    instantAssessment: 'Evaluación instantánea',
    acknowledge: 'Aceptar',
    oneMore: 'Alguna acción con modal',
    alerts: 'Alertas',
    cpts: 'CPT',
    aspects: 'Aspectos',
    responses: 'Respuestas',
    cpt: 'CPT',
    noShow: 'No se presentó',
    reverseNoShow: 'Revocación de "No se presentó"',
    declined: 'Rechazado',
    reverseDeclined: 'Revocación de "Rechazado"',
    accountCptCodes: 'Códigos CPT de la cuenta',
    preview: 'vista previa',
    noAccountSelected: ' No hay ninguna cuenta seleccionada',
    displayedColumns: 'Columnas mostradas',
    assessmentInProgress: 'Evaluación en curso',
    assessmentInProgressMessage:
      'El paciente aún no ha completado esta evaluación. El informe estará disponible cuando termine.',
    noReportData: 'Sin datos de informe',
    noReportDataMessage: 'Esta evaluación no produjo contenido para el informe.',
    failedToLoadReport: 'No se pudo cargar el informe',
    failedToLoadReportMessage: 'Inténtelo de nuevo o contacte con soporte si el problema persiste.',
    someDataNotAvailable: 'Es posible que algunos datos aún no estén disponibles',
    claimReports: 'Informes de reclamaciones',
    reportables: 'Informes',
    botActivities: 'Actividad del bot',
    reported: 'Informado',
    downloadReport: 'Descargar informe',
    accepted: 'Aceptado',
    items: 'elementos',
    notFound: 'No encontrado',
    dashboard: 'Panel',
    populationHealth: 'Salud de la población',
    assessmentPerformance: 'Rendimiento de evaluaciones',
    claimsManager: 'Gestor de reclamaciones',
    bhiDashboard: 'Panel de BHI',
    rootPage: 'Página raíz',
    open: 'Abierto',
    claimsReporting: 'Reclamaciones',
    claims: 'reclamaciones',
    editClaim: 'Editar reclamación',
    upload: 'Subir',
    patientUpload: 'Subir pacientes',
    insuranceUpload: 'Subir seguros',
    providersUpload: 'Subir proveedores',
    claimsUpload: 'Subir reclamaciones',
    downloadPracticeOptimizationReport: 'Descargar informe de optimización de la consulta',
    practiceOptimizationReport: 'Informe de optimización de la consulta',
    enableClaim: 'Habilitar reclamación para este {{source}}',
    enableClaimSubtitle:
      'Se habilitará una reclamación para este {{source}}. Para eliminar la reclamación (deshacer esta operación), marque la reclamación como "No facturable" en el área de Reclamaciones.',
    patientUploadForAccount: 'Carga de pacientes para {{accountName}}',
    insuranceUploadForAccount: 'Carga de seguros para {{accountName}}',
    claimsUploadForAccount: 'Carga de reclamaciones para {{accountName}}',
    providersUploadForAccount: 'Carga de proveedores para {{accountName}}',
    editProfile: 'Editar perfil',
    changePassword: 'Cambiar contraseña',
    accounts: 'Cuentas',
    selectAndUploadFile: 'Seleccionar y subir archivo',
    itemSuccessfullyImported: '{{elemento}} importado con éxito',
    insurance: 'Seguro',
    providers: 'Proveedores',
    // Client-requested rename (2026-08-12), matches en.js `titles.journeys`.
    journeys: 'Programas',
    permissionsTesting: 'Pruebas de permisos',
    Claims: 'Reclamaciones',
    importPatients: 'Importar pacientes',
    validate: 'Validar',
    account: 'Cuenta',
    createAccount: 'Crear cuenta',
    editAccount: 'Editar cuenta',
    editAccountDetails: 'Editar datos de la cuenta',
    switchAccount: 'Cambiar de cuenta',
    appearance: 'Apariencia',
    language: 'Idioma',
    light: 'Claro',
    dark: 'Oscuro',
    // The user-facing word for the `auto` theme: follow the OS setting.
    system: 'Sistema',
    notifications: 'Notificaciones',
    viewAccountDetails: 'Ver detalles de la cuenta',
    removeAccount: 'Eliminar cuenta',
    readOnlyNoPermissions: 'Solo lectura: No hay permisos para editar esta cuenta',
    editUsers: 'Editar usuarios',
    users: 'Usuarios',
    user: 'Usuario',
    testDate: 'Fecha de prueba',
    singleView: 'Único',
    compareView: 'Comparar',
    compareUnavailable: 'No hay ninguna evaluación anterior para comparar',
    viewBillingReport: 'Ver informe de facturación',
    addNewPatient: 'Añadir paciente',
    createNewAssessment: 'Crear nueva evaluación',
    createNewResource: 'Crear recurso',
    accountUsers: 'Gestionar usuarios',
    managesUsers: 'Administrador',
    globalUsersManagement: 'Usuarios',
    administerClaims: 'Administrar reclamaciones',
    administerClaimReports: 'Administrar informes de reclamaciones',
    administerReportable: 'Administrar informes',
    receiveClaimsEmails: 'Recibir correos de reclamaciones',
    receiveSurveysEmails: 'Recibir correos con estadísticas de evaluaciones',
    managesAlert: 'Gestiona alertas',
    enablePatientEngagementDeactivation: 'Desactivar la participación del paciente',
    manageChildAccounts: 'Administrador de cuentas secundarias',
    imminentRiskEmails: 'Recibir correos sobre riesgos inminentes',
    enablePrograms: 'Programas',
    managesUsersHint: 'Puede modificar la configuración de la cuenta y los usuarios.',
    administerClaimsHint:
      'Gestionar reclamaciones, reclamaciones notificables e informes de reclamaciones.',
    administerClaimReportsHint:
      'Acceder y gestionar informes de reclamaciones y la funcionalidad de generación de informes.',
    imminentRiskEmailsHint:
      'Recibirá notificaciones por correo electrónico sobre pacientes con riesgo inminente.',
    receiveSurveysEmailsHint:
      'Recibirá correos electrónicos periódicos con estadísticas de evaluación.',
    receiveClaimsEmailsHint:
      'Recibirá correos electrónicos periódicos con estadísticas de reclamaciones.',
    managesAlertHint:
      "Las alertas se considerarán 'leídas' si las ve un usuario con esta opción. También puede realizar acciones sobre las alertas, como acusar recibo de ellas.",
    enablePatientEngagementDeactivationHint:
      'Permite al usuario desactivar la participación del paciente para esta cuenta. Reactivarla requiere un permiso independiente.',
    manageChildAccountsHint: 'Acceso para editar cuentas.',
    enableProgramsHint:
      'Da al usuario acceso a las páginas de Programas en esta cuenta. Requiere que el módulo de Programas esté activado en la cuenta. Surte efecto en el siguiente inicio de sesión.',
    createUser: 'Crear usuario',
    removeUser: 'Eliminar usuario',
    editUser: 'Editar usuario',
    manageUserAccounts: 'Acceso a cuentas de usuario',
    removeAccess: 'Eliminar acceso',
    removeAccessConfirmation: 'Confirmación de eliminación de acceso',
    saveChanges: 'Guardar cambios',
    addAccountAccess: 'Añadir acceso a cuenta',
    searchAccounts: 'Buscar cuentas...',
    noAccountsFound: 'No se han encontrado cuentas para',
    configureAccessPermissions: 'Configurar permisos de acceso y detalles de roles',
    areYouSureRemoveAccess: '¿Está seguro de que desea eliminar el acceso a',
    warningPermissionsLost:
      'Advertencia: Todos los permisos y ajustes de esta cuenta se perderán de forma permanente y no se podrán recuperar.',
    currentAccount: 'Actual',
    permissionsCount: 'permisos',
    patients: 'Pacientes',
    patient: 'Paciente',
    editPatient: 'Editar paciente',
    createProgram: 'Crear programa',
    selectRangeDate: 'Seleccionar rango de fechas',
    removePatient: 'Eliminar paciente',
    createPatient: 'Crear paciente',
    editOrder: 'Editar pedido',
    removeOrder: 'Eliminar pedido',
    reorder: 'Volver a pedir',
    createOrder: 'Crear pedido',
    createAssessment: 'Crear evaluación',
    orders: 'Pedidos',
    order: 'Pedido',
    assessmentCreated: 'Evaluación creada',
    resourceCreated: 'Recurso creado',
    verifyInvitationDetails: 'Verificar detalles de la invitación',
    assessments: 'Evaluaciones',
    // Client-requested rename (2026-08-12), matches en.js `titles.programs`.
    programs: 'Servicios',
    reports: 'Informes',
    report: 'Informe',
    billing: 'Facturación',
    billingReports: 'Informes de facturación',
    allergiEndResources: 'Documentos de AllergiEnd',
    allergiEndResourcesDescription:
      'Consulta los recursos educativos y documentos clínicos de AllergiEnd alojados en Google Drive.',
    qhslabDocuments: 'Documentos de QHSLAB',
    qhslabDocumentsDescription:
      'Consulta las guías, materiales de formación y documentos de programas de QHSLAB alojados en Google Drive.',
    resources: 'Recursos',
    editAssessment: 'Editar evaluación',
    editBill: 'Editar factura',
    removeBill: 'Eliminar factura',
    patientDashboard: 'Panel del paciente',
    openPatientDashboard: 'Abrir panel del paciente',
    programDashboard: 'Panel del servicio',
    removeAssessment: 'Eliminar evaluación',
    assessmentAdded: 'Nueva evaluación añadida',
    patientAdded: 'Nuevo paciente añadido',
    invitationSent: 'Invitación enviada',
    assessmentLinkGenerated: 'Enlace de evaluación generado',
    assessmentLinkGeneratedSubtitle:
      'Se ha generado correctamente el enlace de su evaluación. Comparta este enlace seguro con su paciente para que comience su evaluación.',
    openAssessment: 'Abrir evaluación',
    linkCopied: '¡Enlace copiado al portapapeles!',
    invitationSentAssessment:
      'Tu invitación a la evaluación se ha enviado correctamente al paciente. Recibirá un mensaje con instrucciones sobre cómo completar la evaluación.',
    invitationSentResource:
      'Tu invitación al recurso se ha enviado correctamente al paciente. Recibirá un mensaje con instrucciones sobre cómo completar el recurso.',
    immediateNotification: 'El paciente recibirá una notificación inmediata',
    assessmentLinkSecure: 'El enlace de la evaluación es seguro y personalizado',
    resourceLinkSecure: 'El enlace del recurso es seguro y personalizado',
    assessmentResultsAuto: 'Los resultados aparecerán automáticamente en su panel de control',
    resourceTrackingAuto:
      'El seguimiento de accesos aparecerá automáticamente en su panel de control',
    loading: 'Cargando...',
    pleaseWait: 'Por favor, espere',
    nothingFound: 'No se ha encontrado nada que coincida con su solicitud.',
    resendInvitation: 'Reenviar invitación',
    generateClaim: 'Generar reclamación',
    viewAssessmentLink: 'Ver enlace de evaluación',
    generateProgramClaim: 'Generar reclamación del programa',
    downloadProgram: 'Descargar informe E-Visit',
    downloadCounselingReport: 'Descargar informe de consejería',
    downloadGroup: 'Descargar',
    downloadItemReport: 'Informe',
    downloadItemComparison: 'Informe comparativo',
    downloadItemProgram: 'E-Visit',
    downloadItemCounseling: 'Informe de consejería',
    downloadImmunotherapyReport: 'Descargar informe de inmunoterapia',
    reportNavigation: 'Navegación por el informe',
    reportSections: 'Secciones del informe',
    linkWillBeProvided: 'Se proporcionará un enlace una vez creada la evaluación.',
    downForMaintenance: 'Fuera de servicio por mantenimiento.',
    downForMaintenanceSubtitleFirst:
      'Actualmente estamos trabajando en algunas actualizaciones de nuestra plataforma y, mientras tanto, el servicio estará fuera de servicio.',
    downForMaintenanceSubtitleSecond: 'Gracias por su paciencia.',
    openThisPage:
      'Abra esta página en el dispositivo adecuado y permita que el paciente complete la evaluación. Una vez completada, recibirá los siguientes pasos para su tramitación.',
    engagementHistory: 'Historial de estado',
    // Create User wizard
    step: 'Paso',
    of: 'de',
    noSelection: 'Sin cuentas seleccionadas',
    newBadge: 'NUEVO',
    errorLoading: 'No se pudieron cargar los datos del usuario.',
    selectAccountsForUser: 'Seleccionar cuentas',
    configureAccess: 'Configurar acceso',
    previousAssessment: 'Evaluación anterior',
    assessment1: 'Evaluación 1',
    assessment2: 'Evaluación 2',
    question: 'Pregunta',
    result: 'Resultado',
    needsAttention: 'Requiere atención',
    // Public auth pages
    signIn: 'Iniciar sesión',
    resetPassword: 'Restablecer contraseña',
    verifyEmail: 'Verifica tu correo',
    setNewPassword: 'Establece tu nueva contraseña',
    almostThere: '¡Ya casi está!',
    pageNotFound: 'Página no encontrada',
    pageNotFoundSubtitle:
      'La página que buscas puede haber sido eliminada, renombrada o no estar disponible temporalmente.',
    welcomeToQHSLab: 'Bienvenido al',
    qhsLabBrand: 'Sistema de Salud de Calidad (QHS)',
    newAssessment: 'Nueva evaluación',
    newResource: 'Nuevo recurso',
    configureAssessment: 'Configurar evaluación',
    configureResource: 'Configurar recurso',
    resourceSent: 'Recurso enviado',
    linkReady: 'Enlace listo',
    forPatient: 'Para {{name}}',
    forPatientWithDob: 'Para {{name}} · FDN {{dob}}',
  },
  catalog: {
    searchAssessments: 'Buscar evaluaciones\u2026',
    searchResources: 'Buscar recursos\u2026',
    noMatchesFor: 'Sin coincidencias para "{{query}}"',
    matchesCountFor: '{{count}} coincidencias para "{{query}}"',
    itemsCount: '{{count}} recursos',
    sortedAlphabetically: 'Ordenado alfabéticamente',
    bestMatchesFirst: 'Mejores coincidencias primero',
    allChip: 'Todos',
    autoAdvanceHint: 'Al seleccionar avanza automáticamente al paso 2',
    readMore: 'Leer más',
    readLess: 'Leer menos',
  },
  configure: {
    selectedAssessment: 'Evaluación seleccionada',
    selectedResource: 'Recurso seleccionado',
    change: 'Cambiar',
    contactInformation: 'Información de contacto',
    whenToSend: 'Cuándo enviar',
    sendNow: 'Enviar ahora',
    sendNowDescAssessment: 'El paciente recibe la invitación de inmediato.',
    sendNowDescResource: 'El paciente recibe el recurso de inmediato.',
    scheduleForLater: 'Programar para más tarde',
    scheduleForLaterDesc: 'Elige una fecha y hora en la zona horaria del paciente.',
    patientTimezone: 'Zona horaria del paciente: {{tz}}',
    noUpdateNeeded: 'No se necesita actualización \u2014 coincide con el registro del paciente.',
    matchesPatientRecord: 'Coincide con el registro del paciente.',
    phoneNotOnFile:
      'El número de teléfono no está registrado. Agrégalo a continuación para enviar por SMS.',
    updateRecordEmailTitle: 'Actualizar el registro del paciente con este correo',
    updateRecordEmailDesc: 'Reemplaza {{previous}} en el perfil del paciente después del envío.',
    updateRecordPhoneTitle: 'Actualizar el registro del paciente con este teléfono',
    updateRecordPhoneDesc: 'Guarda {{value}} en el perfil del paciente después del envío.',
  },
  delivery: {
    sendInvitation: 'Enviar invitación',
    takeInClinic: 'Realizar en clínica',
    howWillPatientTake: 'Envío',
    sendInvitationDesc: 'Un enlace por correo o SMS',
    takeInClinicDesc: 'Un enlace en un dispositivo aquí; no se envía nada',
    whatHappensNext: 'Qué sucede después',
    assessmentLink: 'Enlace de la evaluación',
    generateLink: 'Generar enlace',
    inClinicStep1: 'Genera el enlace.',
    inClinicStep2: 'Ábrelo en el dispositivo del paciente.',
    inClinicStep3: 'Entrega el dispositivo al paciente.',
    inClinicExistingLead:
      'Esta evaluación ya tiene un enlace. Ábrelo en un dispositivo de tu clínica y entrégaselo ' +
      'al paciente. No se envía una nueva invitación.',
  },
  done: {
    invitationSentTo: 'Invitación enviada a {{name}}',
    resourceSentTo: 'Recurso enviado a {{name}}',
    invitationScheduledTo: 'Invitación programada para {{name}}',
    resourceScheduledTo: 'Recurso programado para {{name}}',
    invitationScheduledLead:
      'Puedes cerrar este panel — la invitación se enviará a la hora que elegiste y ' +
      'los resultados aparecerán en el panel del paciente una vez enviados.',
    resourceScheduledLead:
      'El recurso se enviará a la hora que elegiste. También lo verá en su próxima ' +
      'visita al panel.',
    sentNow: 'Enviado ahora',
    sentNowAt: 'a las {{time}}',
    scheduledSend: 'Programado',
    scheduledFor: 'para el {{date}} a las {{time}}, en la zona horaria del paciente',
    scheduledForDate: 'para el {{date}}, en la zona horaria del paciente',
    channelEmail: 'Por correo electrónico',
    channelSms: 'Por SMS',
    channelTo: 'a {{address}}',
    invitationSentLead:
      'Puedes cerrar este panel \u2014 los resultados aparecerán en el panel del paciente ' +
      'una vez enviados.',
    resourceSentLead: 'También lo verá en su próxima visita al panel.',
    patientProfileUpdatedEmail: 'Perfil del paciente actualizado con el nuevo correo.',
    patientProfileUpdatedPhone: 'Perfil del paciente actualizado con el nuevo teléfono.',
    linkReadyHeadline: 'Enlace de evaluación generado',
    linkReadyLead:
      'Abre este enlace en el dispositivo que usará el paciente, o cópialo para enviarlo por ' +
      'tu propio canal.',
    linkReadyTip: 'Consejo: abre el enlace en la tableta del paciente y luego entrégasela.',
    openAssessment: 'Abrir evaluación',
    copyLink: 'Copiar enlace',
    linkCopied: 'Enlace copiado al portapapeles',
  },
  forms: {
    ID: 'ID',
    address: 'Dirección',
    loading: 'Cargando...',
    undo: 'Deshacer',
    time: 'Hora',
    date: 'Fecha',
    selectAllInfo:
      'Utiliza este botón para habilitar el acceso a todas las cuentas que están visibles actualmente en la lista.',
    allAccountsSelected: 'Todas las cuentas seleccionadas. ',
    selectAll: 'Seleccionar todo',
    allowedResources: 'Recursos permitidos',
    allowedSurveys: 'Evaluaciones permitidas',
    addresses: 'Direcciones',
    encounterStatus: 'Estado de la consulta',
    patientLanguage: 'Idioma del paciente',
    race: 'Raza',
    selectRace: 'Seleccionar raza…',
    selectState: 'Seleccionar estado…',
    dos: 'Fecha del servicio',
    insurance: 'Seguro',
    cptInfo: 'Información CPT',
    billingStatus: 'Estado de facturación',
    location: 'Ubicación',
    appointmentProvider: 'Proveedor de la cita',
    checkDate: 'Fecha de verificación',
    paymentDate: 'Fecha de pago',
    paymentMethod: 'Método de pago',
    prType: 'Tipo de PR',
    claimGeneratedTimestamp: 'Fecha de creación de la reclamación',
    createdBy: 'Creado por',
    lastModifiedTimestamp: 'Fecha de modificación',
    modifiedBy: 'Modificado por',
    cptCode: 'Código CPT',
    price: 'Precio',
    initialPrice: 'Precio inicial',
    priceGreaterThanZero: 'El precio debe ser mayor que $0.',
    priceAtMost: 'El precio no puede superar los ${{max}}.',
    accountName: 'Nombre de la cuenta',
    deliverInvitationBy: 'Enviar invitación por',
    orderType: 'Tipo de pedido',
    email: 'Correo electrónico',
    password: 'Contraseña',
    firstName: 'Nombre',
    lastName: 'Apellido',
    features: 'Características',
    settings: 'Configuración',
    configure: 'Configurar',
    configureCount: 'Configurar ({{count}})',
    configureAriaLabel: 'Configurar {{label}}',
    noItemsSelected: 'No hay elementos seleccionados. Haga clic en "Configurar" para seleccionar.',
    searchItemsPlaceholder: 'Buscar elementos...',
    moreCount: '+{{count}} más',
    availableItemsTitle: 'Elementos disponibles',
    selectedItemsTitle: 'Elementos seleccionados',
    clearAll: 'Borrar todo',
    noItemsMatchSearch: 'Ningún elemento coincide con la búsqueda',
    noItemsAvailable: 'No hay elementos disponibles',
    noItemsSelectedShort: 'No hay elementos seleccionados',
    automationNotAvailable: 'La automatización no está disponible para este elemento',
    customEmailSettings: 'Configuración de correo electrónico y SMS',
    customEmailConfiguration: 'Configuración personalizada de correo electrónico y SMS',
    customEmailDescription:
      'Personalice los mensajes enviados a sus pacientes para los distintos tipos de comunicación. Use el interruptor para sustituir los mensajes predeterminados por su propio contenido.',
    invitations: 'Invitaciones',
    reminders: 'Recordatorios',
    completionNotifications: 'Notificaciones de finalización',
    assessmentCommunications: 'Comunicaciones de evaluación',
    resourceCommunications: 'Comunicaciones de recursos',
    custom: 'Personalizado',
    claimReportType: 'Tipo de informe de reclamación',
    claimReportWithoutFinancial: 'Sin información financiera',
    claimReportWithFinancial: 'Con información financiera',
    checkCptsTableErrors: 'Por favor, revise la tabla de CPTs. Hay algunos errores.',
    // Create User steps
    step1EmailVerification: 'Paso 1: Verificación de correo electrónico',
    checkUserExistsDescription: 'Compruebe si el usuario existe antes de crearlo',
    emailAddress: 'Dirección de correo electrónico',
    emailPlaceholder: 'usuario@ejemplo.com',
    whyCheckFirst: 'Por qué verificar primero?',
    checkFirstDescription:
      'Evita usuarios duplicados y garantiza la integridad de los datos en su sistema',
    step2UserDetails: 'Paso 2: Datos del usuario',
    enterUserInformation: 'Introduzca la información personal del usuario',
    // Create User step labels
    stepCheckEmail: 'Verificar correo',
    stepUserDetails: 'Datos del usuario',
    stepSelectAccounts: 'Seleccionar cuentas',
    stepAccountSettings: 'Config. de cuenta',
    // Allowed Accounts section
    accessToAllAccounts: 'Acceso a todas las cuentas',
    accessToSpecificAccounts: 'Acceso a {{count}} cuentas específicas',
    accessToSpecificAccount: 'Acceso a 1 cuenta específica',
    unlimited: 'Ilimitado',
    limited: 'Limitado',
    accountSelected: 'Cuenta seleccionada',
    accountsSelected: 'Cuentas seleccionadas',
    modifyAccessHint:
      'Haga clic en "Modificar acceso" para ver y cambiar las cuentas seleccionadas',
    unlimitedAccessDescription: 'Este usuario tendrá acceso a todas las cuentas actuales y futuras',
    modifyAccess: 'Modificar acceso',
    setAccountAccess: 'Configurar acceso a cuentas',
    phone: 'Teléfono',
    preferredPhone: 'Teléfono preferido (lo indica el paciente)',
    confirmPassword: 'Confirmar contraseña',
    confirmCode: 'Confirmar código',
    hasEmailSubscription: 'Suscripción por correo electrónico',
    hasEmailSubscriptionDescription:
      'El paciente ha dado su consentimiento por escrito o verbalmente para recibir mensajes de correo electrónico.',
    smsOptIn: 'Suscripción a SMS',
    smsOptInDescription:
      'Este paciente ha dado su consentimiento, por escrito o verbalmente, para recibir mensajes SMS.',
    bhiStatus: 'Estado de BHI',
    bhiStatusDescription: 'Inscrito',
    bhiStatusHint: 'Lo establece el sistema.',
    // Customer-mandated wording (daily call 2026-08-05): the word
    // "engagement" is reserved for future CPT/billing interaction
    // metrics — this feature speaks of the patient STATUS. Keys keep
    // the legacy patientEngagement* names; only the copy changed.
    patientEngagement: 'Estado',
    patientEngagementReason: 'Motivo',
    patientEngagementReasonHint:
      'Se requiere un motivo (de 3 a 500 caracteres) al cambiar el estado del paciente.',
    patientEngagementEnabledShort: 'Activo',
    patientEngagementDisabledShort: 'Inactivo',
    patientEngagementHistoryActivated: 'Activado',
    patientEngagementHistoryDeactivated: 'Desactivado',
    patientEngagementChangedBy: 'Estado cambiado por',
    patientEngagementViewHistory: 'Ver historial',
    patientEngagementPauseTitle: '¿Desactivar a {{name}}?',
    patientEngagementResumeTitle: '¿Reactivar a {{name}}?',
    patientEngagementPauseWarning:
      'Mientras esté inactivo, este paciente no recibirá invitaciones a evaluaciones, SMS ni correos electrónicos, y no se crearán nuevos programas de BHI.',
    patientEngagementResumeInfo:
      'El paciente volverá a recibir invitaciones a evaluaciones, SMS y correos electrónicos.',
    patientEngagementPauseConfirm: 'Desactivar paciente',
    patientEngagementResumeConfirm: 'Reactivar paciente',
    patientEngagementResumeShort: 'Reactivar',
    patientEngagementSaveFirstHint: 'Primero guarde o descarte los cambios',
    patientEngagementActive: 'Activo',
    patientEngagementPausedBadge: 'Paciente inactivo',
    patientEngagementPausedBy: 'Desactivado por {{name}}',
    patientEngagementChange: 'Cambiar',
    relativeToday: 'Hoy',
    relativeYesterday: 'Ayer',
    relativeDaysAgo: 'hace {{count}} días',
    distributionSponsor: 'Patrocinador de distribución',
    updatePatientRecord: 'Actualizar expediente del paciente',
    updatePatientRecordEmail: 'Actualizar el registro del paciente con este correo electrónico',
    updatePatientRecordPhone: 'Actualizar el registro del paciente con este teléfono',
    businessName: 'Nombre de la empresa',
    tradeName: 'Nombre comercial',
    sameAsBusinessName: 'Igual que el nombre de la empresa',
    fax: 'Fax',
    contactName: 'Nombre de contacto',
    headProviderName: 'Nombre del proveedor principal',
    customId: 'ID personalizado',
    name: 'Nombre',
    link: 'Enlace',
    streetAddress: 'Dirección',
    suite: 'Despacho',
    city: 'Ciudad',
    state: 'Estado',
    zipCode: 'Código postal',
    basicInfo: 'Información básica',
    organizationAddress: 'Dirección de la organización',
    overrideDefaultMessage: 'Anular mensaje predeterminado',
    useDefaultMessage: 'Usar mensaje predeterminado',
    survey: 'Evaluación',
    resource: 'Recurso',
    english: 'Inglés',
    spanish: 'Español',
    invitationEmail: 'Correo electrónico de invitación',
    invitationSMS: 'SMS de invitación',
    reminderEmail: 'Correo electrónico de recordatorio',
    reminderSMS: 'SMS de recordatorio',
    completionEmail: 'Correo electrónico de finalización',
    completionSMS: 'SMS de finalización',
    editAccountScreen: 'Pantalla Editar cuenta',
    scheduledActivities: 'Actividades programadas',
    ianaTimeZone: 'Zona horaria',
    scheduleDeliverTime: 'Hora de entrega programada',
    scheduledDate: 'Fecha de entrega programada',
    scheduleDeliverDate: 'Fecha de entrega programada',
    scheduleDeliverData: '¿Cuándo quieres enviarlo?',
    shippingAddress: 'Dirección de envío',
    accountType: 'Tipo de cuenta',
    useSameAddress: 'Usar la misma dirección que la de la organización',
    enableOrders: 'Pedidos',
    enableAllergiEndResources: 'Documentos de AllergiEnd',
    enableAssessments: 'Evaluaciones',
    enableInstantAssessment: 'Evaluación instantánea',
    enableResources: 'Recursos',
    enableClaimsManagement: 'Gestión de reclamaciones',
    enableImmunotherapyReport: 'Informe de inmunoterapia',
    enableIntellyChart: 'Preventive Health Counseling',
    disableOrdersAutomations: 'Automatizaciones de pedidos',
    otherAddresses: 'Otras direcciones',
    addAddress: 'Añadir dirección',
    manageCpts: 'Gestionar códigos CPT',
    removeAddress: 'Eliminar dirección',
    userDetails: 'Detalles del usuario',
    userRoleDetails: 'Detalles del rol de usuario',
    accountAccess: 'Acceso a la cuenta',
    selectAllFilteredItems: 'Seleccionar todos los elementos {{filtered}}',
    unselectAllFilteredItems: 'Deseleccionar todos los elementos {{filtered}} ',
    accountAccessNumber: 'Número de cuentas{{end}} con acceso concedido: {{number}}',
    accountAccessTotalNumber: 'Número total de cuentas seleccionadas{{end}}: {{number}}',
    cptsTotalNumber: 'Códigos CPT: {{number}}',
    selectAllAccounts: 'Seleccionar todas las cuentas',
    modifyAccountAccessList: 'Modificar lista de acceso a cuentas secundarias',
    title: 'Título',
    npiNumber: 'Número NPI',
    provider: 'Proveedor',
    assistant: 'Asistente',
    role: 'Rol',
    mrnNumber: 'N.º MRN',
    bussinessName: 'Nombre de la cuenta',
    dateOfBirth: 'Fecha de nacimiento',
    scheduleDate: 'Fecha de la cita',
    gender: 'Sexo',
    genderAtBirth: 'Sexo al nacer',
    allergies: 'Alergias',
    drugAllergies: 'Alergias a medicamentos',
    noDrugAllergies: 'Sin alergias a medicamentos',
    drugList: 'Lista de medicamentos',
    yes: 'Sí',
    no: 'No',
    unknown: 'Desconocido',
    servesDate: 'Fecha de la visita',
    patientName: 'Nombre del paciente',
    assistantType: 'Tipo de asistente',
    datePaid: 'Fecha de pago',
    ctpNumber: 'Código CPT',
    allowed: 'Permitido',
    notAllowed: 'No permitido',
    all: 'Todo',
    notes: 'Notas',
    paid: 'Pagado',
    pr: 'PR',
    female: 'Mujer',
    male: 'Hombre',
    comments: 'Comentarios',
    slit: 'Slit',
    scit: 'Scit',
    ctpInfo: 'Información CTP',
    orderCategory: 'Categoría de pedido',
    sendNow: 'Enviar ahora',
    scheduleForLater: 'Programar para más tarde',
    allergens: 'Alérgenos',
    patient: 'Paciente',
    maintenance: 'Mantenimiento',
    lowDose: 'Dosis baja',
    quantity: 'Cantidad',
    invitationWillBeSent:
      'Se enviará una invitación a la información de contacto del paciente proporcionada anteriormente.',
    invitationWillBeResent: 'Un nuevo enlace por correo o SMS',
    sentOn: 'Enviado',
    viewAssessmentLinkDescription:
      'Comparta este enlace con el paciente o ábralo para previsualizar su experiencia.',
    viewAssessmentLinkHint: 'Cualquier persona con este enlace puede abrir la evaluación.',
    acceptInvitation:
      'Tu cuenta de QHS está casi lista, solo tienes que configurar una contraseña.',
    resetPasswordStep1:
      'Introduzca la dirección de correo electrónico que utiliza para iniciar sesión. Le enviaremos un código de confirmación para verificar su identidad.',
    resetPasswordStep2:
      'En unos instantes recibirás un correo electrónico nuestro con un código de confirmación. Introduzca ese código a continuación para continuar',
    resetPasswordStep3:
      '¡Gracias, {{name}}! El código ha sido confirmado. Ahora establezca su nueva contraseña a continuación',
    // Public auth pages — concise subtitles for the v3 redesign.
    signInSubtitle: 'Accede a tu panel',
    brandTagline: 'La plataforma sanitaria inteligente para mejores resultados de los pacientes.',
    brandAttribution: 'Desarrollado por QHSLab, Inc.',
    secureHipaa: 'Acceso seguro y conforme a HIPAA',
    resetEmailSubtitle: 'Introduce tu correo para recibir un código de verificación.',
    verifyCodeSubtitle: 'Introduce el código de confirmación que enviamos a tu correo.',
    setNewPasswordSubtitle: '¡Ya casi está! Crea tu nueva contraseña.',
    acceptInvitationSubtitle:
      'Establece una contraseña para terminar de configurar tu cuenta de QHS.',
    notFoundCardSubtitle:
      'Puede haber sido eliminada, renombrada o no estar disponible temporalmente.',
    checkingBackAutomatically: 'Comprobando automáticamente',
    appointmentTimestamp: 'Fecha de la cita',
    selectAppointmentProvider: 'Seleccionar proveedor de la cita',
    selectInsuranceProvider: 'Seleccionar proveedor de seguro',
    appointmentDate: 'Fecha de la cita',
    documentDate: 'Fecha del documento',
    patientSeen: 'Paciente atendido',
    documentUploaded: 'Documento cargado',
    modifier: 'Modificador',
    icd: 'ICD',
    id: 'ID',
    DOS: 'Fecha del servicio (DOS)',
    check: 'N.º de cheque',
    claimStatus: 'Estado de la reclamación',
    cptStatus: 'Estado CPT',
    adjustmentCode: 'Código de ajuste',
    adjustmentCodePlaceholder: 'p. ej. CO-45',
    adjustmentCodeHint: 'Opcional — texto libre, hasta 50 caracteres.',
    appointmentTime: 'Hora de la cita',
    providerInformationRequired: 'Se requiere información del proveedor',
    providerTitleLabel: 'Título del proveedor',
    providerTitlePlaceholder: 'Seleccione un título',
    providerTitleOther: 'Otro',
    providerTitleOtherPlaceholder: 'p. ej. NP-C',
    npiNumberPlaceholder: 'Número NPI de 10 dígitos',
    customIdHeader: 'ID personalizado',
    accountAlreadyExists: 'Ya existe una cuenta para este usuario',
    addToSelection: 'Añadir a la selección',
    allowedAssessments: 'Evaluaciones permitidas',
    allowedAssessmentsSubtitle: 'Seleccione las evaluaciones disponibles para esta cuenta',
    searchAssessmentsPlaceholder: 'Buscar evaluaciones...',
    selectAllowedAssessments: 'Seleccionar evaluaciones permitidas',
    allowedResourcesLabel: 'Recursos permitidos',
    allowedResourcesSubtitle: 'Selecciona los recursos disponibles para esta cuenta',
    searchResourcesPlaceholder: 'Buscar recursos...',
    selectAllowedResources: 'Seleccionar recursos permitidos',
    loadingCptCodes: 'Cargando códigos CPT...',
    noCptConfigured:
      'No hay servicios CPT configurados. Haga clic en "Añadir servicio CPT" para empezar.',
    selectCptCode: 'Seleccionar código CPT...',
    addInitialPrice: 'Añadir precio inicial',
    enterEnglishMessage: 'Introducir mensaje en inglés...',
    enterSpanishMessage: 'Introducir mensaje en español...',
    preview: 'Vista previa',
    personalInformation: 'Información personal',
    demographicsMedicalInfo: 'Datos demográficos e información médica',
    languagePreferenceRace: 'Preferencia de idioma y raza',
    addressInformation: 'Información de dirección',
    communicationPreferences: 'Preferencias de comunicación',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    createNewPassword: 'Crear nueva contraseña',
    createNewPasswordDescription: 'Asegúrate de que tu nueva contraseña sea segura y única',
    securityInfoTitle: 'Información importante de seguridad:',
    securityUseChars: 'Utiliza al menos 8 caracteres',
    securityUpperLower: 'Incluye letras mayúsculas y minúsculas',
    securityNumbers: 'Añade números y caracteres especiales',
    securityNoPersonal: 'No utilice información personal',
    securityNoReuse: 'No reutilice contraseñas anteriores',
    passwordStrengthTitle: 'Recomendación sobre la seguridad de la contraseña:',
    passwordMissing: 'Falta su contraseña:',
    passwordContinueHint:
      'Puede continuar con esta contraseña, pero le recomendamos que la refuerce para mayor seguridad.',
    strengthAtLeast8: 'Al menos 8 caracteres',
    strengthLowercase: 'Letras minúsculas',
    strengthUppercase: 'Letras mayúsculas',
    strengthNumbers: 'Números',
    strengthSpecialChars: 'Caracteres especiales',
    orderDetails: 'Detalles del pedido',
    providerInformation: 'Información del proveedor',
    treatmentDetails: 'Detalles del tratamiento',
    treatmentType: 'Tipo de tratamiento',
    slitLabel: 'SLIT',
    slitDescription: 'Inmunoterapia sublingual',
    scitLabel: 'SCIT',
    scitDescription: 'Inmunoterapia subcutánea',
    additionalClinicalInformation: 'Información clínica adicional',
    additionalInformation: 'Información adicional',
    patientInformation: 'Información del paciente',
    deliveryInformation: 'Información de entrega',
    expectedDeliveryDate: 'Fecha de entrega prevista',
    expectedDeliveryDateHint:
      'Se establece en la zona horaria de la cuenta, no en la de su ordenador.',
    contactInformation: 'Información de contacto',
    userInformation: 'Información del usuario:',
    currentAccount: 'Cuenta actual:',
    unknownAccount: 'Cuenta desconocida',
    criticalAction: 'Acción crítica:',
    criticalActionWarningDS:
      'El usuario será eliminado de forma permanente de todas las cuentas y perderá todo acceso.',
    criticalActionWarning:
      'El usuario será eliminado permanentemente de esta cuenta y perderá todo acceso.',
    irreversibleAction: 'Acción irreversible:',
    deleteUserConfirmDS: 'será eliminado permanentemente de',
    deleteUserConfirmDSEnd: 'y ya no aparecerá en ninguna lista de usuarios.',
    deleteUserConfirm:
      'será eliminado permanentemente de esta cuenta y ya no aparecerá en la lista de usuarios.',
    deleteUserTypeInstruction: 'Para continuar, escribe',
    deleteUserTypeInstructionEnd: 'en el campo de abajo para confirmar la autorización.',
    typeDeleteToConfirm: 'Escriba "delete" para confirmar',
    pleaseTypeDeleteExactly: 'Por favor, escriba "delete" exactamente',
    userDeletedSuccess: 'ha sido eliminado correctamente de todas las cuentas.',
    moreAccounts: 'más',
    // Create User wizard
    optional: 'opcional',
    providerTitle: 'Título del proveedor',
    providerNPINumber: 'Número NPI del proveedor',
    providerNpiExactDigits: 'El número NPI debe tener exactamente 10 dígitos.',
    requiresPermission: 'Requiere "{{name}}"',
    programsPermissionAppliesWhereOn:
      'Solo se aplica a las cuentas con el módulo de Programas activado.',
    providerDescription: 'Rol clínico con acceso a registros de pacientes.',
    assistantDescription: 'Rol operativo sin acceso clínico.',
    importFromAccount: 'Importar de existente',
    importFromAccountPlaceholder: 'Importar rol y permisos de una cuenta existente…',
  },
  tables: {
    program: 'Programa',
    // Matches the payer cell ("Desconocida") — today the only lookup
    // that emits the `__unknown__` sentinel is the insurance one.
    unknownValue: 'Desconocida',
    desc: 'DESC',
    asc: 'ASC',
    sortedBy: 'Ordenado por: ',
    filteredBy: 'Filtrado por: ',
    noFilters: 'Ninguno',
    activeFilters: 'Filtros activos',
    noActiveFilters: 'No hay filtros aplicados',
    removeFilter: 'Quitar filtro',
    recentFilters: 'Recientes',
    sortTableBy: 'Ordenar tabla por:',
    sort: 'Ordenar',
    programName: 'Nombre del programa',
    alertTags: 'Etiquetas de alerta',
    criticalCategory: 'Categoría crítica',
    alertName: 'Nombre de la alerta',
    acknowledged: 'Confirmada',
    pendingAcknowledgment: 'Pendiente de confirmación',
    critical: 'Crítica',
    description: 'Descripción',
    dateTriggered: 'Fecha de activación',
    nonCritical: 'No crítico',
    'monitor&support': 'Monitorización y soporte',
    name: 'Nombre',
    providerAssignment: 'Asignación de proveedor',
    uploadFailureReason: 'Motivo del fallo',
    documentUploadTimestamp: 'Fecha de la actividad',
    documentType: 'Tipo de documento',
    documentTypeAssessment: 'Evaluación',
    // Left in English, as every other E-Visit string in this file is.
    documentTypeProgramReport: 'E-Visit',
    documentTypeCounselingReport: 'Informe de asesoramiento',
    documentStatus: 'Estado de carga',
    botIntegration: 'Bot',
    uploadTimestamp: 'Fecha de carga',
    failureReason: 'Motivo del fallo',
    botUploadStatus: 'Estado de carga del bot',
    eVisitFailureReason: 'Motivo del fallo de E-Visit',
    eVisitUploadStatus: 'Estado de carga de E-Visit',
    eVisitUploadTimestamp: 'Fecha de carga de E-Visit',
    hasClaim: 'Tiene reclamación',
    hasProgram: 'Tiene programa',
    hasIntellyChart: 'Tiene Preventive Health Counseling',
    instant: 'Instantáneo',
    price: 'Precio',
    remove: 'Eliminar',
    surveyTags: 'Etiquetas de evaluación',
    entityNameAlert: 'Fuente de la alerta',
    entityType: 'Fuente de la entidad',
    TotalCount: 'Recuento total',
    viewedBy: 'Visto por',
    acknowledgeStatus: 'Estado de confirmación',
    acknowledgedBy: 'Confirmado por',
    alertType: 'Tipo de alerta',
    crisisTriggered: 'Activado',
    crisisTriggeredYes: 'Sí',
    crisisTriggeredNo: 'No',
    viewedTimestamp: 'Fecha de visualización',
    acknowledgedTimestamp: 'Fecha de confirmación',
    createdTimestamp: 'Creado',
    preFilter: 'Prefiltro',
    preFilterHint:
      "Seleccione 'Todo' para ver todas las opciones de esta columna. Para aplicar un prefiltro basado en otros filtros de columna que hayas configurado, selecciona 'Prefiltro'.",
    selectedOptions: 'Opciones seleccionadas:',
    availableOptions: 'Opciones disponibles',
    filterMode: 'Modo de filtro',
    includeGroup: 'Incluir',
    excludeGroup: 'Excluir',
    excludePrefix: 'excepto',
    howFilteringWorks: 'Cómo se combina este filtro',
    filterRuleExplainer:
      'Primero se buscan los valores incluidos y luego se quitan de ese conjunto los excluidos. Si no hay nada incluido, una exclusión significa todos los valores excepto esos. Las filas sin valor se conservan.',
    conflictEmpty:
      'está en ambas listas, así que las dos reglas se anulan y la tabla quedará vacía.',
    conflictPartial:
      'está en ambas listas y quedará fuera; los demás valores incluidos siguen mostrándose.',
    allOptions: 'Todas las opciones',
    uncheckAllOptions: 'Desmarcar todas las opciones',
    noAvailableOptions: 'No hay opciones disponibles.',
    noSelectedOptions: 'No hay opciones seleccionadas.',
    addSomeTextToSearch:
      'Empieza a escribir el nombre en el campo de búsqueda para ver las opciones.',
    cptCount: 'Recuento de CPT',
    cptPaid: 'Recuento de CPT pagados',
    NotBillable: 'No facturable',
    TotalBilledAmount: 'Importe total facturado',
    TotalPaidAmount: 'Importe total pagado',
    TotalPRAmount: 'Importe total de relaciones públicas',
    TotalDeniedAmount: 'Importe total denegado',
    AccountsCount: 'Número de cuentas',
    TotalOutstandingAmount: 'Importe total pendiente',
    TotalPartiallyPaidAmount: 'Importe total pagado parcialmente',
    TotalNotBillableAmount: 'Importe total no facturable',
    TotalNotBilledAmount: 'Importe total no facturado',
    assessmentResource: 'Evaluación/Recurso',
    entityName: 'Evaluación/Recurso',
    entityCompletedTimestamp: 'Fecha de finalización',
    customId: 'ID personalizado',
    accountCustomIdentifier: 'ID personalizado',
    claimReportGeneratedTimestamp: 'Fecha de generación del informe de reclamación',
    reportableGeneratedTimestamp: 'Fecha de generación del informe',
    totalAmount: 'Importe total',
    totalCount: 'Recuento total',
    uniqueAccounts: 'Cuentas únicas',
    totalPaidAmount: 'Importe total reportado',
    totalUnpaidAmount: 'Importe total reportable',
    ViewedCount: 'Recuento de visitas',
    NotViewedCount: 'Recuento de visitas no realizadas',
    PatientsCount: 'Número de pacientes',
    EngagedCount: 'Número de recursos asignados',
    EngageRate: 'Índice de asignación de recursos',
    totalCPTs: 'Total de CPT',
    generateClaimReport: 'Generar informe de reclamaciones',
    accessGranted: 'Acceso concedido',
    mrnNumber: 'Número MRN del paciente',
    patientGender: 'Sexo',
    female: 'Mujer',
    male: 'Hombre',
    patientMrnNumber: 'Número MRN del paciente',
    createdBy: 'Creado por',
    type: 'Tipo',
    manuallyCreated: 'Creado manualmente',
    integration: 'Integración',
    automated: 'Automatizado',
    createdByAthena: 'Athena',
    automation: 'Automatización',
    invitedTimestamp: 'Fecha de invitación',
    appointmentTimestamp: 'Fecha de la cita',
    engagedTimestamp: 'Fecha de participación',
    firstName: 'Nombre',
    lastName: 'Apellido',
    address: 'Dirección',
    more: 'Más',
    roles: 'Roles',
    account: 'Cuenta',
    accountBusinessName: 'Cuenta',
    accountName: 'Nombre de la cuenta',
    numberOfClaimCPTLineItems: 'N.º de partidas CPT de la reclamación',
    assessment: 'Evaluación',
    patientName: 'Nombre del paciente',
    patientFirstName: 'Nombre del paciente',
    patientLastName: 'Apellidos del paciente',
    orderTimestamp: 'Fecha de la solicitud',
    resource: 'Recurso',
    patientDOB: 'Fecha de nacimiento del paciente',
    patientDateOfBirth: 'Fecha de nacimiento del paciente',
    orderType: 'Tipo de pedido',
    orderFormula: 'Fórmula del pedido',
    orderDate: 'Fecha del pedido',
    success: 'Éxito',
    error: 'Error',
    customTags: 'Etiquetas personalizadas',
    patientCustomTags: 'Etiquetas personalizadas del paciente',
    accountCustomTags: 'Etiquetas personalizadas de la cuenta',
    helpRequested: 'Ayuda solicitada',
    reviewed: 'Revisado',
    claimGeneratedTimestamp: 'Fecha de generación de la reclamación',
    entityOrderTimestamp: 'Fecha de la orden',
    cptCode: 'Código CPT',
    allowed: 'Permitido',
    pr: 'PR',
    modifier: 'Modificador',
    icd: 'ICD',
    dos: 'DOS',
    prType: 'Tipo de PR',
    cptStatus: 'Estado CPT',
    reportStatus: 'Estado del informe',
    expectedDeliveryDate: 'Fecha de entrega prevista',
    status: 'Estado',
    encounterStatus: 'Estado de la consulta',
    paymentDate: 'Fecha de pago',
    lastModifiedTimestamp: 'Fecha de modificación',
    modifiedBy: 'Modificado por',
    billingStatus: 'Estado de facturación',
    claimStatus: 'Estado de la reclamación',
    appointmentDate: 'Fecha de la cita',
    claimReportStatus: 'Estado del informe de reclamación',
    filter: 'filtro',
    placeholder: 'marcador de posición',
    date: 'Fecha',
    all: 'Todo',
    pending: 'Pendiente',
    reportable: 'Notificable',
    icdIssue: 'Problema de CIE',
    insuranceIssue: 'Problema de seguro',
    appointmentCancelled: 'Cita Cancelada',
    appointmentTypeIssue: 'Problema con el tipo de cita',
    hold: 'En espera',
    readyToBill: 'Listo para facturación',
    reported: 'Notificado',
    onHold: 'En espera',
    processing: 'En proceso',
    sending: 'Enviando',
    delayed: 'Retrasado',
    shipped: 'Enviado',
    putOnHold: 'En espera',
    revertToPending: 'Revertir a pendiente',
    processManually: 'Procesar manualmente',
    cancel: 'Cancelar',
    sendToPharmacy: 'Enviar a farmacia',
    delay: 'Retraso',
    ship: 'Enviar',
    canceled: 'Cancelado',
    compounding: 'Preparación',
    dateOfBirth: 'Fecha de nacimiento',
    mmddyyyy: 'MM/DD/AAAA',
    mm: 'MM',
    dd: 'DD',
    yyyy: 'YYYY',
    claimReportHistory: 'Historial de informes de reclamaciones',
    reportableHistory: 'Historial de notificaciones',
    ordersHistory: 'Historial de pedidos',
    claimsHistory: 'Historial de reclamaciones',
    assessmentsHistory: 'Historial de evaluaciones',
    programsHistory: 'Historial de programas',
    resourcesHistory: 'Historial de recursos',
    assessmentsAlerts: 'Alertas de evaluación',
    healthSeekingBehavior: 'Comportamiento de búsqueda de ayuda',
    items: '{{totalCount}} elementos',
    searchCustomers: 'Buscar clientes',
    pendingReview: 'Pendiente de revisión',
    partialProcessed: 'Procesado parcialmente',
    eTransfer: 'Transferencia electrónica',
    noShow: 'No se presentó',
    noShowStatus: 'Estado del paciente',
    declined: 'Rechazado',
    notUpdated: 'No actualizado',
    none: 'Ninguno',
    invited: 'Invitado',
    staled: 'Abierto',
    instantCreated: 'Instantánea creada',
    inProgress: 'En curso',
    created: 'Creado',
    scheduled: 'Programado',
    engaged: 'Activo',
    completed: 'Completado',
    billingHistory: 'Historial de facturación',
    completionRate: 'Índice de finalización',
    noShowRate: 'Índice de ausencias',
    declinedRate: 'Índice de rechazos',
    noShowAndDeclinedRate: 'Índice de ausencias + rechazos',
    totalAccountsCount: 'Recuento total de cuentas',
    AverageDaysToPayment: 'Días medios hasta el pago',
    AverageUnpaidAging: 'Antigüedad media de impagos',
    performanceRate: 'Índice de rendimiento',
    assessmentName: 'Nombre de la evaluación',
    procedureName: 'Nombre del procedimiento',
    completedTimestamp: 'Fecha de finalización',
    orderedTimestamp: 'Fecha de solicitud',
    providerFirstName: 'Nombre del proveedor',
    providerLastName: 'Apellido del proveedor',
    reviewedTimestamp: 'Fecha de revisión',
    draft: 'Borrador',
    notCreated: 'No creado',
    billed: 'Facturado',
    inProcess: 'En proceso',
    paid: 'Pagado',
    denied: 'Denegado',
    resubmitted: 'Reenviado',
    notBillable: 'No facturable',
    isp: 'ISP',
    license: 'Licencia',
    control: 'Control',
    experimental: 'Experimental',
    imminentRisk: 'Riesgo inminente',
    helpSeekingBehavior: 'Comportamiento de búsqueda de ayuda',
    AllergyTest: 'Prueba de alergia',
    HomeSleepStudy: 'Estudio del sueño en el hogar',
    MentalHealth: 'Salud mental',
    PainManagement: 'Tratamiento del dolor',
    SleepQuality: 'Calidad del sueño',
    LifestyleImprovement: 'Mejora del estilo de vida',
    MentalHealthHelpRequested: 'Ayuda solicitada para la salud mental',
    SleepHelpRequested: 'Ayuda solicitada para el sueño',
    SleepStudyRequested: 'Estudio del sueño solicitado',
    PainManagementHelpRequested: 'Ayuda solicitada para el manejo del dolor',
    AllergyTestRequested: 'Prueba de alergia solicitada',
    InterestedinImmunotherapy: 'Interés en la inmunoterapia',
    LifestyleHelpRequested: 'Ayuda solicitada para el estilo de vida',
    BHIConsent: 'Consentimiento BHI',
    RiskFactorsIdentified: 'Factores de riesgo identificados',
    QNEGPositive: 'Q-NEG positivo',
    Depressionriskdetected: 'Riesgo de depresión detectado',
    Anxietyriskdetected: 'Riesgo de ansiedad detectado',
    PersistentPain: 'Dolor persistente',
    SignificantPhysicalLimitations: 'Limitaciones físicas significativas',
    ElevatedAllergyScore: 'Puntuación de alergia elevada',
    HighSleepDisorderRisk: 'Alto riesgo de trastornos del sueño',
    SuicideRisk: 'Riesgo de suicidio',
    SuicideorSelfHarmRisk: 'Riesgo de suicidio o autolesión',
    Psychologicaldistressnoactivesuicidalideation:
      'Malestar psicológico, sin ideas suicidas activas',
    SDoHRisk: 'Riesgo de SDoH',
    PersonalSafetyRisk: 'Riesgo para la seguridad personal',
    PreventiveScreeningRequired: 'Se requiere cribado preventivo',
    CheckA1C: 'Comprobar A1C',
    Fallrisk: 'Riesgo de caídas',
    ordersOnly: 'Solo pedidos',
    trial: 'Prueba',
    demo: 'Demostración',
    other: 'Otros',
    active: 'Activo',
    inactive: 'Inactivo',
    bhiStatus: 'Estado BHI',
    Billed: 'Facturado',
    NotBilled: 'No facturado',
    Paid: 'Pagado',
    PR: 'PR',
    Denied: 'Denegado',
    Outstanding: 'Pendiente',
    PartiallyPaid: 'Pagado parcialmente',
    partiallyPaid: 'Pagado parcialmente',
    multiLineActionMode: 'Modo de acción multilínea',
    regularMode: 'Modo normal',
    patientResponsibility: 'Responsabilidad del paciente',
    refreshData: 'Actualizar datos',
    generateReport: 'Generar informe',
    filterSettings: 'Configuración de filtro',
    showFilters: 'Mostrar filtros',
    resetAllFilters: 'Restablecer todos los filtros',
    unpinAll: 'Desanclar todo',
    chageStatus: 'Cambiar el estado de todas las filas de una tabla',
    miltiAction: 'Acciones en todas las filas de una tabla',
    miltiActionAllData: 'El cambio de estado se realizará en todas las filas de la tabla a la vez.',
    miltiActionFilteredData:
      'El cambio de estado se realizará inmediatamente en todas las filas de la tabla que correspondan a los filtros especificados.',
    downloadOrderReports: 'Descargar informes de pedidos',
    downloadFileByFilters: 'Descargar archivo',
    downloadCSVFile: 'Descargar archivo CSV',
    downloadFileFilteredData:
      'El archivo se generará a partir de los datos de la tabla correspondientes a los filtros seleccionados y a las columnas visibles.',
    downloadFileAllData: 'El archivo se generará a partir de todos los datos de la tabla.',
    numbersOfRows: 'Número de elementos.',
    multiLineActions: 'Acciones en varias filas',
    totalNumberOfSelected: 'Número total de elementos seleccionados',
    acknowledgeDescription:
      'Se cambiará el estado de todos los valores de la tabla que correspondan a los filtros especificados.',
    changeAcknowledgeStatus: 'Cambiar el estado a "confirmado" para todas las filas',
    changeStatus: 'Cambiar estado',
    changeDeliveryDate: 'Cambiar la fecha de entrega prevista',
    deliveryDateActionAllData:
      'La fecha de entrega prevista se cambiará en todas las filas de la tabla a la vez.',
    deliveryDateActionFilteredData:
      'La fecha de entrega prevista se cambiará inmediatamente en todas las filas de la tabla que correspondan a los filtros especificados.',
    deliveryDateModePick: 'Elegir una fecha',
    deliveryDateModeReset: 'Restablecer al valor predeterminado',
    deliveryDateDefaultCalculation: 'Cálculo predeterminado',
    deliveryDateCanceledHint:
      'Los pedidos cancelados no admiten una nueva fecha de entrega prevista. Si la tabla contiene alguno, se rechaza todo el cambio.',
    change: 'Cambiar',
    noRecordsToDisplay: 'No hay registros que mostrar',
    unableToLoadData: 'No se pueden cargar los datos',
    failedToLoadData: 'Error al cargar los datos',
    unexpectedServerError: 'Se ha producido un error inesperado del servidor',
    patientEngagement: 'Estado',
  },
  placeholders: {
    noColumnsSelected: 'No se ha seleccionado ninguna columna',
    noItemsFound: 'No se ha encontrado ningún {{item}}',
    noFilteredItemsFound:
      '{{item}} no ha sido autorizado. \n' +
      'Póngase en contacto con QHSLab en el 800-393-8817 para habilitar {{item}} en esta cuenta.',
    reviseFiltersOrCreateYourFirstItem: 'Revise los filtros o cree su primer {{item}}.',
    selectAtLeastOneColumn: 'Seleccione al menos una columna para mostrar la tabla.',
    pleaseChangeSearchText: 'Cambie el texto de búsqueda',
    noCPTCodes: 'No hay códigos CPT',
    addCPTCodes: 'Añada un código CPT con el botón {{item}} de abajo',
  },
  validationErrors: {
    required: 'campo obligatorio',
    matchPasswords: 'las contraseñas deben coincidir',
    invalid: '{{name}} no es válido',
    minError: '{{name}} debe tener al menos {{length}} caracteres',
    maxError: '{{name}} debe tener un máximo de {{length}} caracteres',
    lessThan30days:
      'La fecha de servicio (DOS) no puede ser anterior a 30 días antes de la {{date}} (fecha de la cita)',
    moreThan30days:
      'La fecha de servicio (DOS) no puede ser posterior a 30 días después de la {{date}} (fecha de la cita)',
    requiredField: '{{fieldName}} es un campo obligatorio.',
    CPTCodeRequired: 'El código CPT es un campo obligatorio.',
    claimSumValueLimits: 'El valor no debe ser inferior a 0 ni superior a 5000 $.',
    PRTypeRequired: 'El tipo de PR es un campo obligatorio si PR > 0.',
    claimStatusMustBeEqual:
      'El estado de la reclamación debe ser "Pendiente" si el estado de facturación es "Pendiente" o "En espera".',
    dataIsInvalid: 'Los datos no son válidos.',
    newPasswordRequired: 'Se requiere una nueva contraseña',
    confirmPasswordRequired: 'Confirme su nueva contraseña',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
  },
  errors: {
    loadingError:
      '   Vaya, parece que se ha producido un error al cargar los datos. Comprueba el enlace o intenta cargarlo de nuevo.',
    doNotHaveAccessToAnyAccounts:
      'No tienes acceso a ninguna cuenta en el panel de control de QHS. Si crees que se trata de un error, ponte en contacto con el administrador de tu cuenta de QHS.',
    unknownError: 'No se puede completar tu solicitud debido a un error desconocido.',
    userNotFound:
      'No hemos podido encontrar ninguna cuenta para la dirección de correo electrónico que ha proporcionado.',
    accountIsDisabled:
      'La cuenta está desactivada. \nPóngase en contacto con el servicio de asistencia en el 1-800-393-8817.',
    credentialsInvalid:
      'La dirección de correo electrónico o la contraseña que ha introducido no son válidas.',
    specifiedCondition: 'No se cumple la condición especificada para "status".',
    validationError:
      'Algunos datos introducidos parecen no ser válidos. Corrija los errores indicados en rojo e inténtelo de nuevo.',
    pleaseEnterDescription:
      'Introduzca una descripción del problema que está experimentando. No elimine el contenido que aparece debajo de la línea siguiente',
    supportRequest: 'Solicitud de asistencia de QHS',
    invalidData: 'Datos no válidos',
    noProvidersOnThisAccount:
      'No hay proveedores en esta cuenta. Se requiere al menos un proveedor para crear un pedido.',
    noLongerValid: 'Esta invitación ya no es válida.',
    accountOrUser: 'No se ha encontrado la cuenta o el usuario.',
    orderCouldNotFind:
      'No se ha podido encontrar la cuenta especificada o {{name}}. Actualice la página e inténtelo de nuevo.',
    metadataLoadingError: 'Error al cargar los datos',
    metadataLoadingErrorDescription:
      'Lamentablemente, no hemos podido cargar los datos necesarios para crear un pedido. Intenta actualizar la página.',
    refreshPage: 'Actualizar página',
    orderCantBeRemoved: 'El pedido no se puede eliminar, ya que ya no tiene el estado "Pendiente".',
    orderStatusMultiplyValidation: `El estado que está intentando cambiar para uno o más {{name}}s no está
        permitido. Compruebe los {{name}}s e inténtelo de nuevo.`,
    orderStatusSingleValidation:
      'El estado que ha seleccionado no está permitido según el estado actual del {{name}}.',
    patientCouldNotFind:
      'No se ha podido encontrar la cuenta o el paciente especificado. Actualice la página e inténtelo de nuevo.',
    patientCantBeRemoved: 'No se puede eliminar el paciente {{name}}.',
    userCouldNotFind:
      'No se ha podido encontrar el usuario especificado. Actualice la página e inténtelo de nuevo.',
    userCantBeRemoved: 'El perfil de usuario de {{name}} no se puede eliminar de esta cuenta.',
    accountCouldNotFind:
      'No se ha encontrado la cuenta especificada. Actualiza la página e inténtalo de nuevo.',
    accountCantBeRemoved: 'No se puede eliminar la cuenta {{name}}.',
    userProfileNotFound:
      'No se ha encontrado ningún perfil de usuario para el correo electrónico especificado.',
    verificationCodeInvalid:
      'El código de verificación no es válido. Inténtalo de nuevo o envía un nuevo código de verificación.',
    tooManyInvitations:
      'Se han enviado demasiadas invitaciones en muy poco tiempo. Espera unos minutos e inténtalo de nuevo.',
    invitationCannotBeSent:
      'La invitación se ha enviado demasiado rápido para esta evaluación. Inténtalo de nuevo en un minuto o dos.',
    invitationMessageWasJustSent:
      'Se acaba de enviar el mensaje de invitación. Inténtalo de nuevo dentro de unos minutos.',
    invitationsWereNotOriginallySent:
      'No se enviaron invitaciones inicialmente para esta encuesta, por lo que no se permite reenviarlas.',
    dateRequiredToSend: 'Es obligatorio indicar la fecha de envío.',
    timeRequiredToSend: 'Es obligatorio indicar la hora de envío.',
    somethingWentWrong: 'Algo salió mal. Por favor, inténtelo de nuevo.',
    somethingWentWrongTitle: 'Algo salió mal',
    somethingWentWrongMessage: 'Inténtelo de nuevo o contacte con soporte si el problema persiste.',
    accountAccessCannotBeRemoved: 'No se puede eliminar el acceso a la cuenta.',
    failedToCreateSurvey: 'Error al crear la evaluación instantánea.',
    failedToUpdateSurvey: 'Error al actualizar la evaluación.',
  },
  feedback: {
    triggerTooltip: 'Enviar comentarios',
    dialogTitle: 'Enviar comentarios',
    dialogSubtitle: 'Comparta una mejora, informe un problema o cuéntenos qué no funciona.',
    categoryLabel: 'Categoría',
    categoryImprovement: 'Mejora',
    categoryIssue: 'Problema',
    categoryOther: 'Otro',
    messageLabel: 'Mensaje',
    placeholderImprovement: '¿Qué no funciona bien o podría ser más claro?',
    placeholderIssue: '¿Qué ocurrió y qué esperaba que ocurriera?',
    placeholderOther: 'Cuéntenos qué tiene en mente.',
    attachmentsLabel: 'Archivos adjuntos (opcional)',
    dropzoneTitle: 'Arrastre fotos o videos aquí, o haga clic para buscar',
    dropzoneHint: 'Hasta 5 archivos, 25 MB cada uno. PNG, JPG, MP4, MOV.',
    removeAttachment: 'Quitar',
    sendButton: 'Enviar comentarios',
    sendingButton: 'Enviando…',
    fileRejectedMime: '"{{name}}" no es una imagen ni un video.',
    fileRejectedSize: '"{{name}}" supera los 25 MB.',
    fileRejectedCount: 'Puede adjuntar como máximo 5 archivos.',
    fileRejectedTotalSize: 'El tamaño total de los adjuntos no puede superar los 50 MB.',
  },
  notifications: {
    acknowledgeStatusChanged: 'Confirmación del cambio de estado realizada correctamente',
    assessmentAccepted: 'Evaluación aceptada correctamente',
    checkYourForm:
      'Algunos campos contienen errores.\n' + 'Por favor, corrígelos antes de continuar.',
    autoLogout: 'Se ha cerrado tu sesión automáticamente debido a la inactividad',
    logout401: 'Tu sesión de QHSLab ha caducado. Inicie sesión de nuevo para continuar.',
    profileUpdated: 'Su perfil se ha actualizado correctamente.',
    accountCreated: 'Cuenta "{{name}}" creada correctamente.',
    accountEdited: 'Cuenta "{{name}}" editada correctamente.',
    claimEdited: 'Reclamación editada correctamente.',
    amountCapped: 'El importe no puede superar los ${{max}}. El valor se ha ajustado.',
    accountRemoved: 'La cuenta {{name}} ha sido eliminada.',
    userCreated: 'Usuario "{{name}}" creado correctamente.',
    userEdited: 'Usuario "{{name}}" editado correctamente.',
    userRemoved: 'El perfil de usuario de {{name}} ha sido eliminado', // de {{accountName}}.',
    patientCreated: 'Paciente "{{name}}" creado correctamente.',
    notPermissionForEditingClaim: 'No tienes permiso para editar la reclamación.',
    notPermissionForDownloadingFile: 'No tienes permiso para descargar el archivo.',
    surveyURLCopied: 'La URL de la evaluación se ha copiado en el portapapeles',
    dataCopied: 'Los datos se han copiado en el portapapeles',
    dataNotCopied: 'Los datos no se han copiado en el portapapeles',
    patientEdited: 'Paciente "{{name}}" editado correctamente.',
    patientEngagementPaused: 'El paciente "{{name}}" ha sido desactivado.',
    patientEngagementResumed: 'El paciente "{{name}}" ha sido reactivado.',
    claimEnabled: 'La reclamación se ha activado correctamente.',
    patientRemoved: 'Se ha eliminado al paciente "{{name}}".',
    dataIsInvalid: 'Los datos no son válidos.',
    pdfSucceededSaved: 'El archivo PDF se ha descargado correctamente.',
    noShowStatusSucceededChanged: 'El estado "No se presentó" se ha modificado correctamente.',
    noShowStatusSucceededReversed: 'El estado "No se presentó" se ha revertido correctamente.',
    declinedStatusSucceededChanged: 'El estado "Rechazado" se ha modificado correctamente.',
    declinedStatusSucceededReversed: 'El estado "Rechazado" se ha revertido correctamente.',
    fileSucceededSaved: 'El archivo {{format}} se ha descargado correctamente.',
    zipSucceededSaved: 'El archivo ZIP se ha descargado correctamente.',
    orderCreated: 'Pedido creado correctamente.',
    orderUpdated: 'Pedido actualizado correctamente.',
    resourceCreated: 'Recurso para "{{name}}" creado correctamente.',
    orderEdited: 'Pedido de "{{name}}" editado correctamente.',
    accountAccessRemoved: 'Acceso a la cuenta eliminado correctamente.',
    accountChangesSaved: 'Cambios de la cuenta guardados correctamente.',
    accountChangesSavedNextSignIn:
      'Cambios de la cuenta guardados. Los cambios de permisos surten efecto en el siguiente inicio de sesión del usuario.',
    userUpdated: 'Usuario actualizado correctamente.',
    instantSurveyCreated: 'Evaluación instantánea creada correctamente.',
    surveyUpdated: 'Evaluación actualizada correctamente.',
    orderRemoved: 'El pedido ha sido eliminado.',
    orderStatusChanged: 'El estado de "{{name}}" se ha cambiado correctamente.',
    orderDeliveryDateChanged: 'La fecha de entrega prevista se ha cambiado correctamente.',
    orderDeliveryDateReset:
      'La fecha de entrega prevista se ha restablecido al cálculo predeterminado.',
    verifyCodeHasBeenSent: 'Se ha enviado el código de verificación.',
    passwordHasBeenChanged: 'Se ha cambiado la contraseña.',
    addProvider: 'Añade al menos un proveedor a la cuenta antes de crear pedidos.',
    youHaveBeenSwitched: `Se te ha cambiado automáticamente a la cuenta {{name}}`,
    welcomeToQHS: 'Se ha establecido tu contraseña. ¡Bienvenido a QHS!',
    emailInvitation: 'Se ha enviado otra invitación por correo electrónico.',
    assessmentCreated: 'Evaluación creada',
    assessmentMustBeCompleted: 'El paciente debe completar la evaluación antes de ver el informe',
    invitationResent: 'Invitación reenviada correctamente',
    copyToClipboard: 'El texto se ha copiado correctamente al portapapeles',
    notPermissionForDeletingOrder:
      '¡Vaya! Lo sentimos, pero su capacidad para eliminar pedidos ha sido suspendida o aún no está habilitada en su cuenta. Póngase en contacto con el servicio de atención al cliente en el 1-800-393-8817 o envíenos un correo electrónico a services@qhslab.com para solicitar que se active esta función.',
    notPermissionForEditingOrder:
      '¡Vaya! Lo sentimos, pero su capacidad para editar pedidos ha sido suspendida o aún no está habilitada en su cuenta. Póngase en contacto con el servicio de atención al cliente en el 1-800-393-8817 o envíenos un correo electrónico a services@qhslab.com para solicitar que se active esta función.',
    notPermissionForStartingProgram: 'No tienes permiso para iniciar programas para este paciente.',
    notPermissionForCreatingOrder:
      '¡Vaya! Lo sentimos, pero su capacidad para crear pedidos ha sido suspendida o aún no está habilitada en su cuenta. Póngase en contacto con el servicio de atención al cliente en el 1-800-393-8817 o envíenos un correo electrónico a services@qhslab.com para solicitar que se active esta función.',
    notPermissionForCreatingProgram:
      '¡Vaya! Lo sentimos, pero la función para crear programas ha sido suspendida o aún no está habilitada en su cuenta. Póngase en contacto con el servicio de atención al cliente en el 1-800-393-8817 o envíenos un correo electrónico a services@qhslab.com para solicitar que se active esta función.',
    notPermissionForChangeClaimReportStatus:
      '¡Vaya! Lo sentimos, pero su capacidad para cambiar el estado del informe de reclamación ha sido suspendida o aún no está habilitada en su cuenta. Póngase en contacto con el servicio de atención al cliente en el 1-800-393-8817 o envíenos un correo electrónico a services@qhslab.com para solicitar que se active esta función.',
    notPermissionForCreatingAssessment:
      '¡Vaya! Lo sentimos, pero su capacidad para crear evaluaciones ha sido suspendida o aún no está habilitada en su cuenta. Póngase en contacto con el servicio de atención al cliente en el 1-800-393-8817 o envíenos un correo electrónico a services@qhslab.com para solicitar que se active esta función.',
    hasDrugAllergies:
      'Este paciente tiene actualmente alergias a medicamentos desconocidas. Actualice el historial del paciente para crear órdenes.',
    pleaseLogIn: 'Inicie sesión para ver el recurso solicitado',
    noPermissions: 'No tiene permiso para acceder a este recurso',
    accessRemoved: 'Acceso eliminado.',
    bulkSaveSucceeded: 'Ajustes aplicados a {{count}} cuentas.',
    bulkSavePartial: 'Aplicado a {{ok}} de {{total}} cuentas. Fallaron: {{names}}.',
    bulkSaveFailed: 'No se actualizó ninguna cuenta. Inténtelo de nuevo.',
    accountsAdded: '{{count}} cuenta(s) añadida(s).',
    accountsAddFailed: 'No se pudieron añadir las cuentas.',
    feedbackSent: 'Gracias. Sus comentarios se han enviado.',
    feedbackFailed: 'No se pudieron enviar sus comentarios. Inténtelo de nuevo.',
  },
  dialogs: {
    createUserFailedTitle: 'No se creó el usuario',
    backTo: 'Volver a {{title}}',
    canUseForSeveralAccounts:
      'Esta acción está disponible para las líneas que pertenecen a una sola cuenta. Establezca el filtro adecuado.',
    confirmRemove: 'Confirmar eliminación de {{name}}',
    confirmStatusChange: 'Confirmar cambio de estado',
    generateClaimsReport: 'Generar informe de reclamaciones',
    additionalOptions: 'Opciones adicionales',
    downloadXlsxFile: 'Descargar archivo XLSX (opcional)',
    confirmResend: 'Confirmar para enviar de todas formas',
    confirmResendInvitation: 'Confirmar reenvío de invitación',
    reportHasBeenGenerated:
      'Se ha generado el informe. Puede verlo/descargarlo desde la pantalla Informes de reclamaciones.',
    generateClaimsReportDescription1:
      'Se generará un informe de reclamaciones para los artículos que ha seleccionado. A continuación se muestra un resumen de los artículos de la reclamación. Para generar el informe, compruebe que todo está correcto y seleccione ',
    generateClaimsReportDescription2: 'Verificar y generar ',
    generateClaimsReportDescription3: 'a continuación.',
    statusDescriptionForOneOption: '¿Cambiar el estado a "{{status}}" para la fila actual?',
    statusDescription:
      '¿Cambiar el estado a "{{status}}" para todas las filas seleccionadas o solo para la fila actual?',
    prescriberDeclaration: 'Declaración del prescriptor',
    bySavingThisPrescription: `Al guardar esta receta, declaro que:`,
    requirementA: `a) Estoy tratando o he tratado a este paciente por el diagnóstico indicado en la
      fecha de vigencia de esta orden;`,
    requirementB: `b) Esta orden refleja con exactitud el diagnóstico y el estado de este paciente
      y está respaldada por mi historial médico;`,
    requirementC: `c) Incorporaré la copia original firmada de este documento al
      historial médico de este paciente y la pondré a disposición de Medicare, Medicaid y otras aseguradoras
      o cualquier agente autorizado si así se solicita.`,
    prescribingPhysician: 'el médico prescriptor ha aprobado el envío de esta orden a la farmacia',
    hipaaAgreement: 'Acuerdo de socio comercial de la HIPAA',
    hipaaAgreementFor: 'Acuerdo de socio comercial de la HIPAA para {{accountName}}',
    privacyFor: 'Política de privacidad para {{accountName}}',
    hippa_baa_For: 'Acuerdo de socio comercial de la HIPAA para {{accountName}}',
    termsFor: 'Términos y condiciones para {{accountName}}',
    scrollToTheBottom: 'Desplácese hasta el final para aceptar el acuerdo',
    readAndAccept: 'He leído y acepto el acuerdo',
    administratorMustAccept: `Un administrador debe aceptar el Acuerdo de socio comercial de la HIPAA
      antes de que se pueda acceder a la cuenta.`,
    sessionTimeout: 'Tiempo de espera de la sesión',
    inactivityWarning: `Se va a cerrar la sesión debido a inactividad. Elija entre permanecer
      conectado o cerrar sesión. De lo contrario, se cerrará la sesión automáticamente.`,
    autoLogoutIn: 'Cierre de sesión en {{seconds}} s',
    updateRequired: 'Actualización necesaria',
    mandatoryUpdateTitle: 'Se requiere actualizar para continuar',
    mandatoryUpdateSubtitle:
      'Esta versión del panel ya no es compatible. Vuelva a cargar para obtener la versión actual — tarda unos segundos.',
    mandatoryUpdateStillOld:
      'Sigue en la versión anterior. Su navegador puede estar usando una copia en caché — intente recargar otra vez o cierre y vuelva a abrir la pestaña.',
    mandatoryUpdateVersionLabel: 'Versión actual:',
    mandatoryUpdatePendingTitle: 'Actualización necesaria: guarde su trabajo primero',
    mandatoryUpdatePendingSubtitle:
      'Esta versión del panel ya no es compatible. Tiene cambios sin guardar, por lo que no se ha interrumpido nada: guárdelos o descártelos y la actualización continuará.',
    mandatoryUpdatePendingConfirm: 'Actualizar ahora y perder los cambios sin guardar',
    mandatoryUpdatePendingCancel: 'Guardaré primero',
    chooseProviders: 'Elegir proveedores',
    updateVersionSubtitle:
      'Hay una versión más reciente de este panel disponible. Para asegurarte de que no surjan problemas, haz clic en Actualizar a continuación para cargar la nueva versión.',
    updateNow: 'Actualizar ahora',
    skipNow: 'Omitir por ahora',
    // Create User wizard (v3 features/create-user)
    createUser: 'Crear usuario',
    stepDetails: 'Datos',
    stepAccounts: 'Cuentas',
    stepSettings: 'Configuración',
    checkingEmail: 'Comprobando disponibilidad del correo electrónico...',
    emailAvailable:
      'El correo electrónico está disponible. Haga clic en "Siguiente" para continuar.',
    userExistsInAccount: 'El usuario ya existe en su cuenta',
    userExistsInAccountDesc:
      'Este correo ya pertenece a un usuario en esta cuenta. Puede editarlo en su lugar.',
    userExistsInSystem: 'El usuario existe en nuestro sistema',
    userExistsInSystemDesc:
      'Puede agregarlo a su cuenta con el rol y los permisos que elija a continuación.',
    emailCheckFailed: 'No se pudo verificar el correo. Inténtelo de nuevo.',
    selectAccounts: 'Seleccionar cuentas',
    selectAccountsDesc:
      'Elija una o más cuentas a las que el usuario tendrá acceso. Puede ajustar los roles y permisos a continuación.',
    settingsTemplateHintSingle: 'Estos ajustes se aplicarán a la cuenta seleccionada.',
    settingsTemplateHintMany: 'Estos ajustes se aplicarán a todas las cuentas seleccionadas.',
    roleAndProvider: 'Rol y proveedor',
    permissions: 'Permisos',
    verifyEmailToContinue: 'Verifique el correo arriba para continuar',
    accountAccess: 'Acceso a cuentas',
    unsavedChanges: 'Cambios sin guardar',
    unsavedChangesPreview: 'Hay cambios sin guardar para "{{accountName}}":',
    bulkEditBanner: 'Editando {{count}} cuentas',
    applyToAccounts: 'Aplicar estos ajustes a todas las cuentas seleccionadas.',
    bulkAllowedAccountsHint: 'Las cuentas permitidas se pueden editar solo por cuenta.',
    removeAccountLastWarning:
      'Esta es la última cuenta del usuario. Eliminarla quitará al usuario del sistema por completo.',
    removeAccountWarning:
      'El usuario perderá el acceso a {{accountName}}. Su acceso a otras cuentas permanecerá.',
    addAccountsToUser: 'Añadir cuentas al usuario',
    addAccountsStep1Info:
      'Elige una o más cuentas a las que dar acceso al usuario. La configuración se aplicará de forma uniforme en el siguiente paso.',
    addAccountsStep2Info:
      'Configura el rol y los permisos que se aplicarán a todas las cuentas seleccionadas. Puedes ajustar cada cuenta después.',
    // Patient create flow (Session 12)
    stepNextSteps: 'Qué sigue',
  },
  scit: {
    buildUp46: 'Aumento de 46 dosis por unidad',
    buildUp50: 'Aumento de 50 dosis por unidad',
    stage1: 'Fase 1 de 10 dosis por unidad',
    stage2: 'Fase 2 de 10 dosis por unidad',
    stage3: 'Fase 3 de 10 dosis por unidad',
    stage4: '10 dosis/unidad, etapa 4',
    scitMaintenance: '12 dosis/unidad, mantenimiento SCIT',
  },
  slit: {
    oneMonthLowDose: '1 mes de dosis baja',
    oneMonthSLITMaintenance: '1 mes de mantenimiento con SLIT',
  },
  allergens: {
    allergySymptomsDescription: 'Enumerar los síntomas de la alergia',
    symptomsExposureDescription: 'Los síntomas suelen empeorar con la exposición a',
    symptomsTimeOfYearDescription: 'Los síntomas suelen aparecer en qué época del año',
    symptomsTimeInDayDescription: 'Los síntomas suelen aparecer a qué hora del día',
    symptomsMostlyOccurDescription: 'Los síntomas se presentan principalmente',
    examinationRevealsDescription: 'El examen revela lo siguiente',
    allergyDiagnosisDescription: 'Diagnóstico de alergia',
    allergySymptoms: 'Síntomas de alergia del paciente',
    symptomsExposure: 'Empeoran con la exposición a',
    symptomsTimeOfYear: 'Aparición estacional',
    symptomsTimeInDay: 'Hora de aparición diaria',
    symptomsMostlyOccur: 'Dónde se producen los síntomas',
    examinationReveals: 'Hallazgos del examen físico',
    allergyDiagnosis: 'Diagnóstico clínico',
    runnyOrStuffyNose: 'Nariz que gotea o tapada',
    sneezing: 'Estornudos',
    itchyNose: 'Picor de nariz',
    blockedNose: 'Nariz taponada',
    postNasalDripDrainage: 'Goteo nasal',
    mouthBreathingSnoring: 'Respiración bucal y ronquidos',
    frequentSniffling: 'Estornudos frecuentes',
    decreasedSmell: 'Disminución del olfato',
    headaches: 'Dolores de cabeza',
    facialPressurePain: 'Presión y dolor facial',
    redEyes: 'Ojos rojos',
    itchyEyes: 'Picor en los ojos',
    wateryEyes: 'Ojos llorosos',
    darkCircles: 'Ojeras',
    swollenDryEyes: 'Ojos secos e hinchados',
    soreEyes: 'Dolor en los ojos',
    rash: 'Erupción cutánea',
    hives: 'Ronchas',
    urticaria: 'Urticaria',
    eczema: 'Eccema',
    swelling: 'Hinchazón',
    itchySkin: 'Picor en la piel',
    wheezing: 'Sibilancias',
    coughing: 'Tos',
    chestTightness: 'Opresión en el pecho',
    shortnessOfBreath: 'Dificultad para respirar',
    chronicBronchitis: 'Bronquitis crónica',
    itchyThroat: 'Picor de garganta',
    throatClearing: 'Carraspeo',
    soreThroat: 'Dolor de garganta',
    excessivePhlegm: 'Exceso de flemas',
    hoarseness: 'Ronquera (voz débil, áspera o ronca)',
    grasses: 'Hierbas',
    otherPollen: 'Otro polen',
    otherAnimalsOrInsects: 'Otros animales o insectos',
    dust: 'Polvo',
    wind: 'Viento',
    perfume: 'Perfume',
    smokePollution: 'Humo / contaminación',
    cleaningProducts: 'Productos de limpieza',
    certainTypesOfFood: 'Ciertos tipos de alimentos',
    grassesGrassMix:
      'Mezcla de gramíneas (timoteo, orchard, junio, red top, festuca de prado, centeno perenne, venal dulce)',
    grassesBermuda: 'Bermuda',
    grassesJohnson: 'Johnson',
    weeds: 'Malas hierbas',
    weedsRagweed: 'Ambrosía (ambrosía corta, ambrosía gigante/alta, artemisa)',
    weedsMugwort: 'Artemisa',
    weedsCocklbur: 'Cocklbur',
    weedsRoughMarshelder: 'Marshelder áspero',
    weedsPigweed: 'Amaranto (amaranto áspero, hierba descuidada, cáñamo acuático occidental)',
    weedsDockSorrell: 'Acedera de agua (accedera amarilla, acedera de oveja)',
    weedsChenopod: 'Chenopodio (kochia, cardo ruso, bledo)',
    weedsEnglishPlaintain: 'Plátano inglés',
    trees: 'Árboles',
    treesBirch: 'Abedul (abedul, aliso, avellano)',
    treesCypress: 'Ciprés (enebro, cedro, ciprés)',
    treesOlive: 'Olivo (olivo, fresno, aligustre)',
    treesBeechOak: 'Haya-Roble (Haya, Roble, Castaño)',
    treesPecanHickory: 'Pacana-Hickory',
    treesPolarAspenCottonwood: 'Álamo-Álamo temblón-Álamo americano',
    treesMapleElder: 'Arce-Saúco',
    treesSycamore: 'sicómoro',
    treesElm: 'olmo',
    cat: 'gato',
    dog: 'perro',
    dustMites: 'ácaros del polvo',
    cockroach: 'cucaracha',
    mold: 'moho',
    allYearRound: 'Todo el año',
    spring: 'Primavera',
    summer: 'Verano',
    fall: 'Otoño',
    winter: 'Invierno',
    theyJustStarted: 'Acaban de empezar',
    atNight: 'Por la noche',
    duringTheDay: 'Durante el día',
    bothNightAndDay: 'Tanto de noche como de día',
    indoor: 'En el interior',
    outdoor: 'Al aire libre',
    bothIndoorAndOutdoor: 'Tanto en el interior como al aire libre',
    allergicRhinitis: 'Rinitis alérgica',
    asthma: 'Asma',
    allergicConjunctivitis: 'Conjuntivitis alérgica',
    atopicDermatitis: 'Dermatitis atópica',

    nasalAndSinusFindings: 'Hallazgos nasales y sinusales:',
    rhinorrhea: 'Rinorrea – Goteo nasal',
    nasalCongestion: 'Congestión nasal – Nariz taponada',
    turbinateHypertrophy:
      'Hipertrofia de los cornetes – Aumento del tamaño de los cornetes nasales',
    septalDeviation: 'Desviación del tabique – Desviación del tabique nasal',
    postnasalDrip: 'Goteo posnasal – Secreción mucosa visible en la parte posterior de la faringe',
    mouthBreathing: 'Respiración bucal – Observada durante la respiración',
    anosmiaOrHyposmia: 'Anosmia o hiposmia – Pérdida o disminución del sentido del olfato',
    sinusTenderness:
      'Sensibilidad en los senos paranasales – Dolor a la palpación de los senos paranasales',
    facialErythemaOrSwelling:
      'Eritema o hinchazón facial – Inflamación alrededor de los senos paranasales',
    boggyNasalMucosa:
      'Mucosa nasal edematosa – Mucosa hinchada indicativa de alergias o inflamación',
    eyeFindings: 'Hallazgos oculares:',
    conjunctivalInjection: 'Inyección conjuntival – Ojos rojos',
    periorbitalEdema: 'Edema periorbital – Hinchazón alrededor de los ojos',
    darkCirclesUnderEyes: 'Ojeras (ojeras alérgicas)',
    conjunctivalChemosis: 'Quemosis conjuntival – Hinchazón de la conjuntiva',
    blepharitis: 'Blefaritis – Inflamación de los párpados',
    wateryEyesExcessiveLacrimation: 'Ojos llorosos – Lacrimación excesiva',
    allergicConjunctivitisItchy: 'Conjuntivitis alérgica – Picazón, enrojecimiento y ojos llorosos',
    dermatologicalFindings: 'Hallazgos dermatológicos:',
    erythematousRash: 'Erupción eritematosa – Erupción cutánea roja',
    urticaria: 'Urticaria',
    lichenifiedPlaques: 'Placas liquenificadas – Se observan en el eccema crónico',
    xerosis: ' Xerosis – Piel seca',
    angioedema: 'Angioedema – Hinchazón de los tejidos subcutáneos',
    pruritus: 'Prurito – Picor generalizado de la piel',
    respiratoryFindings: 'Hallazgos respiratorios:',
    wheezingHighPitched: ' Sibilancias: sonidos agudos similares a silbidos en la auscultación',
    prolongedExpiratoryPhase:
      'Fase espiratoria prolongada: se observa en el asma o en enfermedades obstructivas de las vías respiratorias',
    cracklesOrRales:
      'Crepitaciones o estertores: sonidos finos o gruesos en la auscultación (si coexisten otras afecciones)',
    rhonchi: 'Roncos: sonidos graves debidos a la congestión de las vías respiratorias',
    decreasedBreathSounds:
      'Disminución de los ruidos respiratorios: indicativo de obstrucción de las vías respiratorias o hiperinflación',
    coughingProductive: 'Tos: productiva o no productiva, audible durante la exploración',
    barrelChest: 'Tórax en barril: hallazgo físico relacionado con la bronquitis crónica',
    intercostalRetractions:
      'Retracciones intercostales: se observan en casos de dificultad respiratoria grave',
    throatFindings: 'Hallazgos en la garganta:',
    pharyngealErythema: 'Eritema faríngeo: enrojecimiento de la garganta',
    cobblestoningOfThePosteriorPharynx:
      'Aspecto de adoquín de la faringe posterior: engrosamiento de la mucosa debido al goteo posnasal',
    hoarsenessObserved: 'Ronquera: observada durante la conversación o la fonación',
    tonsillarHypertrophy: 'Hipertrofia amigdalar: amígdalas agrandadas',
    lymphadenopathy: 'Linfadenopatía – Ganglios linfáticos agrandados, típicamente cervicales',
    throatClearingObserved: 'Carraspeo – Hábito observado durante la exploración',
  },
  formulas: {
    outdoor: 'Exterior',
    indoor2: 'Interior 2',
    indoor3: 'Interior 3',
    indoor4: 'Interior 4',
    mold: 'Moho',
    environment: 'Entorno',
  },
  ordersCsv: {
    organization: 'Organización',
    firstName: 'Nombre',
    lastName: 'Apellidos',
    dob: 'Fecha de nacimiento',
    gender: 'Sexo',
    allergies: 'Alergias',
    patientPhone: 'Teléfono del paciente',
    patientAddress: 'Dirección del paciente',
    clinician: 'Médico',
    npi: 'NPI',
    shipTo: 'Destinatario',
    accountCustomIdentifier: 'Identificador personalizado',
    category: 'Categoría',
    type: 'Tipo',
    formula: 'Fórmula',
    qty: 'Cantidad',
    geography: 'Ubicación',
    date: 'Fecha',
    expectedDeliveryDate: 'Fecha de entrega prevista',
    comments: 'Comentarios',
  },
  allergyBaselineAssessmentReport: {
    title: 'Informe de evaluación inicial de alergias',
    firstPart:
      "La 'Evaluación de alergias' de QHSLab es una herramienta de medicina digital patentada, desarrollada para ayudar a los médicos a identificar y tratar afecciones alérgicas comunes, los alérgenos desencadenantes, la gravedad de los síntomas, el uso y la frecuencia de la medicación, así como los hábitos de salud. La Evaluación de alergias se ajusta a la definición para el uso del código CPT 96160, 'Administración de un instrumento de evaluación de riesgos para la salud centrado en el paciente (p. ej., evaluación de riesgos para la salud) con puntuación y documentación, según un instrumento estandarizado",
    requirementsFirst: 'Los requisitos para informar del código 96160 son los siguientes:',
    requirementsSecond:
      'Se incurre en gastos de consulta para administrar el instrumento (como el tiempo de la enfermera o la compra del cuestionario).\n' +
      'El instrumento está estandarizado.\n' +
      'El instrumento es puntuable.\n' +
      'Los resultados se documentan en la historia clínica.',
    requirementsThird:
      'El término "estandarizado" se refiere a pruebas previamente validadas que se administran y puntúan de manera coherente o "estándar".',
    requirementsForth:
      '¿Qué constituye la "puntuación"? Esta es una distinción importante entre una verdadera evaluación de riesgos para la salud y los formularios de recopilación de antecedentes. El instrumento, como mínimo, debe proporcionar un resultado umbral o respuestas pertinentes de sí/no que indiquen el riesgo del paciente de sufrir un resultado adverso para la salud o el riesgo de una mayor exacerbación de una afección médica actual, normalmente crónica.',
    QHSLabAllergyAssessmentTitle: 'Evaluación de alergias de QHSLab',
    QHSLabAllergyAssessmentText:
      'La Evaluación de alergias es una aplicación de medicina digital patentada que combina varios instrumentos validados y estandarizados relacionados con las alergias y el asma, que se describen a continuación. Esta evaluación incluye las respuestas de los pacientes y la puntuación relacionada con su historial de alergias, los síntomas recientes de alergia y asma, el impacto ambiental y la gravedad de dichos síntomas, el uso de medicamentos para la alergia y el asma, y los hábitos de vida. La Evaluación de alergias se desarrolló para ayudar a los médicos y otros profesionales sanitarios en su evaluación rutinaria de pacientes con sospecha de alergias y asma comórbida. "Medicina digital" es un término que se refiere a las aplicaciones informáticas dirigidas por médicos y otros profesionales sanitarios. Esta evaluación no pretende ser diagnóstica ni terapéutica, sino que debe utilizarse como complemento en la toma de decisiones clínicas. \n',
    respiratoryAllergyPredictionTestTitle: 'Prueba de predicción de alergias respiratorias',
    respiratoryAllergyPredictionTestText:
      'La Prueba de Predicción de Alergias Respiratorias es una evaluación validada y sencilla que consta de cuatro preguntas. Está diseñada para confirmar la sospecha clínica de alergia respiratoria y la necesidad médica de realizar pruebas de alergia gracias a su alto valor predictivo. Responder afirmativamente a las tres preguntas siguientes: 1) aparición de síntomas en primavera, 2) tener o haber tenido tos y dificultad para respirar, y 3) uso frecuente de aerosoles nasales, indica una alta probabilidad (85 %) de diagnóstico de alergia respiratoria. También sugiere una necesidad real de realizar pruebas de alergia para confirmar el alérgeno desencadenante. Si un paciente ha respondido afirmativamente a las preguntas que acabamos de describir. En ese caso, el informe de interpretación digital del médico indicará que es muy probable que el paciente dé positivo en una prueba de alergia en sangre o cutánea para confirmar los alérgenos ambientales desencadenantes (Galimberti et al., 2015). ',
    generalAllergyHistoryTitle: 'Historial general de alergias',
    generalAllergyHistoryText:
      'Se ha demostrado que el conocimiento que tiene un paciente de sus diversas afecciones de salud, o "alfabetización sanitaria", repercute positivamente en su enfoque del autocontrol y en su calidad de vida en general. Supongamos que un paciente responde que no sabe si padece alguna afección de salud como rinitis alérgica, asma, conjuntivitis alérgica o urticaria alérgica. Esta situación podría brindar una oportunidad educativa para explicar la afección, determinar si el paciente la padece y explicar el manejo adecuado de la misma. Si un paciente responde que padece la afección y que ha recibido tratamiento en el pasado, esto proporcionará información sobre sus expectativas respecto al tratamiento actual que se le va a proponer. Ambas respuestas son oportunidades para reforzar los enfoques basados en la evidencia para el manejo de las alergias.',
    patientReportedAllergySymptomsTitle: 'Síntomas de alergia comunicados por el paciente',
    patientReportedAllergySymptomsText:
      'Los alérgenos que provocan síntomas pueden clasificarse, a grandes rasgos, en alérgenos predominantemente exteriores, interiores o relacionados con los alimentos. Los distintos alérgenos exteriores polinizan en diferentes épocas del año. Los árboles producen polen a principios y mediados de la primavera, la polinización de la hierba tiene lugar más adelante en la primavera y durante el verano, y las malas hierbas polinizan en otoño. Las esporas de moho del exterior también pueden afectar a las personas alérgicas durante todo el año cuando las condiciones favorecen el crecimiento de hongos o moho, como tras el deshielo de las heladas invernales a principios de primavera o tras periodos de lluvias intensas seguidos de condiciones climáticas más cálidas. Los alérgenos perennes, como los ácaros del polvo, la caspa animal, los insectos y los alérgenos del moho, que suelen encontrarse en interiores con condiciones de alta humedad, son desencadenantes de síntomas alérgicos muy frecuentes durante todo el año. Las respuestas de un paciente a las preguntas sobre los síntomas, su aparición y el entorno ayudan a los médicos a determinar el alérgeno que probablemente esté afectando al paciente, lo cual se confirma mediante una prueba cutánea o un análisis de sangre, y también ayuda al médico a recetar o modificar la medicación.',
    sinoNasalOutcomeTestTitle: 'Prueba de resultados nasosinusales-22 (SNOT-22)',
    sinoNasalOutcomeTestText1:
      'El Sino-Nasal Outcome Test-22 (SNOT-22) es un cuestionario específico para esta enfermedad muy utilizado que incluye 22 síntomas que combinan problemas rinológicos con cuestiones de salud general. El SNOT-22 ha sido validado y ha demostrado ser fácil de usar en todo el mundo, tanto en la práctica clínica como en la investigación. Los médicos pueden utilizar esta prueba para facilitar la práctica clínica habitual y poner de relieve el impacto de la rinosinusitis crónica en la calidad de vida de los pacientes. Esta prueba también se utiliza con frecuencia para evaluar los resultados de intervenciones quirúrgicas y tratamientos específicos de inmunoterapia con alérgenos (Hopkins et al., 2009).',
    sinoNasalOutcomeTestText2:
      'Encontrará el resultado global del paciente en su SNOT-22 (indicado en la sección titulada "Interpretación del médico") con una de las siguientes indicaciones:',

    sinoNasalOutcomeTestText3:
      'Los médicos pueden consultar cada una de las 22 respuestas del SNOT-22 en la sección del informe titulada "Gravedad de los síntomas alérgicos SNOT-22"',
    sinoNasalOutcomeTestMildTitle: 'Leve',
    sinoNasalOutcomeTestMildText: 'Puntuación de 8 a 19',
    sinoNasalOutcomeTestModerateTitle: 'Moderada',
    sinoNasalOutcomeTestModerateText: 'Puntuación entre 20 y 50',
    sinoNasalOutcomeTestSevereTitle: 'Grave',
    sinoNasalOutcomeTestSevereText: 'Puntuación superior a 50',
    asthmaControlTestTitle: 'Prueba de control del asma (ACT)',
    asthmaControlTestText:
      "La rinosinusitis crónica (RSC) está estrechamente relacionada con el asma comórbida. La Prueba de Control del Asma (ACT) proporciona rápidamente una puntuación numérica para evaluar el control del asma. La ACT está reconocida por los Institutos Nacionales de Salud (NIH) en sus directrices sobre el asma de 2007 y ha sido validada clínicamente en comparación con la espirometría y la evaluación de especialistas (Nathan et al., 2004). Supongamos que su paciente indica que padece asma en la sección de antecedentes generales de alergias. En ese caso, encontrará la puntuación global que indica en qué medida el asma del paciente está controlada según el ACT, que se recoge en la sección 'Interpretación del médico'. Una puntuación de 19 o menos indica que es posible que el asma del paciente no esté controlada.",
    allergyMedicationUseTitle: 'Uso de medicamentos para la alergia',
    allergyMedicationUseText:
      'A menudo, los pacientes se autodiagnostican y se automedican de forma inadecuada. Las estrategias más habituales para tratar los síntomas de la alergia están relacionadas con la adherencia a la medicación. Los pacientes que se automedican con medicamentos de venta libre suelen presentar bajos índices de adherencia y pueden tomar medicamentos incorrectos sin la orientación de un médico o un farmacéutico. Las estrategias de autocontrol se pueden aplicar mejor cuando se ha evaluado el tipo y el uso de la medicación del paciente en combinación con la frecuencia y la gravedad de sus síntomas y los factores ambientales a los que se expone.  La Evaluación de Alergias registra las respuestas de los pacientes sobre el uso y la frecuencia de antihistamínicos, descongestionantes, cromoglicato, antagonistas de los receptores de leucotrienos y broncodilatadores combinados de acción prolongada y beta2-adrenérgicos para los pacientes que indican que son asmáticos. ',
    healthBehaviorsTitle: 'Comportamientos de salud',

    healthBehaviorsTextFirst:
      'Es bien sabido que un estilo de vida saludable —que incluya actividad física regular, control del peso, buenos hábitos de sueño, una dieta sana rica en frutas y verduras, no fumar (y evitar la exposición al humo de segunda mano) y bienestar psicológico— puede ayudar a las personas alérgicas. Muchos pacientes saben que necesitan cambiar su estilo de vida, pero a menudo no se lo toman en serio hasta que se lo dice un profesional médico de confianza. La Evaluación de Alergias también plantea a los pacientes preguntas relacionadas con sus hábitos de salud y proporciona a los médicos las puntuaciones de los pacientes en cuanto a niveles de actividad física y ejercicio, consumo de frutas y verduras y consumo de tabaco, ya que estos hábitos de salud tienen un impacto evidente en el bienestar general del paciente, el control del peso y la salud psicosocial, incluida la calidad del sueño.',
    healthBehaviorsTextSecond:
      'Cuando los pacientes están asintomáticos o tienen bajo control sus desencadenantes polínicos, los médicos deben animar a sus pacientes con alergias y asma a cumplir las directrices recomendadas de actividad física y ejercicio. Además, animar a los pacientes a pasar tiempo al aire libre, especialmente en espacios verdes como parques, bosques, lagos y playas, siempre que sea posible, para atraer algunos "microbios" beneficiosos a su microbiota, también resulta beneficioso para el control de las enfermedades alérgicas. La exposición segura a la luz solar directa para absorber vitamina D natural mientras se hace ejercicio al aire libre también puede ser beneficiosa.',
    healthBehaviorsTextThird:
      'Seguir una dieta rica en fibra fermentable, con frutas y verduras y prebióticos habituales, resulta muy beneficioso e incluye alimentos como el ajo, la cebolla, el puerro, la raíz de achicoria y los espárragos. También se recomiendan los alimentos ricos en probióticos, como el repollo fermentado, el chucrut o el kimchi, los encurtidos, el suero de leche y los yogures con cultivos vivos. Una dieta saludable combinada con prebióticos y probióticos puede ayudar a proteger a sus pacientes contra las alergias (Pullen y Grogan 2017).',
    healthBehaviorsTextForth:
      'En conclusión, la evaluación de alergias de QHSLab proporciona una herramienta de medicina digital para que los médicos evalúen rápidamente los posibles desencadenantes de alergias de un paciente y las condiciones ambientales que afectan a la gravedad de sus síntomas y a su calidad de vida. Con esta sencilla evaluación digital de riesgos para la salud, los médicos pueden determinar si son necesarias pruebas de confirmación adicionales en sangre o cutáneas y si el paciente se beneficiaría de la intervención de un especialista en alergias y/o de un tratamiento de inmunoterapia con alérgenos.',

    referencesTitle: 'Referencias',
    referencesFirst:
      'Galimberti et al. Detección de la alergia mediante un sencillo cuestionario. Revista de la Organización Mundial de Alergia (2015) 8:16',
    referencesSecond:
      'Hopkins C et al. Validez psicométrica de la prueba de resultados nasosinusales de 22 ítems. Clin Otolaryngol. Octubre de 2009; 34(5):447-54.',

    referencesThird:
      'Toma S, Hopkins C. Estratificación de las puntuaciones del SNOT-22 en leve, moderada o grave y relación con otros instrumentos subjetivos. Rhinology. Junio de 2016; 54(2):129-33.',
    referencesFourth:
      'Departamento de Salud y Servicios Humanos de EE. UU., Institutos Nacionales de Salud, Instituto Nacional del Corazón, los Pulmones y la Sangre. Informe del Panel de Expertos 3: Directrices para el diagnóstico y el tratamiento del asma (EPR-3 2007). ',
    referencesFifth: 'Nathan RA et al. J Allergy Clin Immunol. 2004;113:59-65.',
    referencesSixth:
      'Pullen y Grogan. Aumento de las alergias: soluciones desde la atención primaria. MedScience Research Group, Inc. (2017).',
  },
  QScaleReport: {
    title: 'Escala Q',
    subtitle: 'Test de tipos de estrés e instrumentos de Kessler 6',
    firstPart:
      'Uno de los principales avances en la investigación psicológica y la epidemiología de los últimos 40 años ha sido el desarrollo de entrevistas estructuradas administradas por personas sin formación específica, lo que permite estimar de forma estandarizada la prevalencia de los trastornos psicológicos entre la población no clínica.',
    secondPart:
      '"Q" significa "calidad de vida", y la Escala Q mide las respuestas de un paciente o los signos de alerta temprana ante preguntas sobre su sueño, estrés, ansiedad, preocupación, dolor y satisfacción. QHSLabs creó el instrumento de la Escala Q para generar información sobre el bienestar psicosocial en pacientes que, por lo demás, gozan de buena salud. Por lo tanto, los ítems de la Escala Q se han redactado deliberadamente para hacer hincapié en el funcionamiento psicológico normal de pacientes generalmente sanos. Si las respuestas a la Escala Q indican posibles problemas de salud mental, se deriva a los pacientes al Test de Tipo de Estrés y a las 6 preguntas de Kessler para identificar su riesgo de ansiedad y depresión clínicas con vistas a una evaluación clínica más exhaustiva.',
    thirdPart:
      'Algunas personas gestionan mejor el estrés a nivel físico (corriendo, practicando deporte, yendo al gimnasio), mientras que otras lo hacen mejor a nivel mental (meditación, relajación, terapia cognitivo-conductual). A los pacientes que responden afirmativamente a preguntas relacionadas con "sentirse bajo presión" o "tener dificultades para relajarse" se les remite al Test de Tipo de Estrés. La Prueba de Tipo de Estrés es una evaluación de 14 ítems que identifica cómo el paciente puede responder mejor a un enfoque físico o cognitivo de gestión del estrés.¹',
    fourthPart:
      'La Escala de Cribado de Kessler para el Malestar Psicológico (Kessler 6) se ha utilizado ampliamente como herramienta de cribado de problemas de salud mental y para medir la gravedad del impacto de dichos problemas en la vida diaria del paciente. La Kessler 6 es una herramienta adecuada para el cribado y la medición de la gravedad de los trastornos del estado de ánimo. También predice la calidad de vida relacionada con la salud más allá de lo que predicen los diagnósticos por sí solos. Los encuestados valoran con qué frecuencia se sintieron nerviosos, desesperanzados, inquietos o nerviosos, tan tristes que nada podía animarlos, que todo les suponía un esfuerzo y que se sentían inútiles.²',
    referencesTitle: 'Referencias',
    referencesFirst:
      'Egger, Binns, Rossner y Sagner. (2017) Medicina del estilo de vida. Estilo de vida, medio ambiente y medicina preventiva en la salud y la enfermedad. Tercera edición. Academic Press',
    referencesSecond:
      'Kessler RC, Andrews G, Colpe LJ, Hiripi E, Mroczek DK, Normand SL, Walters EE, Zaslavsky AM. Psychol Med. Agosto de 2002; 32(6):959-76',
  },
  pediatricAllergyBaselineAssessmentReport: {
    title: 'Informe de evaluación inicial de alergias pediátricas',
    firstPart:
      "La 'Evaluación de alergias pediátricas' de QHSLab es una herramienta de medicina digital patentada, desarrollada para ayudar a los médicos a identificar y tratar afecciones alérgicas comunes, los alérgenos desencadenantes, la gravedad de los síntomas, así como el uso y la frecuencia de la medicación en niños. La Evaluación de alergias pediátricas se ajusta a la definición para el uso del código CPT 96160, 'Administración de un instrumento de evaluación de riesgos para la salud centrado en el paciente (p. ej., evaluación de riesgos para la salud) con puntuación y documentación, según un instrumento estandarizado",
    requirementsFirst: 'Los requisitos para informar del código 96160 son los siguientes',
    requirementsSecond:
      'Se incurre en gastos de consulta para administrar el instrumento (como el tiempo de la enfermera o la compra de la prueba). El instrumento está estandarizado. El instrumento es puntuable. Los resultados se documentan en la historia clínica.',

    requirementsThird:
      'El término "estandarizado" se refiere a pruebas previamente validadas que se administran y califican de manera coherente o "estándar".',
    requirementsForth:
      '¿En qué consiste la "calificación"? Esta es una distinción importante entre una verdadera evaluación de riesgos para la salud y los formularios de recopilación de antecedentes. El instrumento, como mínimo, debe proporcionar un resultado umbral o respuestas pertinentes de sí/no que indiquen el riesgo del paciente de sufrir un resultado adverso para la salud o el riesgo de una mayor exacerbación de una afección médica actual, normalmente crónica.',
    QHSLabAllergyAssessmentTitle: 'Evaluación de alergias pediátricas de QHSLab',

    QHSLabAllergyAssessmentText:
      'La Evaluación de Alergias Pediátricas es una aplicación de medicina digital patentada que combina varios instrumentos validados y estandarizados relacionados con las alergias y el asma, tal y como se describe a continuación. Esta evaluación incluye las respuestas de los padres y tutores, así como la puntuación relativa al historial alérgico de sus hijos, los síntomas recientes de alergia y asma, el impacto ambiental y la gravedad de dichos síntomas, y el uso de medicamentos para la alergia y el asma. La Evaluación de Alergias Pediátricas se desarrolló para ayudar a los médicos y otros profesionales sanitarios en su evaluación rutinaria de niños con sospecha de alergias y asma comórbida. "Medicina digital" es un término que se refiere a las aplicaciones informáticas dirigidas por médicos y otros profesionales sanitarios. Esta evaluación no pretende ser diagnóstica ni terapéutica, sino que debe utilizarse como complemento en la toma de decisiones clínicas.',
    respiratoryAllergyPredictionTestTitle: 'Prueba de predicción de alergias respiratorias',
    respiratoryAllergyPredictionTestText:
      'La prueba de predicción de alergias respiratorias es una evaluación validada y sencilla que consta de cuatro preguntas. Está diseñada para confirmar la sospecha clínica de alergia respiratoria y la necesidad médica de realizar pruebas de alergia gracias a su alto valor predictivo. Responder afirmativamente a las tres preguntas siguientes: 1) aparición de síntomas en primavera, 2) tener o haber tenido tos, sibilancias y dificultad para respirar, y 3) uso frecuente de aerosoles nasales, indica una alta probabilidad (85 %) de diagnóstico de alergia respiratoria. También sugiere una necesidad real de realizar pruebas de alergia para confirmar el alérgeno desencadenante. Si un paciente ha respondido afirmativamente a las preguntas que acabamos de describir. En ese caso, el informe de interpretación digital del médico indicará que es muy probable que el paciente dé positivo en una prueba de alergia en sangre o cutánea para confirmar los alérgenos ambientales desencadenantes (Galimberti et al., 2015 y Sacchetti M et al).',
    generalAllergyHistoryTitle: 'Historial general de alergias',
    generalAllergyHistoryText:
      'Se ha demostrado que el conocimiento que tienen los padres o tutores sobre los distintos problemas de salud de sus hijos, o "alfabetización sanitaria", influye positivamente en su enfoque del autocontrol y en su calidad de vida en general. Supongamos que un padre o tutor responde que no sabe si su hijo padece alguna afección de salud, como rinitis alérgica, asma, conjuntivitis alérgica, urticaria alérgica, alergia alimentaria o anafilaxia. Esta situación podría brindar una oportunidad educativa para explicar la afección, determinar si el niño la padece y explicar cómo gestionarla adecuadamente. Si un padre o tutor responde que su hijo padece la afección y ha recibido tratamiento en el pasado, esto proporcionará información sobre sus expectativas respecto al tratamiento actual que se le va a proponer. Ambas respuestas son oportunidades para reforzar los enfoques basados en la evidencia para el manejo de la alergia.',
    patientReportedAllergySymptomsTitle:
      'Síntomas de alergia del niño comunicados por los padres o tutores',

    patientReportedAllergySymptomsText:
      'Los alérgenos que provocan síntomas pueden clasificarse, a grandes rasgos, en alérgenos predominantemente exteriores, interiores o relacionados con los alimentos. Los distintos alérgenos exteriores polinizan en diferentes épocas del año. Los árboles producen polen a principios y mediados de la primavera, la polinización de la hierba tiene lugar más adelante en la primavera y durante el verano, y las malas hierbas polinizan en otoño. Las esporas de moho del exterior también pueden afectar a las personas alérgicas durante todo el año cuando las condiciones favorecen el crecimiento de hongos o moho, como tras el deshielo de las heladas invernales a principios de primavera o tras periodos de lluvias intensas seguidos de condiciones climáticas más cálidas. Los alérgenos perennes, como los ácaros del polvo, la caspa animal, los insectos y los alérgenos del moho, que suelen encontrarse en interiores en zonas con condiciones de alta humedad, son desencadenantes de síntomas alérgicos muy frecuentes durante todo el año. Las respuestas de los padres o tutores a las preguntas sobre los síntomas, la frecuencia y el entorno de sus hijos ayudan a los médicos a determinar el alérgeno que probablemente esté afectando al niño, lo cual se confirma mediante una prueba cutánea o de sangre, y también ayudan al médico a recetar o modificar la medicación.',
    sinoNasalOutcomeTestTitle: 'Cuestionario de resultados nasosinusales-22 (SNOT-22)',
    sinoNasalOutcomeTestText1:
      'El Sino-Nasal Outcome Test-22 (SNOT-22) es un cuestionario específico para esta enfermedad que se utiliza habitualmente y que incluye 22 síntomas que combinan problemas rinológicos con cuestiones de salud general. El SNOT-22 ha sido validado y ha demostrado ser fácil de usar en todo el mundo, tanto en la práctica clínica como en la investigación. Los médicos pueden utilizar esta prueba para facilitar la práctica clínica habitual y poner de relieve el impacto de la rinosinusitis crónica en la calidad de vida de los pacientes. Esta prueba también se utiliza con frecuencia para evaluar los resultados de intervenciones quirúrgicas y tratamientos específicos de inmunoterapia con alérgenos (Hopkins et al., 2009).',
    sinoNasalOutcomeTestText2:
      'Encontrará el resultado global del paciente en su SNOT-22 (indicado en la sección titulada "Interpretación del médico") con una de las siguientes indicaciones:',

    sinoNasalOutcomeTestText3:
      'Los médicos pueden consultar cada una de las 22 respuestas del SNOT-22 en la sección del informe titulada "Gravedad de los síntomas alérgicos SNOT-22"',
    sinoNasalOutcomeTestMildTitle: 'Leve',
    sinoNasalOutcomeTestMildText: 'Puntuación de 8 a 19',
    sinoNasalOutcomeTestModerateTitle: 'Moderada',
    sinoNasalOutcomeTestModerateText: 'Puntuación entre 20 y 50',
    sinoNasalOutcomeTestSevereTitle: 'Grave',
    sinoNasalOutcomeTestSevereText: 'Puntuación superior a 50',
    asthmaControlTestTitle: 'Prueba de control del asma (ACT)',
    asthmaControlTestText:
      "La rinosinusitis crónica (RSC) está estrechamente relacionada con el asma comórbida. La Prueba de Control del Asma (ACT) proporciona rápidamente una puntuación numérica para evaluar el control del asma. La ACT está reconocida por los Institutos Nacionales de Salud (NIH) en sus directrices sobre el asma de 2007 y ha sido validada clínicamente en comparación con la espirometría y la evaluación de especialistas (Nathan et al., 2004). Supongamos que su paciente indica que padece asma en la sección de antecedentes generales de alergias. En ese caso, encontrará la puntuación global que indica en qué medida el asma del paciente está controlada según el ACT, que se recoge en la sección 'Interpretación del médico'. Una puntuación de 19 o menos indica que es posible que el asma del paciente no esté controlada.",
    allergyMedicationUseTitle: 'Uso de medicamentos para la alergia',

    allergyMedicationUseText:
      'A menudo, los padres y tutores autodiagnostican y automedican a sus hijos de forma inadecuada. Las estrategias más habituales para tratar los síntomas de la alergia están relacionadas con el cumplimiento terapéutico. Los pacientes que se automedican con medicamentos de venta libre suelen presentar bajos índices de cumplimiento, y es posible que tomen medicamentos incorrectos sin la orientación de un médico o un farmacéutico. Las estrategias de autocontrol pueden aplicarse mejor cuando se ha evaluado el tipo y el uso de la medicación del paciente en combinación con la frecuencia y gravedad de sus síntomas y los factores ambientales a los que se expone. La Evaluación de Alergias Pediátricas registra las respuestas de los padres o tutores sobre el uso de medicación de sus hijos y la frecuencia de antihistamínicos, descongestionantes, cromoglicato, antagonistas de los receptores de leucotrienos y broncodilatadores combinados de acción prolongada y beta2-adrenérgicos para los pacientes que indican que son asmáticos. \n En conclusión, la Evaluación de Alergias Pediátricas de QHSLab proporciona una herramienta médica digital para que los médicos evalúen rápidamente los posibles desencadenantes de la alergia de un paciente y las condiciones ambientales que afectan a la gravedad de sus síntomas y a su calidad de vida. Con esta sencilla evaluación digital de riesgos para la salud, los médicos pueden determinar si se necesitan más pruebas de confirmación en sangre o cutáneas y si el paciente se beneficiaría de la intervención de un especialista en alergias y/o de un enfoque de tratamiento de inmunoterapia con alérgenos.',
    referencesTitle: 'Referencias',
    referencesFirst:
      'Galimberti et al. Detección de la alergia mediante un sencillo cuestionario. World Allergy Organization Journal (2015) 8:16',
    referencesSecond:
      'Sacchetti M et al. Desarrollo y validación preliminar de un nuevo cuestionario de cribado para identificar a los niños atópicos. Pediatric Health, Medicine and Therapeutics 2017:8 99–105',
    referencesThird:
      'Hopkins C et al. Validez psicométrica del Sinonasal Outcome Test de 22 ítems. Clin Otolaryngol. Octubre de 2009; 34(5):447-54.',
    referencesFourth:
      'Toma S, Hopkins C. Estratificación de las puntuaciones del SNOT-22 en leve, moderada o grave y relación con otros instrumentos subjetivos. Rhinology. Junio de 2016; 54(2):129-33.',
    referencesFifth:
      'Departamento de Salud y Servicios Humanos de EE. UU., Institutos Nacionales de Salud, Instituto Nacional del Corazón, los Pulmones y la Sangre. Informe del Panel de Expertos 3: Directrices para el diagnóstico y el tratamiento del asma (EPR-3 2007).',
    referencesSixth: 'Nathan RA et al. J Allergy Clin Immunol. 2004;113:59-65.',
  },
  SNOT22Report: {
    title: 'Evaluación SNOT-22',
    firstPart: `El SNOT-22 es un cuestionario específico para la enfermedad que incluye 22 síntomas que combinan problemas rinológicos con cuestiones de salud general, y que proporciona una puntuación global de la gravedad de los síntomas que puede estar afectando a la calidad de vida del paciente.`,
    sinoNasalOutcomeTestTitle: 'Prueba de resultados nasosinusales-22 (SNOT-22)',
    sinoNasalOutcomeTestText1:
      'La Prueba de Resultados Sinonasales-22 (SNOT-22) es un cuestionario específico para la enfermedad de uso común que incluye 22 síntomas que combinan problemas rinológicos con problemas de salud general. La SNOT-22 ha sido validada y se ha demostrado que es fácil de usar en todo el mundo en la práctica clínica y la investigación. Los médicos pueden utilizar esta prueba para facilitar la práctica clínica habitual y poner de relieve el impacto de la rinosinusitis crónica en la calidad de vida de los pacientes. Esta prueba también se utiliza con frecuencia para evaluar los resultados de intervenciones quirúrgicas y tratamientos específicos de inmunoterapia con alérgenos (Hopkins et al., 2009).',
    sinoNasalOutcomeTestText2:
      'Encontrará el resultado global del paciente en el SNOT-22 (recogido en la sección titulada "Interpretación del médico") con una de las siguientes indicaciones:',
    sinoNasalOutcomeTestText3:
      "Los médicos pueden revisar cada una de las 22 respuestas al SNOT-22 en la sección del informe bajo el encabezado 'Gravedad de los síntomas alérgicos SNOT-22.'",
    sinoNasalOutcomeTestMildTitle: 'Leve',

    sinoNasalOutcomeTestMildText: 'Puntuación de 8 a 19',
    sinoNasalOutcomeTestModerateTitle: 'Moderado',
    sinoNasalOutcomeTestModerateText: 'Puntuación entre 20 y 50',
    sinoNasalOutcomeTestSevereTitle: 'Grave',
    sinoNasalOutcomeTestSevereText: 'Puntuación superior a 50',
    referencesTitle: 'Referencias',
    referencesFirst:
      'Hopkins C et al. Validez psicométrica del Sinonasal Outcome Test de 22 ítems. Clin Otolaryngol. Octubre de 2009; 34(5):447-54.',
  },
  asthmaControlAssessmentReport: {
    title: 'Prueba de control del asma (ACT)',
    firstPart: `La prueba de control del asma es una evaluación de 5 ítems que indica el grado de control del asma de un paciente durante el último mes.`,
    asthmaControlTestTitle: 'Prueba de control del asma (ACT)',
    asthmaControlTestText:
      'La rinosinusitis crónica (RSC) está estrechamente relacionada con el asma comórbida. La Prueba de control del asma (ACT) proporciona rápidamente una puntuación numérica para evaluar el control del asma. La ACT está reconocida por los Institutos Nacionales de Salud (NIH) en sus directrices sobre el asma de 2007 y ha sido validada clínicamente frente a la espirometría y la evaluación de especialistas (Nathan et al. 2004).',
    asthmaControlTestText2:
      'Una puntuación de 19 o menos indica que el asma del paciente podría no estar controlada.\n',
    referencesTitle: 'Referencias',
    referencesFirst:
      'Departamento de Salud y Servicios Humanos de EE. UU., Institutos Nacionales de Salud, Instituto Nacional del Corazón, los Pulmones y la Sangre. Informe del Panel de Expertos 3: Directrices para el diagnóstico y el tratamiento del asma (EPR-3 2007).',
    referencesSecond: 'Nathan RA et al. J Allergy Clin Immunol. 2004;113:59-65.',
  },
  printReport: {
    assessmentDate: 'Fecha de evaluación',
    dateOfBirth: 'Fecha de nacimiento',
    sex: 'Sexo',
    male: 'Hombre',
    female: 'Mujer',
    MRN: 'MRN',
    zipCode: 'Código postal',
    providerName: 'Nombre del proveedor',
    providerNPI: 'NPI del proveedor',
    accountAddress: 'Dirección de la cuenta',
  },
  printBilling: {
    billingReport: 'Informe de facturación',
    procedureName: 'Nombre del procedimiento',
    procedureDescription: 'Descripción del procedimiento',
    exampleCPT: 'Ejemplo de CPT',
    completedTimestamp: 'Fecha de finalización',
    reviewedTimestamp: 'Fecha de revisión por parte del proveedor',
    dateOfBirth: 'Fecha de nacimiento',
    sex: 'Sexo',
    male: 'Hombre',
    female: 'Mujer',
    MRN: 'MRN',
    zipCode: 'Código postal',
    providerName: 'Nombre del proveedor',
    accountAddress: 'Dirección de la cuenta',
  },
  charts: {
    '< 1': '< 1',
    '1-4': '1-4',
    '5-14': '5-14',
    '15-24': '15-24',
    '25-34': '25-34',
    '35-44': '35-44',
    '45-54': '45-54',
    '55-64': '55-64',
    '65-74': '65-74',
    '75-84': '75-84',
    '> 84': '> 84',
    genderFemale: 'Género (Mujer)',
    averageAge: 'Edad media',
    generalHealth: 'Salud general',
    symptomSeveritySnot22: 'Gravedad de los síntomas (SNOT-22)',
    physicalActivity: 'Actividad física',
    fruitVegetableConsumption: 'Consumo de fruta y verdura',
    tobaccoUse: 'Consumo de tabaco',
    ageRange: 'Rango de edad',
    asthma: 'Asma',
    allergicRhinitis: 'Rinitis alérgica',
    allergicUrticara: 'Urticaria alérgica',
    allergicConjunctivitis: 'Conjuntivitis alérgica',
    numberOfPatients: 'Número de pacientes',
    good: 'Bueno',
    fair: 'Aceptable',
    very_good: 'Muy bueno',
    excellent: 'Excelente',
    poor: 'Malo',
    do_not_know: 'No sé si padezco esta afección',
    know_i_dont_have: 'Sé que no padezco esta afección',
    never_treated: 'Padezco esta afección, pero nunca he recibido tratamiento para ella',
    treated_in_past: 'Padezco esta afección y he recibido tratamiento en el pasado',
    treated_monitored: 'Recibo tratamiento y me controlan regularmente por esta afección',
    low: 'Bajo',
    lowRisk: 'Bajo riesgo',
    moderate: 'Moderado',
    moderateRisk: 'Riesgo moderado',
    highRisk: 'Alto riesgo',
    mild: 'Leve',
    severe: 'Grave',
  },
  dashboard: {
    activePatients: '{{count}} pacientes activos',
    errorLoadingMetrics: 'No se pudieron cargar las métricas del panel',
    numberOfPatients: 'Número de Pacientes',
    genderFemale: 'Género (Mujer)',
    averageAge: 'Edad Media',
    ageUnit: 'años',
    femaleOfTotal: '{{female}} de {{total}} pacientes',
    noChartData: 'Sin datos',
    healthStatus: 'Estado de Salud',
    riskConditions: 'Condiciones de Riesgo',
    lifestyle: 'Estilo de Vida',
  },
  permissionsTesting: {
    banner:
      'Herramienta de pruebas fuera de producción. Los cambios se aplican cuando el usuario vuelve a iniciar sesión.',
    account: 'Cuenta',
    user: 'Usuario',
    selectAccount: 'Seleccione una cuenta',
    selectUser: 'Seleccione un usuario',
    noUsers: 'Esta cuenta no tiene usuarios editables.',
    pickPair: 'Seleccione una cuenta y un usuario para cargar sus permisos.',
    pairUnavailable: 'Esta combinación de cuenta y usuario ya no está disponible. Elija otra.',
    loading: 'Cargando...',
    sectionUser: 'Usuario',
    sectionUserHint: 'Global para esta persona, en todas sus cuentas.',
    sectionUserAccount: 'Usuario en esta cuenta',
    sectionUserAccountHint: 'Rol y opciones por cuenta.',
    sectionAccount: 'Cuenta',
    sectionAccountHint: 'Funciones desactivadas para toda la cuenta.',
    readOnly: 'Solo lectura',
    effective: 'Permisos efectivos',
    effectiveHint: 'Las máscaras que el backend incluirá en el próximo token del usuario.',
    effectiveCurrent: 'Cuenta actual',
    effectiveChild: 'Cuentas hijas',
    decode: 'Descifrar',
    decodeUnknown: 'Bits activos sin nombre en el panel',
    decodeNone: 'Sin permisos asignados.',
    bulkJson: 'Edición masiva en JSON',
    bulkJsonInvalid: 'JSON no válido.',
    bulkJsonHint:
      'Reemplaza todos los valores a la vez. Guardar sigue enviando solo las secciones modificadas.',
    save: 'Guardar',
    clearAll: 'Borrar todas las opciones',
    clearAllHint:
      'Pone en false todas las opciones editables y no cambia el rol. Las opciones de cuenta son de tipo "desactivar", por lo que borrarlas habilita esas funciones.',
    saved: 'Guardado. Los cambios se aplican cuando el usuario vuelve a iniciar sesión.',
    featureOff: 'No disponible en este entorno.',
  },
  fileUploading: {
    dragFileHere: 'ARRASTRA EL ARCHIVO AQUÍ O',
    availableFormats: '* Formato de archivo disponible: ".XLSX"',
    fileIsUploaded: 'El archivo se ha cargado y validado...',
    fileSuccessfullyValidated: 'Archivo validado correctamente',
    importPatientsNow: 'Importar ahora',
    importNow: 'Importar ahora',
    importInsuranceNow: 'Importar seguro ahora',
    fileTypeNotSupported: 'Tipo de archivo no compatible',
    downloadValidationErrors: 'descargar errores de validación',
    fileHasValidationErrors: 'El archivo cargado tiene errores de validación',
    uploadAndValidate: 'Cargar y validar',
    selectFile: 'Seleccionar archivo',
    uploadOneFile: 'Por favor, carga un archivo',
    fileTooLarge: 'El archivo es demasiado grande. El tamaño máximo es de 10 MB',
    fileTypeInvalid: 'Tipo de archivo no válido. Solo se aceptan archivos .XLSX',
    importWasSuccessful: 'La importación se ha realizado correctamente',
    ok: 'ok',
    error500:
      "La cadena 'Estados Unidos' no se ha reconocido como una fecha y hora válidas. Hay una palabra desconocida que comienza en el índice '0'",
  },
  claimUpload: {
    title: 'Subida de reclamaciones',
    boxSubtitle:
      'Suba un archivo .xlsx. Valídelo primero para revisar los problemas sin guardar nada, o impórtelo para aplicar los cambios.',
    boxSubtitleNoValidate: 'Suba un archivo .xlsx para importar las filas.',
    dropHint: 'Suelte claims.xlsx aquí o busque el archivo',
    dropHintSub: 'Solo archivos .xlsx',
    changeFile: 'Cambiar archivo',
    removeFile: 'Quitar archivo',
    uploadAndImport: 'Subir e importar',
    uploadAndImportHint: 'Importa y guarda las reclamaciones',
    validateOnly: 'Solo validar',
    validateOnlyHint: 'Comprueba si hay errores; no se guarda nada',
    onlyXlsx: 'Solo se admiten archivos .xlsx',
    selectOneFile: 'Seleccione un único archivo .xlsx',
    resultTotal: 'Total',
    resultImported: 'Importadas',
    resultFailed: 'Fallidas',
    downloadErrorRows: 'Descargar filas con errores ({{count}})',
    addedToHistory: 'La nueva fila también se ha añadido al historial de abajo',
    dryRunTitle: 'Solo validación: no se guardó nada',
    rejectedTitle: 'Archivo rechazado: estructura no válida',
    issuesCount: '{{count}} problemas',
    noErrorDetails: 'No se proporcionaron más detalles.',
    rejectedSubtitle:
      'No se importó ninguna fila. Corrija los problemas siguientes y vuelva a subir el archivo.',
    rejectedSubtitleValidate:
      'Solo validación: el archivo fue rechazado y no se guardó nada. Corrija los problemas siguientes.',
    summaryValidatePassed:
      'Validación superada: {{imported}} de {{total}} filas están listas para importar. No se guardó nada.',
    validatedSuccess: 'Archivo validado correctamente: listo para subir.',
    summaryValidateIssues:
      'La validación encontró {{failed}} problema(s) en {{total}} filas. No se guardó nada.',
    summaryImportComplete: 'Las {{imported}} filas se importaron correctamente.',
    summaryImportPartial: 'Importación finalizada: {{imported}} importadas, {{failed}} fallidas.',
    skippedEmptyRows: '{{count}} filas vacías omitidas',
    statusCompleted: 'Completada',
    statusCompletedWithErrors: 'Completada con errores',
    statusRejected: 'Rechazada',
    statusValidationFailed: 'Validación fallida',
    // Binary-response domains (Patients / Insurance / Providers): the POST
    // returns an empty 200 (all rows in) or an annotated .xlsx workbook.
    fileSuccessTitle: 'Todas las filas se importaron correctamente.',
    fileFailedTitle: 'Algunas filas no se pudieron importar.',
    fileFailedSubtitle:
      'Las filas sin errores se importaron. Descargue el archivo anotado para ver qué falló y por qué.',
    fileValidateFailedTitle: 'La validación encontró problemas.',
    fileValidateFailedSubtitle:
      'No se guardó nada. Descargue el archivo anotado para ver los problemas.',
    downloadAnnotated: 'Descargar archivo anotado',
    importedLink: 'Importado',
    historyTitle: 'Historial de subidas',
    filterDateRange: 'Rango de fechas',
    filterUploadedBy: 'Subido por',
    allUploaders: 'Todos los usuarios',
    colFile: 'Archivo',
    colStatus: 'Estado',
    colImpFail: 'Imp/Fall',
    colUploadedBy: 'Subido por',
    colUploaded: 'Subido',
    errorsLink: 'Errores',
    historyEmpty: 'Aún no hay subidas',
    justNow: 'ahora mismo',
    loadMore: 'Cargar más',
  },
  tooltips: {
    notificationsComingSoon: 'Noticias y novedades de la versión: próximamente',
    oneAccountColumnsMustBeSelected:
      'Debe seleccionarse al menos una de las columnas de la cuenta para un patrocinador de distribución.',
    enableAutomation: 'Habilitar automatización',
    availableOnlyForDS: 'Disponible solo para cuentas de patrocinador de distribución',
    availableAfterSaving: 'Disponible después de guardar la cuenta',
    // Create User wizard
    dsIncompatiblePermission:
      'No disponible — su selección incluye una cuenta de Patrocinador de Distribución.',
    compareImproved: 'Mejorado',
    compareWorsened: 'Empeorado',
    compareChanged: 'Cambiado',
    severityCritical: 'Crítico',
    severityMonitor: 'Monitorear',
    help: 'Ayuda',
    // Row-menu availability hints
    noPermissionForAction: 'No tiene permiso para esta acción',
    rowActionResendUnavailable:
      'Disponible mientras la evaluación está a la espera del paciente (Invitado, Abierto, En curso o Procesado parcialmente)',
    rowActionGenerateClaimUnavailable:
      'Disponible para evaluaciones completadas que aún no tienen una reclamación',
    rowActionViewLinkUnavailable:
      'El enlace no está disponible para evaluaciones en estado Programado, No se presentó o Rechazado',
    rowActionReportUnavailable:
      'El informe del paciente se genera cuando se completa la evaluación.',
    rowActionComparisonUnavailable:
      'La comparación necesita una evaluación anterior completada del mismo tipo para este paciente.',
    rowActionEVisitUnavailable: 'No se creó una reclamación E-Visit para esta evaluación.',
    rowActionCounselingUnavailable: 'No se eligió ningún tema de asesoramiento en esta evaluación.',
    rowActionAppointmentNotPassed: 'Disponible después de la fecha de la cita',
    rowActionPatientDisabled: 'Disponible cuando el estado del paciente es Activo',
    rowActionImmunotherapyUnavailable: 'Disponible para pedidos de inmunoterapia SCIT',
    rowActionResourceScheduled: 'Este recurso está programado y aún no se ha enviado',
    rowActionEVisitClaimUnavailable:
      'Disponible para reclamaciones generadas a partir de un programa E-Visit',
  },
  infoPane: {
    patient: 'Paciente',
    clickToCopyToClipboard: 'Haga clic para copiar el valor',
    editPatient: 'Editar paciente',
    openPatientDashboard: 'Abrir panel del paciente',
    sentEmail: 'Enviar correo electrónico',
    metrics: 'Métricas',
    claims: 'Reclamaciones',
    assessments: 'Evaluaciones',
    reportables: 'Informes',
    resource: 'Recursos',
    alerts: 'Alertas',
    emailPatient: '¿Enviar correo electrónico al paciente?',
    openEmailApp: 'Elija cómo desea enviar un correo electrónico a este paciente.',
    emailPatientWithApp: 'Abrir en la aplicación de correo',
    emailPatientWithOutlook: 'Abrir en Outlook Web',
    emailHandlerNote:
      'Si al hacer clic en "Abrir en la aplicación de correo" no ocurre nada, es posible que su navegador no tenga configurado un gestor de correo electrónico predeterminado.',
    emailHandlerLink: 'Cómo configurarlo',
    send: 'Enviar',
    filtersApplied: 'Filtros aplicados',
    moreDetails: 'Más detalles',
    clickToOpenInfoPane: 'Haga clic para abrir el panel de información',
    anonymousPatient: 'Evaluación anónima',
    anonymousPatientInfo: 'No se ha recopilado información del paciente',
    sections: {
      identification: 'Identificación',
      engagement: 'Estado del paciente',
      contact: 'Contacto',
      demographics: 'Demografía',
    },
    collapseButton: 'Contraer',
    callPatient: 'Llamar al paciente',
    errorTitle: 'No se pudo cargar el paciente',
    errorRetry: 'Reintentar',
  },
  populationHealth: {
    exportFile: 'Exportar archivo',
    dateRange: 'Intervalo de fechas',
    assessmentType: 'Tipo de evaluación',
    comparisonMode: 'Modo de comparación',
    baselineVsFollowup: 'Referencia frente a seguimiento',
    singleTimePoint: 'Momento único',
    totalPatients: 'Total de pacientes',
    loadingPopulationHealthData: 'Cargando datos de salud de la población...',
    noMetricsAvailable:
      'No hay métricas disponibles para el instrumento de evaluación seleccionado',
    pleaseSelectDifferentInstrument:
      'Seleccione un instrumento diferente o elija "Todos los instrumentos"',
    patientDetails: 'Detalles del paciente',
    baselinePatients: 'Pacientes de referencia',
    followupPatients: 'Pacientes de seguimiento',
    populationDistribution: 'Distribución de la población',
    baselineVsFollowupComparison: 'Comparación entre referencia y seguimiento',
    metricSummary: 'Resumen de métricas',
    totalPatientsCount: 'Total de pacientes',
    ofPopulation: 'De la población',
    riskLevel: 'Nivel de riesgo',
    change: 'Cambio',
    patientList: 'Lista de pacientes',
    noPatients: 'No hay pacientes',
    foundForThisMetric: 'Encontrado para esta métrica',
    noBaselinePatients: 'No hay pacientes de referencia',
    noFollowupPatients: 'No hay pacientes de seguimiento',
    lastAssessment: 'Última evaluación',
    score: 'Puntuación',
    low: 'Baja',
    moderate: 'Moderada',
    high: 'Alta',
    critical: 'Crítica',
    helpRequested: 'Ayuda solicitada',
    monitor: 'Monitor',
    otherPatients: 'Otros pacientes',
    baseline: 'Referencia',
    followup: 'Seguimiento',
    baselineLight: 'Referencia (ligera)',
    followupFullColor: 'Seguimiento (a todo color)',
    numberOfPatients: 'Número de pacientes',
    patients: 'Pacientes',
    clickToViewDetails: 'Haga clic para ver los detalles del paciente',
    colorsIndicateRiskLevels:
      'Los colores indican los niveles de riesgo: Rojo (Crítico), Naranja (Alto), Azul (Monitor), Verde (Ayuda solicitada)',
    redCritical: 'Rojo (Crítico)',
    orangeHigh: 'Naranja (alto)',
    blueMonitor: 'Azul (vigilancia)',
    greenHelpRequested: 'Verde (se solicita ayuda)',
    alerts: 'Alertas',
    ofTotal: 'Del total',
    populationHealthMetrics: 'Métricas de salud de la población',
    clickBarToViewDetails:
      'Haga clic en cualquier barra para ver la información detallada del paciente',
    selectDateRange: 'Seleccionar intervalo de fechas',
    clearDateRange: 'Borrar intervalo de fechas',
    searchAssessments: 'Buscar evaluaciones...',
    loadingAssessments: 'Cargando evaluaciones...',
    noAssessmentsFound: 'No se han encontrado evaluaciones',
    noAssessmentsAvailable: 'No hay evaluaciones disponibles',
    allAssessments: 'Todas las evaluaciones',
    noPatientDataAvailable: 'No hay datos de pacientes disponibles',
    searchPatientsPlaceholder: 'Buscar pacientes por nombre, ID o detalles...',
    noPatientFoundFor: 'No se han encontrado pacientes para "{{query}}"',
    // Exportar informe
    exportReportTitle: 'Informe de evaluación de la salud de la población',
    exportReportSubtitle:
      'Análisis exhaustivo de los resultados de los pacientes y resumen de métricas clínicas',
    reportingPeriod: 'Período de información',
    assessmentTool: 'Herramienta de evaluación',
    patientCohort: 'Cohorte de pacientes',
    activePatients: 'Pacientes activos',
    analysisType: 'Tipo de análisis',
    comparativeAnalysis: 'Análisis comparativo',
    currentPeriod: 'Periodo actual',
    dataStatus: 'Estado de los datos',
    deidentified: 'Anonimizado',
    generated: 'Generado',
    allTime: 'Todo el tiempo',
    allInstruments: 'Todos los instrumentos',
    clinicalGrade: 'Grado clínico',
    accountFilter: 'Cuenta',
    selectAccount: 'Seleccionar cuenta',
    loadingAccountsText: 'Cargando cuentas...',
    noAccountsAvailable: 'No hay cuentas disponibles',
    exportDisclaimer:
      'Aviso sobre datos clínicos: Este informe contiene información sanitaria agregada y anonimizada de los pacientes, procesada de conformidad con la Norma de Privacidad de la HIPAA. Los datos están destinados a la mejora de la calidad de la atención sanitaria y al apoyo en la toma de decisiones clínicas. Se han eliminado los identificadores individuales de los pacientes para proteger su privacidad.',
    anyDate: 'Cualquier fecha',
    allAccounts: 'Cuenta actual',
    metricsTitle: 'Métricas de salud de la población',
    clickBarHint: 'Haga clic en cualquier barra para ver la información detallada del paciente.',
    exportPng: 'PNG',
    exportPdf: 'PDF',
    exportData: 'Exportar datos',
    loadingMetrics: 'Cargando métricas de población…',
    loadingHint:
      'Procesando los datos de pacientes para los filtros seleccionados. Esto suele tardar un momento.',
    errorTitle: 'No se pudieron cargar las métricas',
    errorHint:
      'Algo salió mal al obtener el panel. Inténtelo de nuevo en un momento o ajuste los filtros.',
    emptyTitle: 'Sin datos coincidentes',
    emptyHint:
      'Ningún paciente coincide con los filtros seleccionados. Amplíe el rango de fechas o elija otra evaluación.',
    resetFilters: 'Restablecer filtros',
  },
  assessmentPerformance: {
    includeAutomated: 'Incluir evaluaciones automáticas',
    automatedExcluded: 'Evaluaciones automáticas excluidas',
    pageTitle: 'Rendimiento de evaluaciones',
    pageSubtitle:
      'Compare la finalización de evaluaciones entre cuentas para dos periodos cualesquiera.',

    // Filter chips
    periodA: 'Actual',
    periodB: 'Anterior',
    quickRange: 'Rango rápido',
    quickRangePlaceholder: 'Aplicar preajuste…',
    account: 'Cuenta',
    selectPeriod: 'Seleccionar periodo',
    presetWoW: 'Semana a semana',
    presetMoM: 'Mes a mes',
    selectedAccountSingle: '1 seleccionada',
    selectedAccountsCount: '{{count}} seleccionadas',
    clearAll: 'Borrar',
    columnOffice: 'Consultorio',

    // Account picker (server-driven via /accounts)
    accountPickerPlaceholder: 'Elija las cuentas a comparar',
    accountPickerSearch: 'Buscar cuentas por nombre…',
    accountPickerLoading: 'Cargando cuentas…',
    accountPickerNoResults: 'Ninguna cuenta coincide con esta búsqueda.',
    accountPickerEmpty: 'No hay cuentas disponibles.',
    accountPickerNoSelection: 'No hay cuentas seleccionadas: elija al menos una',
    accountPickerLoadMore: 'Cargar más',
    accountPickerFilterByTags: 'Filtrar por etiquetas',

    // KPIs
    kpiSent: 'Enviadas',
    kpiCompleted: 'Completadas + TE',
    kpiCompletionRate: 'Índice de finalización',
    kpiDelta: 'Δ vs periodo anterior',
    pp: 'pp',
    noChange: 'sin cambios',

    // Comparison table
    tableTitle: 'Tabla comparativa',
    tableHint: 'Anterior → Actual (Δ%). Haga clic en una fila para ver el detalle.',
    columnAccount: 'Cuenta',
    rowTotal: 'Total (todas las cuentas)',

    // Metric labels
    metricSent: 'Enviadas',
    metricCompleted: 'Completadas',
    metricETransfer: 'Transferencia electrónica',
    metricCombinedCompleted: 'Completadas + TE',
    metricPartialProcessed: 'Procesado parcialmente',
    metricPendingReview: 'Pendiente de revisión',
    metricInProgress: 'En curso',
    metricNoShow: 'No se presentó',
    metricDeclined: 'Rechazado',
    metricNoShowAndDeclined: 'No se presentó + Rechazado',
    metricInvited: 'Invitado',
    metricCompletionRate: '% de finalización',
    metricEngagementRate: '% de participación',
    metricNoResponseRate: '% sin respuesta',

    // Tone tooltips
    toneInfoTitle: 'Semántica de colores',
    toneInfoBody:
      'Las métricas de rendimiento se muestran en verde cuando evolucionan en la dirección correcta y en rojo cuando no. Las métricas de seguimiento se muestran en naranja al subir (atención) y en verde al bajar (mejora). Las métricas neutras de volumen permanecen en gris independientemente del cambio.',

    // Charts
    chartCardTitle: 'Visualizaciones',
    chartCardHint:
      'Alterne entre la vista enfocada (una métrica) y la vista general (todas las métricas).',
    chartTabDiverging: 'Δ por cuenta',
    chartTabHeatmap: 'Mapa de calor',
    chartMetricSelector: 'Métrica',
    chartXLabel: 'Δ% vs anterior',
    chartLegendUp: 'Aumento',
    chartLegendDown: 'Disminución',

    // Drill-down modal
    drilldownTitle: 'Desglose de la cuenta',
    drilldownActiveFilters: 'Filtros activos',
    drilldownPeriodALabel: 'Actual',
    drilldownPeriodBLabel: 'Anterior',
    drilldownStatusDistribution: 'Distribución de estados',
    drilldownMetricsBreakdown: 'Desglose de métricas',
    drilldownMetricColumn: 'Métrica',
    drilldownEmailSummary: 'Enviar resumen de la cuenta por correo',
    drilldownEmailHint: 'Abre su cliente de correo predeterminado con el desglose ya completado.',

    // Toolbar
    exportCsv: 'Exportar CSV',
    exportPng: 'Exportar PNG',
    emailFullReview: 'Enviar revisión completa por correo',

    // Email-draft dialog (used when the body is too long for mailto)
    emailDraftDialogTitle: 'El borrador del correo es demasiado largo para el autocompletado',
    emailDraftDialogDescription:
      'Esta revisión mensual incluye todas las cuentas en un solo correo; el cuerpo completo es demasiado grande para que la mayoría de los clientes de correo (Gmail, Outlook web) lo acepten mediante el enlace de autocompletado. Rechazan cualquier contenido que supere ~2 KB.',
    emailDraftStep1: 'Copie el cuerpo del correo',
    emailDraftStep1Hint:
      '— haga clic en el botón de abajo para copiar el cuerpo completo al portapapeles.',
    emailDraftStep2: 'Abra su cliente de correo',
    emailDraftStep2Hint: '— se abre un borrador nuevo con el asunto ya completado.',
    emailDraftStep3: 'Pegue el cuerpo',
    emailDraftStep3Hint: '— Cmd / Ctrl + V en el cuerpo del mensaje.',
    emailDraftSubjectLabel: 'Asunto',
    emailDraftCopyButton: 'Copiar cuerpo del correo',
    emailDraftCopiedButton: 'Copiado',
    emailDraftCopied: 'Cuerpo del correo copiado al portapapeles.',
    emailDraftOpenButton: 'Abrir borrador vacío',

    // Empty / loading / error / pick-something
    loading: 'Cargando rendimiento de evaluaciones…',
    pickToBeginTitle: 'Elija un rango de fechas y al menos una cuenta',
    pickToBeginHint:
      'Use los chips de arriba para definir el periodo actual, el periodo anterior y las cuentas que desea comparar. De forma predeterminada se compara la última semana con la anterior.',
    emptyTitle: 'No hay datos para los periodos seleccionados',
    emptyHint: 'Pruebe con un rango de fechas más amplio o cambie la selección de cuentas.',
    errorTitle: 'No se pudieron cargar las métricas',
    errorRetry: 'Reintentar',
  },
  messages: {
    checkingEmail: 'Comprobando disponibilidad del correo electrónico...',
    emailAvailable:
      'El correo electrónico está disponible. Haga clic en "Siguiente" para continuar.',
    userExists: 'El usuario {email} ya existe',
    userExistsAddToAccount: 'El usuario {email} existe en el sistema',
    errorCheckingEmail: 'Error al comprobar el correo electrónico. Inténtelo de nuevo.',
    validating: 'Validando...',
    userAddedSuccess:
      'El usuario {{firstName}} {{lastName}} se ha añadido correctamente a su cuenta.',
    userCreatedSuccess: 'El usuario {{firstName}} {{lastName}} se ha creado correctamente.',
    emailRequired: 'El correo electrónico es obligatorio',
    invalidEmail: 'Introduzca una dirección de correo electrónico válida',
    searchAccountsPlaceholder: 'Buscar cuentas...',
    noAccountsFound: 'No se han encontrado cuentas',
    noAccountsAvailable: 'No hay cuentas disponibles',
    permissionsCount: '{{count}} permisos',
  },
  unsavedChanges: {
    title: 'Cambios sin guardar',
    defaultMessage: 'Si sales, se perderán tus cambios.',
    keepEditingButton: 'Quedarse',
    discardButton: 'Salir',
    // Formularios de usuario
    userProfile: 'Tienes cambios sin guardar en tu perfil.',
    userCreate: 'Tienes cambios sin guardar en el nuevo usuario.',
    providerCreate: 'Tienes cambios sin guardar en el nuevo proveedor.',
    providerEdit: 'Tienes cambios sin guardar en este proveedor.',
    userAccountAdd: 'Tienes detalles de acceso sin guardar. ¿Salir de todos modos?',
    userEdit: 'Tienes cambios sin guardar en el perfil de {name}.',
    userEditWarning:
      'Cualquier cambio que hayas realizado en la información del usuario, los roles o los permisos se perderá de forma permanente y no se podrá recuperar.',
    // Formularios de cuenta
    accountCreate: 'Tienes cambios sin guardar en la nueva cuenta.',
    accountEdit: 'Tienes cambios sin guardar en la configuración de {{name}}',
    accountPermissions: 'Tienes cambios sin guardar en los permisos de {name}',
    accountSwitchWarning:
      'Tienes cambios sin guardar en los permisos de {name}. Al cambiar de cuenta se perderán tus cambios.',
    accountSwitchTabMessage:
      'Tienes cambios sin guardar. ¿Está seguro de que desea cambiar a la pestaña Evaluaciones instantáneas? Se perderán sus cambios.',
    switchTab: 'Cambiar pestaña',
    // Formularios de pedido
    orderCreate: 'Hay cambios sin guardar en el nuevo pedido.',
    orderEdit: 'Hay cambios sin guardar en este pedido.',
    // Formularios de evaluación
    assessmentCreate: 'Tienes cambios sin guardar en la nueva evaluación.',
    // Formularios de paciente
    patientEdit: 'Tiene cambios sin guardar en el expediente de este paciente.',
    patientCreate: 'Tienes detalles del paciente sin guardar. ¿Salir de todos modos?',
    // Formularios de reclamación
    claimEdit: 'Tienes cambios sin guardar en esta reclamación.',
    // Etiquetas de botones
    leaveAnyway: 'Salir de todos modos',
    keepEditing: 'Seguir editando',
    switchAnyway: 'Cambiar de todos modos',
  },
  instantSurvey: {
    // Búsqueda y filtros
    searchPlaceholder: 'Buscar evaluaciones instantáneas...',
    addButtonTitle: 'Añadir nueva evaluación instantánea',
    // Filtros de estado
    statusAll: 'Todas',
    statusDraft: 'Borrador',
    statusActive: 'Activa',
    statusInactive: 'Inactiva',
    statusArchived: 'Archivada',
    // Indicadores de estado (texto de visualización)
    statusLabelDraft: 'Borrador',
    statusLabelActive: 'Activo',
    statusLabelInactive: 'Inactivo',
    statusLabelArchived: 'Archivado',
    // Insignia
    badgeNew: 'NUEVO',
    // Estados vacíos
    emptyStateNoAssessments: 'Aún no se han creado evaluaciones instantáneas',
    emptyStateNotFound: 'No se han encontrado evaluaciones instantáneas',
    // Texto de envíos
    submissions: 'envíos',
    submissionsWithLimit: '{{current}}/{{max}} envíos · {{completed}} completados',
    submissionsWithoutLimit: '{{current}} envíos · {{completed}} completados',
    // SurveyContent - Estado vacío
    emptyStateTitle: 'No se ha seleccionado ninguna evaluación instantánea',
    emptyStateDescription:
      'Seleccione una evaluación instantánea de la barra lateral para ver y editar sus detalles, o cree una nueva evaluación instantánea para empezar.',
    // SurveyContent - Título principal
    mainTitle: 'Configuración de la evaluación instantánea',
    mainSubtitle: '{{surveyType}} • Configure y personalice su evaluación instantánea',
    mainSubtitleNoType:
      'Tipo de evaluación no establecido • Configure y personalice su evaluación instantánea',
    // Títulos de sección
    basicConfigTitle: 'Configuración básica',
    linkQrCodeTitle: 'Enlace generado y código QR',
    submissionsTitle: 'Estado de los envíos',
    // Etiquetas de campo
    fieldAssessmentName: 'Nombre de la evaluación',
    fieldAssessmentType: 'Tipo de evaluación',
    fieldSurveyCode: 'Código de la encuesta',
    fieldMaxSubmissions: 'Número máximo de envíos',
    fieldAnonymous: 'Anónimo',
    // Valores de campo
    valueUntitledAssessment: 'Evaluación sin título',
    valueTypeNotSpecified: 'Tipo no especificado',
    valueNoCodeGenerated: 'No se ha generado ningún código',
    valueUnlimited: 'Ilimitado',
    valueAllowed: 'Permitido',
    valueNotAllowed: 'No permitido',
    // Descripciones emergentes de acciones
    editConfigurationTooltip: 'Editar configuración',
    // Secciones de QR y enlace
    sectionSurveyLink: 'Enlace a la encuesta',
    sectionQrCode: 'Código QR',
    downloadQrAriaLabel: 'Descargar código QR',
    shareHelper:
      'Comparte este enlace con los pacientes o imprime el código QR para escanearlo in situ.',
    // Sección de envíos
    submissionsLabel: 'Envíos',
    maxSubmissionsLabel: 'Número máximo de envíos',
    createdByText: 'Creado por {{creator}} el {{date}}',
    submissionsProgressCaption: '{{count}} de {{max}} respuestas recopiladas',
    completedSubmissionsCaption: '{{count}} completados',
    ofLabel: 'de',
    noLimitLabel: 'Sin límite',
    // AddInstantSurveyModal
    editInstantAssessment: 'Editar evaluación instantánea',
    createNewInstantAssessment: 'Crear nueva evaluación instantánea',
    basicInformation: 'Información básica',
    assessmentType: 'Tipo de evaluación',
    instantAssessmentName: 'Nombre de la evaluación instantánea',
    instantAssessmentNamePlaceholder:
      'Introduzca un nombre descriptivo para esta evaluación instantánea',
    privacySettings: 'Configuración de privacidad',
    anonymousModeLabel: 'Modo anónimo (no se recopila información del paciente)',
    patientInfoCollected:
      'Se recopilará información del paciente (nombre, correo electrónico, teléfono) en la encuesta',
    submissionsSectionTitle: 'Envíos',
    maximumSubmissions: 'Máximo de envíos',
    maxSubmissionsPlaceholder: 'Délo en blanco para envíos ilimitados',
    autoCloseAfterLimit: 'La evaluación se cerrará automáticamente tras alcanzar este límite',
    fixValidationErrors:
      'Por favor, corrija los errores de validación que se indican a continuación',
    failedToCreateAssessment: 'Error al {{action}} la evaluación instantánea',
    // DeleteConfirmationModal
    deleteInstantAssessment: 'Eliminar evaluación instantánea',
    finalConfirmation: 'Confirmación final',
    deleteInstantAssessmentQuestion: '¿Eliminar evaluación instantánea?',
    deleteConfirmMessage: '¿Está seguro de que desea eliminar de forma permanente',
    deleteWarningMessage:
      'Esta acción no se puede deshacer. Todos los datos asociados a esta evaluación se eliminarán de forma permanente.',
    actionIrreversible: 'Esta acción es irreversible',
    assessment: 'Evaluación:',
    deleteAboutToMessage:
      'Estás a punto de eliminar definitivamente esta configuración de evaluación. Esta acción no se puede deshacer y eliminará todos los ajustes y datos de configuración.',
    deletePermanently: 'Eliminar definitivamente',
    // StatusChangeConfirmationModal
    confirmAction: 'Confirmar acción',
    confirm: 'Confirmar',
    // Configuraciones de cambio de estado
    launchTitle: 'Iniciar evaluación',
    launchMessage: '¿Está seguro de que desea iniciar esta evaluación?',
    launchDescription:
      'Una vez iniciada, la evaluación se activará y será accesible para los pacientes. Puede desactivarla más tarde si es necesario.',
    launchConfirm: 'Iniciar evaluación',
    deactivateTitle: 'Desactivar evaluación',
    deactivateMessage: '¿Está seguro de que desea desactivar esta evaluación?',
    deactivateDescription:
      'La evaluación se desactivará temporalmente y los pacientes no podrán acceder a ella. No se perderán datos y podrá reactivarla en cualquier momento.',
    deactivateConfirm: 'Desactivar',
    reactivateTitle: 'Reactivar evaluación',
    reactivateMessage: '¿Está seguro de que desea reactivar esta evaluación?',
    reactivateDescription:
      'La evaluación volverá a estar activa y accesible para los pacientes. Todos los datos anteriores permanecerán intactos.',
    reactivateConfirm: 'Reactivar',
    archiveStep1Title: 'Archivar evaluación',
    archiveStep1Message: '¿Estás seguro de que quieres archivar esta evaluación?',
    archiveStep1Description:
      'La evaluación se trasladará al archivo y se ocultará de la lista principal. Se conservarán todos los datos y podrá desarchivar la evaluación en cualquier momento.',
    archiveStep2Title: 'Confirmación final',
    archiveStep2Message: 'Esta acción archivará la evaluación de forma permanente',
    archiveStep2Description:
      'La evaluación se trasladará a la sección de archivo y se eliminará de la vista principal. Aunque se conservan los datos, esta acción requiere una cuidadosa consideración.',
    archiveConfirm: 'Archivar evaluación',
    unarchiveTitle: 'Desarchivar evaluación',
    unarchiveMessage: '¿Está seguro de que desea desarchivar esta evaluación?',
    unarchiveDescription:
      'La evaluación se restablecerá a un estado inactivo y se mostrará en la lista principal. Todos los datos permanecerán intactos.',
    unarchiveConfirm: 'Desarchivar',
  },
  accountEdit: {
    unsavedOn: 'Cambios sin guardar en {{name}}',
    discard: 'Descartar',
    readOnly: 'Sólo lectura',

    configure: 'Configurar',
    needHelp: '¿Necesitas ayuda?',
    needHelpText:
      'Contacta a tu gerente de Customer Success para cambiar los permisos a nivel de cuenta.',

    identityLabel: 'Identidad',
    identityHint: 'Nombre, tipo, contacto',
    locationsLabel: 'Ubicaciones',
    locationsHint: 'Direcciones de oficina y envío',
    featuresLabel: 'Funciones',
    featuresHint: 'Módulos para esta cuenta',
    communicationsLabel: 'Comunicaciones',
    communicationsHint: 'Plantillas de correo y SMS',
    billingLabel: 'Facturación',
    billingHint: 'Códigos CPT y Zoho Books',
    billingSectionDescription:
      'Códigos y tarifas de los reportes de reclamaciones, y a dónde van las facturas de esta cuenta en Zoho Books.',
    zohoSectionTitle: 'Zoho Books',
    zohoSuggested: 'Sugerido',
    zohoSectionDescription:
      'Las facturas de esta cuenta se crean en Zoho Books para el cliente vinculado y se asignan al vendedor seleccionado.',
    zohoEnabled: 'Crear facturas en Zoho Books',
    zohoEnabledDescription:
      'Si está activado, cada informe de reclamaciones crea una factura en Zoho Books.',
    zohoNoCustomerWarning:
      'Sin cliente de Zoho vinculado: las facturas fallarán hasta que se seleccione uno',
    zohoCustomer: 'Cliente de Zoho',
    zohoCustomerHint: 'Busque por nombre, número de cuenta o correo electrónico.',
    zohoCustomerPlaceholder: 'Seleccione un cliente',
    zohoSearchPlaceholder: 'Nombre, número de cuenta o correo',
    zohoTypeToSearch: 'Escriba al menos 2 caracteres para buscar',
    zohoCustomerNone: 'Ninguno (desvincular)',
    zohoSearching: 'Buscando en Zoho Books…',
    zohoNoMatches: 'No hay clientes de Zoho que coincidan',
    zohoAccountNo: 'N.º de cuenta',
    zohoLinkedElsewhere: 'vinculado a otra cuenta',
    zohoSalesperson: 'Vendedor',
    zohoSalespersonNone: 'Ninguno',
    zohoInactive: 'inactivo',
    zohoUnavailable: 'Zoho Books no está disponible. Inténtelo más tarde.',
    instantAssessmentsLabel: 'Evaluaciones instantáneas',
    instantAssessmentsHint: 'Enlaces públicos y QR',

    identitySectionDescription: 'Quién administra esta cuenta y cómo contactarla.',
    accountType: 'Tipo de cuenta',
    selectAccountType: 'Selecciona una etiqueta',
    isDS: 'Patrocinador de distribución',
    isDSDescription:
      'Las cuentas DS administran cuentas hijas y desbloquean configuraciones adicionales.',
    basicInfo: 'Información básica',
    businessName: 'Nombre comercial',
    tradeName: 'Nombre de entidad / marca',
    sameAsBusinessName: 'Igual que el nombre comercial',
    usingBusinessName: 'Usando el nombre comercial',
    same: 'Igual',
    headProvider: 'Proveedor principal',
    contactName: 'Nombre de contacto',
    customId: 'ID personalizado',
    customIdLockedHint: 'No se puede cambiar mientras editas tu propia cuenta',
    phone: 'Teléfono',
    fax: 'Fax',
    scheduledDelivery: 'Entrega programada',
    timeZone: 'Zona horaria',
    scheduleDeliveryTime: 'Hora de entrega diaria',
    scheduleDeliveryTimeHint: 'Local a la zona horaria anterior',

    locationsSectionDescription:
      'Oficina central, dirección de envío y cualquier ubicación adicional.',
    headquartersAddress: 'Oficina central',
    sameAsHQ: 'Igual que la oficina central',
    shippingAddress: 'Dirección de envío',
    otherLocations: 'Otras ubicaciones',
    locationName: 'Nombre de la ubicación',
    streetAddress: 'Dirección',
    suite: 'Suite / Unidad',
    city: 'Ciudad',
    state: 'Estado',
    selectState: 'Selecciona…',
    zipCode: 'Código postal',
    location: 'Ubicación',
    addLocation: 'Agregar ubicación',

    features: 'Funciones',
    featuresSectionDescription: 'Qué módulos del producto están habilitados para esta cuenta.',
    enableOrders: 'Órdenes',
    enableOrdersDescription: 'Se pueden asignar órdenes individuales a los pacientes.',
    enableOrdersAutomations: 'Automatizaciones de órdenes',
    enableOrdersAutomationsDescription:
      'Seguimientos automáticos para órdenes que requieren acción.',
    enableAllergiendResources: 'Documentos de AllergiEnd',
    enableAllergiendResourcesDescription:
      'Mostrar recursos educativos de AllergiEnd en el portal del paciente.',
    enableImmunotherapyReport: 'Informe de inmunoterapia',
    enableImmunotherapyReportDescription:
      'Acceso al informe combinado de rendimiento de inmunoterapia.',
    enableClaimsManagement: 'Gestión de reclamaciones',
    enableClaimsManagementDescription:
      'Desbloquea el módulo completo de reclamaciones para esta cuenta.',
    intellyChartAssessments: 'Evaluaciones de Preventive Health Counseling',
    intellyChartAssessmentsHelper:
      'Solo las evaluaciones seleccionadas generan una reclamación de Preventive Health Counseling. Elija entre las evaluaciones permitidas para esta cuenta.',
    intellyChartAssessmentsEmpty:
      'No hay evaluaciones seleccionadas. No se crearán reclamaciones de Preventive Health Counseling para esta cuenta.',
    intellyChartAssessmentsNoOptions:
      'Primero agregue evaluaciones a la lista de evaluaciones permitidas más abajo.',
    intellyChartAssessmentsRemoved:
      'También eliminadas de la facturación de Preventive Health Counseling: {{titles}}.',
    intellyChartAssessmentsCount: '{{selected}} de {{total}} seleccionadas',
    intellyChartSelectAll: 'Seleccionar todo',
    intellyChartClear: 'Limpiar',
    enablePrograms: 'Programas',
    enableProgramsDescription:
      'Inscriba pacientes en programas de varios pasos creados por su patrocinador. Cada usuario también necesita Programas concedidos en su configuración de usuario.',
    enableProgramsSponsorDescription:
      'Siempre activado para los patrocinadores de distribución. Conceda Programas a cada usuario en su configuración de usuario.',
    programs: 'Programas',
    panelUnappliedTitle: 'Cambios sin aplicar',
    panelUnappliedMessage:
      'Esta lista tiene cambios que aún no se han aplicado. Descártelos o siga editando.',
    programsHelper:
      'Activar un programa agrega todo lo que necesita a las listas de abajo y lo bloquea allí. Quitar un elemento bloqueado desactiva el programa, tras una confirmación.',
    programsEnabledCount: '{{enabled}} de {{total}} activados',
    programsEmpty: 'Todavía no hay programas publicados disponibles para esta cuenta.',
    programOn: 'Activo',
    programName: 'Programa',
    programIncludes: 'Incluye',
    programOwnTemplate: 'Plantilla propia, siempre disponible',
    programIncludesSummary: '{{surveys}} evaluaciones · {{resources}} recursos · {{steps}} pasos',
    programHintAssessments: 'Evaluaciones',
    programHintResources: 'Recursos',
    programHintAllowed: 'Permitida',
    programHintWillBeAdded: 'Se agregará',
    usedBy: 'Usado por programas',
    requiredByProgram: 'Requerido por un programa. Haga clic para quitarlo de todos modos.',
    requiredByOwnProgram:
      'Requerido por un programa propio de esta cuenta. Edite esa plantilla de programa para quitarlo.',
    allowedTableEmpty:
      'Todavía no hay nada permitido. Use el botón Agregar para elegir del catálogo.',
    assessmentColumn: 'Evaluación',
    resourceColumn: 'Recurso',
    searchPrograms: 'Buscar programas',
    searchNoMatches: 'Nada coincide con su búsqueda.',
    manage: 'Gestionar',
    manageNeedsModule: 'Active primero este módulo.',
    programsCatalogueNeedsGrant: 'Lista de programas no disponible',
    programsCatalogueNeedsGrantHint:
      'Su usuario no tiene Programas en su propia cuenta. Pida a un administrador que le conceda Programas en su configuración de usuario y vuelva a iniciar sesión.',
    rowAllowedSummary: '{{allowed}} de {{total}} permitidas',
    rowRequiredSummary: '{{count}} requeridas por programas',
    filterAll: 'Todas {{count}}',
    filterAllowed: 'Permitidas {{count}}',
    filterRequired: 'Requeridas {{count}}',
    selectAllShown: 'Seleccionar o quitar todas las filas mostradas',
    tableLockHint:
      'las filas bloqueadas son requeridas por un programa activo; haga clic en el candado para quitarla de todos modos, se le pedirá confirmación',
    neededByOff: 'Necesaria para {{program}} (inactivo)',
    definitionsUnavailable:
      'No se pudo cargar el catálogo de programas, por lo que las listas permitidas son de solo lectura por ahora. Recargue la página para volver a intentarlo.',
    usedByMore: 'Más programas',
    allowedColumnHintAssessments:
      'Los pacientes de esta cuenta pueden recibir esta evaluación. Desmarque para dejar de asignarla; las evaluaciones ya enviadas o en curso no se ven afectadas.',
    allowedColumnHintResources:
      'Los pacientes de esta cuenta pueden recibir este recurso. Desmarque para dejar de asignarlo; los recursos ya enviados no se ven afectados.',
    automationColumnHint:
      'Cuando un paciente completa esta evaluación, QHS envía automáticamente el seguimiento previsto para este tipo: recursos y videos educativos, evaluaciones de seguimiento o un curso de lecciones, según el tipo y las respuestas del paciente. Desmarque para detener los nuevos seguimientos; los ya iniciados para un paciente llegan hasta el final.',
    intellyChartColumnHint:
      'Cuando un proveedor acepta los resultados de esta evaluación, QHS crea una reclamación de Preventive Health Counseling (CPT 99401). Disponible mientras la gestión de reclamaciones esté activada.',
    eVisitColumnHint:
      'Cuando un proveedor acepta los resultados de esta evaluación, QHS crea una reclamación E-Visit (CPT 99422 o 99423), como máximo una vez por paciente cada 30 días. Disponible mientras la gestión de reclamaciones esté activada. La reclamación necesita un recurso que envía la automatización, por lo que no surte efecto si Automatización está desmarcada para esta evaluación.',
    usedByHintAssessments:
      'Programas que envían esta evaluación en alguno de sus pasos. Mientras un programa así esté activado en la cuenta, la evaluación no puede quitarse de esta lista.',
    usedByHintResources:
      'Programas que envían este recurso en alguno de sus pasos. Mientras un programa así esté activado en la cuenta, el recurso no puede quitarse de esta lista.',
    allowedColumn: 'Permitida',
    automationColumn: 'Automatización',
    eVisitColumn: 'E-Visit',
    intellyChartColumn: 'Preventive Health Counseling',
    intellyChartNeedsClaims: 'Active primero la gestión de reclamaciones.',
    intellyChartNeedsClaimsColumn: 'Active {{module}} para usar esta columna.',
    presets: 'Selecciones predefinidas',
    presetsHint: 'Agrega un conjunto habitual de evaluaciones. No quita ninguna ya permitida.',
    presetFullScreening: 'Evaluación completa',
    presetHealthBehavioral: 'Salud y conducta',
    presetBehavioral: 'Solo conducta',
    presetAllAllowed: 'Ya permitidas',
    eVisitNeedsAutomation: 'Active primero la automatización de esta evaluación.',
    cptCodeOr: 'o',
    claimCptNeeded: 'Requiere el código CPT {{code}} en esta cuenta.',
    claimCptMissingColumn: 'Requiere el código CPT {{code}} en esta cuenta.',
    cptNeededTitle: 'La configuración de reclamaciones necesita estos códigos',
    cptNeededMissing: '{{column}} se factura con el código CPT {{code}}. Añádalo abajo.',
    claimCptDialogTitle: 'Esto requiere un código CPT',
    claimCptDialogMissing:
      '{{column}} se factura con el código CPT {{code}}, que esta cuenta no tiene. Añádalo en Códigos CPT y vuelva para marcar las evaluaciones correspondientes.',
    claimCptDialogMissingNoAccess:
      '{{column}} se factura con el código CPT {{code}}, que esta cuenta no tiene. Pida a su patrocinador de distribución que lo añada.',
    openCptSection: 'Abrir Códigos CPT',
    ordersAutomationsNeedOrders: 'Active primero los pedidos.',
    columnNeedsAllowed: 'Permita primero esta evaluación.',
    pickerSearchAssessments: 'Buscar evaluaciones',
    pickerSearchResources: 'Buscar recursos',
    programNeedsAssessments:
      'Active primero «Habilitar evaluaciones»: este programa envía evaluaciones.',
    programNeedsResources: 'Active primero «Habilitar recursos»: este programa envía recursos.',
    programAddedItems: 'Añadido a las listas permitidas ({{count}}): {{items}}',
    programAddedNothing: 'Todo lo que necesita este programa ya estaba permitido.',
    moduleOffTitle: '¿Desactivar {{module}}?',
    moduleOffBodyOne: 'Un programa activo depende de ello y se desactivará para esta cuenta.',
    moduleOffBodyMany:
      '{{count}} programas activos dependen de ello y se desactivarán para esta cuenta.',
    moduleOffConfirmOne: 'Desactivar y deshabilitar {{program}}',
    moduleOffConfirmMany: 'Desactivar y deshabilitar {{count}} programas',
    removeDependencyTitle: '¿Quitar {{name}}?',
    removeDependencyBodyOne:
      'Un programa activo envía este elemento. Quitarlo desactiva ese programa para esta cuenta. Los pacientes ya inscritos conservan su programa actual.',
    removeDependencyBodyMany:
      '{{count}} programas activos envían este elemento. Quitarlo desactiva esos programas para esta cuenta. Los pacientes ya inscritos conservan su programa actual.',
    removeDependencyWillTurnOff: 'se desactivará',
    removeDependencyNote: 'Nada se guarda hasta que presione Guardar cambios en la cuenta.',
    removeDependencyKeep: 'Conservar',
    removeDependencyConfirmOne: 'Quitar y desactivar {{program}}',
    removeDependencyConfirmMany: 'Quitar y desactivar {{count}} programas',
    enableBhiIntegration: 'Integración BHI',
    enableBhiIntegrationDescription:
      'Envía notificaciones webhook para esta cuenta (Behavioral Health Integration).',
    allowedAssessments: 'Evaluaciones permitidas',
    enableAssessments: 'Habilitar evaluaciones',
    enableAssessmentsDescription:
      'Se pueden enviar invitaciones para completar evaluaciones a los pacientes.',
    allowedAssessmentsHelper:
      'Los pacientes pueden completar cualquiera de las evaluaciones seleccionadas.',
    searchAssessments: 'Buscar evaluaciones',
    allowedResources: 'Recursos permitidos',
    enableResources: 'Habilitar recursos',
    enableResourcesDescription: 'Los pacientes ven los recursos educativos seleccionados.',
    allowedResourcesHelper:
      'Sólo los recursos seleccionados aparecerán en los menús de asignación.',
    searchResources: 'Buscar recursos',

    cptCodes: 'Códigos CPT',
    cptCodesSectionDescription:
      'Códigos de servicios facturables y tarifas usados en los reportes de reclamaciones de esta cuenta.',
    reportFormat: 'Formato del reporte de reclamación',
    reportFormatField: 'Formato del reporte',
    selectFormat: 'Selecciona un formato',
    cptCodesList: 'Códigos',
    cptCode: 'Código',
    cptFee: 'Tarifa (USD)',
    cptEmpty: 'Aún no hay códigos CPT. Agrega el primero usando la fila inferior.',
    cptAddHint: 'Agrega un nuevo código →',
    cptCodePlaceholder: '99213',
    add: 'Agregar',
    remove: 'Eliminar',

    communications: 'Comunicaciones',
    communicationsSectionDescription:
      'Plantillas que el sistema usa para enviar correos o mensajes a los pacientes. Las etiquetas como {patientName} se conservan sin cambios.',
    templates: 'plantillas',
    assessmentTemplates: 'Plantillas de evaluaciones',
    resourceTemplates: 'Plantillas de recursos',
    useDefault: 'Usar predeterminada',
    usingDefault: 'Usando predeterminada',
    customTemplate: 'Personalizada',
    topicAssessment: 'Evaluación',
    topicResource: 'Recurso',
    templateInvitationEmail: 'Correo — invitación',
    templateInvitationSMS: 'SMS — invitación',
    templateReminderEmail: 'Correo — recordatorio',
    templateReminderSMS: 'SMS — recordatorio',
    templateCompletionEmail: 'Correo — completado',
    templateCompletionSMS: 'SMS — completado',

    instantAssessments: 'Evaluaciones instantáneas',
    instantAssessmentsSectionDescription:
      'Evaluaciones que los pacientes pueden iniciar con un solo toque sin invitación. Se guardan individualmente a través del widget legado.',

    completenessMissing: 'Faltan campos obligatorios',
    completenessWarn: 'Campos recomendados vacíos',
    completenessError: 'Tiene errores de validación',

    noChanges: 'Sin cambios sin guardar',
    changeSingular: 'cambio sin guardar',
    changePlural: 'cambios sin guardar',
    across: 'en',
    sectionSingular: 'sección',
    sectionPlural: 'secciones',

    justCreatedTitle: 'Cuenta creada. Paso siguiente: invita a tu equipo.',
    justCreatedSubtitle:
      'Hemos rellenado lo básico — termina de configurar las funciones aquí y luego ve a Usuarios para añadir al menos una persona que pueda iniciar sesión.',
    goToUsers: 'Ir a Usuarios',

    deleteAccount: 'Eliminar cuenta',
    deleteConfirmTitle: '¿Eliminar {{name}}?',
    deleteConfirmMessage:
      'Esto eliminará permanentemente la cuenta y todos los pacientes, reclamaciones y pedidos asociados. Esta acción no se puede deshacer.',
  },
  accountCreate: {
    title: 'Nueva cuenta',
    description:
      'Sólo necesitamos lo esencial para empezar — configurarás el resto en la página de la cuenta.',
    businessName: 'Nombre comercial',
    accountType: 'Tipo de cuenta',
    accountTypePlaceholder: 'Selecciona uno o varios',
    phone: 'Teléfono',
    contactName: 'Nombre de contacto',
    timeZone: 'Zona horaria',
    helperText:
      'Después de crear la cuenta, te llevaremos directamente a la página de la cuenta para que puedas activar funciones, añadir otras ubicaciones e invitar a tu primer usuario.',
    stepCopy: 'Paso 1 de 2 · luego invita usuarios',
    submitLabel: 'Crear y configurar',
    addressTitle: 'Dirección de la oficina central',
    addressHint: 'Se usa como dirección de envío por defecto — puedes separarlas después.',
    required: 'Obligatorio',
    isDS: 'Patrocinador de distribución',
    isDSDescription:
      'Las cuentas DS administran cuentas hijas y desbloquean configuraciones adicionales.',
    isDSHint: 'No se puede cambiar después',
  },
  instantAssessments: {
    backToAccount: 'Volver a la cuenta',
  },
  surveyStatus: {
    invited: 'Invitado',
    created: 'Pendiente',
    staled: 'Abierto',
    inProgress: 'En curso',
    pendingReview: 'Pendiente de revisión',
    partialProcessed: 'Parcial',
    completed: 'Completado',
    processing: 'Procesando',
    scheduled: 'Programado',
    eTransfer: 'Transferido',
    canceled: 'Cancelado',
    noShow: 'No asistió',
  },
  providers: {
    // list columns
    colName: 'Nombre',
    colTitle: 'Título',
    colNpi: 'NPI',
    colLinked: 'Tiene usuarios',
    colDefault: 'Predeterminado',
    colCreated: 'Creado',
    // cell values, row actions and badges
    linkedYes: 'Sí',
    linkedNo: 'No',
    // Right-aligned pill on the account's default provider inside a
    // picker, so a preselected field says why it chose that row.
    defaultTag: 'Predeterminado',
    defaultChipPdf: 'PDF',
    defaultChipClaims: 'Reclamaciones',
    defaultChipAssessments: 'Evaluaciones',
    setDefaultGroup: 'Establecer como predeterminado para',
    alreadyDefaultFor: 'Este proveedor ya es el predeterminado para {{context}}',
    clearDefaultGroup: 'Quitar predeterminado para',
    uploadProvidersBtn: 'Subir proveedores',
    // add dialog
    addProvider: 'Agregar proveedor',
    howToAdd: 'Cómo agregar',
    providerDetails: 'Datos del proveedor',
    nameFromUser: 'Se toma del usuario seleccionado',
    modeManualTitle: 'Ingresar datos',
    modeManualSubtitle: 'Escriba el nombre, el título y el NPI del proveedor.',
    modeLinkTitle: 'Vincular un usuario de la cuenta',
    modeLinkSubtitle: 'Asocie el proveedor a alguien que ya tiene acceso.',
    accountUser: 'Usuario de la cuenta',
    selectAccountUser: 'Seleccione un usuario',
    searchUsers: 'Buscar usuarios...',
    loadingUsers: 'Cargando usuarios...',
    alreadyLinked: 'ya vinculado',
    linkOnlyViaPicker:
      'Escribir un nombre no vincula a nadie. Para vincular un proveedor con un usuario de la cuenta, elija "Vincular un usuario de la cuenta" arriba y selecciónelo de la lista.',
    providerAdded: 'Proveedor agregado.',
    userRequired: 'Seleccione un usuario para vincular.',
    nameConflict: 'Ya existe un proveedor con este nombre en esta cuenta.',
    // edit dialog
    editProvider: 'Editar proveedor',
    editName: 'Nombre',
    editTitle: 'Título',
    editNpi: 'Número NPI',
    providerUpdated: 'Proveedor actualizado.',
    nameRequired: 'El nombre es obligatorio.',
    titleRequired: 'El título es obligatorio.',
    npiRequired: 'El número NPI es obligatorio.',
    nameTooLong: 'El nombre no debe superar los 64 caracteres.',
    titleTooLong: 'El título no debe superar los 64 caracteres.',
    npiExactDigits: 'El número NPI debe tener exactamente 10 dígitos.',
    // errors
    staleRow: 'Este proveedor ya no está disponible. La lista se ha actualizado.',
    genericError: 'Algo salió mal. Por favor, inténtalo de nuevo.',
    // shared picker
    selectProvider: 'Seleccionar proveedor',
    noProvider: 'Sin proveedor',
  },
  programsDashboard: {
    common: {
      idPrefix: 'ID',
    },
    filters: {
      quickRangeLabel: 'Rango rápido',
      customRangeLabel: 'Rango personalizado',
      applyPresetPlaceholder: 'Aplicar preset…',
      pickDatesPlaceholder: 'Elegir fechas',
      accountLabel: 'Cuenta',
      accountStatusLabel: 'Estado de cuenta',
      statusActive: 'Activas',
      statusInactive: 'Inactivas',
      statusAll: 'Todas',
      presetPreviousMonth: 'Mes anterior',
      presetCurrentMonth: 'Mes actual',
      presetPreviousQuarter: 'Trimestre anterior',
      presetCurrentQuarter: 'Trimestre actual',
      presetYtd: 'Año en curso (hasta hoy)',
      presetFullYear: 'Año actual (completo)',
      presetCustom: 'Personalizado',
      resetFilters: 'Restablecer filtros',
    },
    export: {
      csv: 'Exportar CSV',
      xlsx: 'Exportar xlsx',
      pickDateRangeFirst: 'Elija primero un rango de fechas.',
      downloaded: 'Exportación descargada.',
      exportFailed: 'La exportación falló.',
    },
    compare: {
      dialogTitle: 'Comparar períodos',
      dialogSubtitle:
        'Elija dos ventanas de fechas para comparar la actividad de inscripción lado a lado.',
      accountLabel: 'Cuentas',
      currentLabel: 'Actual',
      previousLabel: 'Anterior',
      selectPeriod: 'Seleccionar período',
      quickPresets: 'Presets rápidos',
      presetPairs: {
        currentVsPreviousMonth: 'Mes actual vs anterior',
        lastCompletedVsBefore: 'Último mes completo vs el anterior',
        currentVsPreviousQuarter: 'Trimestre actual vs anterior',
        currentVsPreviousYear: 'Año actual vs anterior',
        ytdVsLastYear: 'Año hasta hoy vs año pasado',
        sameWindowLastYear: 'Ventana actual vs mismo período del año pasado',
      },
      // Own-namespace copies of CompareAccountPopover's chrome text
      // (values copied from assessmentPerformance.*'s es counterparts
      // — same UI, own feature's i18n namespace, per the
      // one-namespace-per-feature convention PH's AccountPopover
      // already follows).
      selectedAccountSingle: '1 seleccionada',
      selectedAccountsCount: '{{count}} seleccionadas',
      accountPickerPlaceholder: 'Elija las cuentas a comparar',
      accountPickerSearch: 'Buscar cuentas por nombre…',
      accountPickerLoading: 'Cargando cuentas…',
      accountPickerNoResults: 'Ninguna cuenta coincide con esta búsqueda.',
      accountPickerEmpty: 'No hay cuentas disponibles.',
      accountPickerLoadFailed:
        'No se pudieron cargar las cuentas. Cierre y vuelva a abrir para intentarlo de nuevo.',
      metricColumn: 'Métrica',
      changeColumn: 'Cambio',
      accountsSectionTitle: 'Cuentas que impulsan el cambio',
      accountsSectionHint: 'por pacientes activos al cierre del período',
      showAllAccounts: 'Mostrar las {{count}} cuentas',
      exportCsv: 'Exportar CSV de comparación',
      ppSuffix: 'pp',
      predatesHistory: 'El período de comparación es anterior al historial disponible.',
      loadFailed: 'No se pudo cargar la comparación. Ajuste los períodos e inténtelo de nuevo.',
    },
    exceptions: {
      rowLabel: 'Atención',
      noNewEnrollments: 'Sin nuevas inscripciones',
      declining: 'En declive',
      noActivePatients: 'Sin pacientes activos',
      highCancellationRate: 'Cancelación alta',
      noActivity: 'Sin actividad en el período',
    },
    help: {
      buttonLabel: 'Cómo se calcula',
      modalAriaLabel: 'Cómo se calculan las cifras del Panel de BHI',
      genericTitle: 'Cómo se calcula',
      gotItBtn: 'Entendido',
      l1Title: 'Panel de BHI — Cartera',
      l1Subtitle:
        'Qué significa cada columna e indicador de esta página y cómo lo calcula el backend.',
      l2Title: 'Panel de BHI — Detalle de cuenta',
      l2Subtitle:
        'Qué significa cada indicador y columna de la lista de pacientes y cómo lo calcula el backend.',
      sectionFieldsOnThisPage: 'Campos de esta página',
      metaSource: 'Fuente',
      metaFormula: 'Fórmula',
      metaAnchor: 'Ancla',
      metaNotes: 'Notas',
    },
    l1: {
      viewAccountsTab: 'Por cuenta',
      viewInsuranceTab: 'Por aseguradora',
      byInsuranceTableTitle: 'Reembolso por aseguradora',
      byInsuranceSubtitle:
        'Cada CPT desglosado por aseguradora, con una fila por cuenta bajo cada aseguradora — la misma aseguradora y CPT a distintas tarifas contratadas, lado a lado.',
      groupAccountsSingular: '{{count}} cuenta',
      groupAccountsPlural: '{{count}} cuentas',
      groupAccountsPartial: '{{loaded}} de {{count}} cuentas',
      pageTitle: 'Panel de BHI',
      pageSubtitle:
        'Actividad de inscripción del programa BHI a nivel de cartera. Detecte caídas en el cambio neto, picos de cancelación y cuentas sin actividad reciente.',
      tableTitle: 'Panel de BHI',
      backAriaLabel: 'Volver a {{title}}',
      pickRange: 'Elige un rango de fechas',
      nonDs: {
        accountFallback: 'Su cuenta',
        headlineOpeningActive: 'Activos al inicio',
        headlineNewEnrollments: 'Nuevas inscripciones',
        headlineCancellations: 'Cancelaciones',
        headlineClosingActive: 'Activos al cierre',
        opsNetChange: 'Δ neto',
        opsGrowthPercent: 'Crecimiento %',
        opsCancellationRate: 'Cancelación %',
        opsLastNewEnrollment: 'Última inscripción',
        opsLastCancellation: 'Última cancelación',
        viewPatientListCta: 'Ver lista de pacientes',
      },
    },
    l2: {
      pageSubtitleWithAccount:
        'Actividad de inscripción BHI de esta cuenta durante el período seleccionado.',
      tableTitle: 'Pacientes',
      periodLabel: 'Período',
    },
    history: {
      noHistoryYet: 'Esta cuenta aún no tiene historial de inscripción de BHI.',
      historyStartsOn:
        'El historial de inscripción de BHI comienza el {{date}}. Los números a continuación reflejan solo el período disponible.',
    },
    kpis: {
      opening: 'Iniciales',
      newEnrollments: 'Nuevas',
      cancellations: 'Cancelaciones',
      netChange: 'Δ neto',
      closing: 'Finales',
      cancellationRate: 'Cancelación %',
      accountsWithActive: 'Cuentas con activos',
      accountsWithNew: 'Cuentas con nuevas',
      accountsWithCancellations: 'Cuentas con cancelaciones',
    },
    columns: {
      businessName: 'Cuenta',
      customIdentifier: 'ID personalizado',
      accountStatus: 'Estado',
      statusActive: 'Activa',
      statusInactive: 'Inactiva',
      opening: 'Activos al inicio',
      newEnrollments: 'Nuevas inscripciones',
      cancellations: 'Cancelaciones',
      netChange: 'Δ neto',
      closing: 'Activos al cierre',
      growthPercent: 'Crecimiento %',
      cancellationRate: 'Cancelación %',
      lastNewEnrollment: 'Última inscripción',
      lastCancellation: 'Última cancelación',
      patientFirstName: 'Nombre',
      patientLastName: 'Apellido',
      mrn: 'MRN',
      enrollmentDate: 'Fecha de inscripción',
      currentStatus: 'Estado',
      patientStatusActive: 'Activo',
      patientStatusCancelled: 'Cancelado',
      statusEffectiveDate: 'Vigencia del estado',
      cancellationDate: 'Fecha de cancelación',
      lastBhiActivityDate: 'Última actividad',
    },
    patientStatus: {
      active: 'Activo',
      cancelled: 'Cancelado',
    },
    dictionary: {
      openingActivePatients: {
        label: 'Activos al inicio',
        definition: 'Pacientes inscritos en BHI y aún activos al inicio del período.',
        formula:
          'Recuento de pacientes cuyo último evento de inscripción ≤ from y sin cancelación ≤ from.',
        source: 'Tabla de eventos de inscripción de BHI.',
        anchor: 'Inicio del período (from).',
      },
      newEnrollments: {
        label: 'Nuevas inscripciones',
        definition: 'Número de pacientes recién inscritos en BHI durante el período seleccionado.',
        formula: 'Recuento de eventos de inscripción con timestamp en [from, to].',
        source: 'Tabla de eventos de inscripción de BHI.',
        anchor: 'Timestamp del evento.',
      },
      cancellations: {
        label: 'Cancelaciones',
        definition: 'Número de inscripciones de BHI canceladas durante el período seleccionado.',
        formula: 'Recuento de eventos de cancelación con timestamp en [from, to].',
        source: 'Tabla de eventos de cancelación de BHI.',
        anchor: 'Timestamp del evento.',
        gotchas:
          'El motivo aún no se registra — toda cancelación se muestra como una única categoría "Cancelada".',
      },
      netChange: {
        label: 'Δ neto',
        definition: 'Cambio en el número de pacientes activos durante el período.',
        formula: 'newEnrollments − cancellations',
        source: 'Derivado.',
        anchor: 'Igual que las entradas.',
      },
      closingActivePatients: {
        label: 'Activos al cierre',
        definition: 'Pacientes activos al final del período.',
        formula: 'openingActivePatients + netChange',
        source: 'Derivado.',
        anchor: 'Fin del período (to).',
      },
      growthPercent: {
        label: 'Crecimiento %',
        definition:
          'Crecimiento de pacientes activos durante el período, en relación con el número inicial.',
        formula: '(netChange ÷ openingActivePatients) × 100',
        source: 'Derivado.',
        anchor: 'Igual que las entradas.',
        gotchas: 'Se muestra como "—" cuando openingActivePatients es 0.',
      },
      cancellationRate: {
        label: 'Cancelación %',
        definition: 'Qué porción de la población en riesgo canceló durante el período.',
        formula: '(cancellations ÷ (openingActivePatients + newEnrollments)) × 100',
        source: 'Derivado.',
        anchor: 'Igual que las entradas.',
        gotchas: 'Se muestra como "—" cuando el denominador es 0.',
      },
      lastNewEnrollment: {
        label: 'Última inscripción',
        definition: 'Fecha del evento de inscripción más reciente.',
        formula: 'Timestamp máximo de inscripción durante el período.',
        source: 'Tabla de eventos de inscripción de BHI.',
        anchor: 'Timestamp del evento.',
      },
      lastCancellation: {
        label: 'Última cancelación',
        definition: 'Fecha del evento de cancelación más reciente.',
        formula: 'Timestamp máximo de cancelación durante el período.',
        source: 'Tabla de eventos de cancelación de BHI.',
        anchor: 'Timestamp del evento.',
      },
      accountsWithActivePatients: {
        label: 'Cuentas con activos',
        definition:
          'Cuántas cuentas de clientes tienen al menos un paciente activo al final del período.',
        formula: 'Recuento de cuentas donde closingActivePatients > 0.',
        source: 'Derivado.',
        anchor: 'Fin del período (to).',
      },
      accountsWithNewEnrollments: {
        label: 'Cuentas con nuevas',
        definition:
          'Cuántas cuentas de clientes tuvieron al menos una nueva inscripción durante el período.',
        formula: 'Recuento de cuentas donde newEnrollments > 0.',
        source: 'Derivado.',
        anchor: 'Timestamps de los eventos.',
      },
      accountsWithCancellations: {
        label: 'Cuentas con cancelaciones',
        definition:
          'Cuántas cuentas de clientes tuvieron al menos una cancelación durante el período.',
        formula: 'Recuento de cuentas donde cancellations > 0.',
        source: 'Derivado.',
        anchor: 'Timestamps de los eventos.',
      },
      accountsInScope: {
        label: 'Cuentas en alcance',
        definition:
          'Total de cuentas de clientes que el usuario actual tiene permiso para ver, sin importar su actividad.',
        formula: 'Recuento de cuentas permitidas.',
        source: 'Conjunto de permisos de cuenta.',
        anchor: 'En este momento.',
      },
      earliestEventTimestamp: {
        label: 'Evento más antiguo',
        definition:
          'El evento de inscripción de BHI más antiguo conocido para cualquier cuenta en alcance.',
        formula: 'Timestamp mínimo de evento entre todos los eventos en alcance.',
        source: 'Tablas de eventos de BHI.',
        anchor: 'Timestamp del evento.',
        gotchas:
          'Es null cuando la cuenta aún no tiene historial de BHI — el banner de historial entonces muestra "aún sin historial".',
      },
      patientFirstName: {
        label: 'Nombre',
        definition: 'Nombre de pila del paciente tal como consta en el registro demográfico.',
        formula: 'Campo directo.',
        source: 'Datos demográficos del paciente.',
      },
      patientLastName: {
        label: 'Apellido',
        definition: 'Apellido del paciente tal como consta en el registro demográfico.',
        formula: 'Campo directo.',
        source: 'Datos demográficos del paciente.',
      },
      mrn: {
        label: 'MRN',
        definition: 'Número de Historia Clínica (Medical Record Number).',
        formula: 'Campo directo.',
        source: 'Datos demográficos del paciente.',
      },
      enrollmentDate: {
        label: 'Fecha de inscripción',
        definition: 'Fecha en que el paciente fue inscrito en el programa BHI.',
        formula: 'Timestamp del evento de inscripción inicial.',
        source: 'Eventos de inscripción de BHI.',
      },
      currentStatus: {
        label: 'Estado',
        definition: 'Si este paciente está actualmente activo en BHI o ha sido cancelado.',
        formula:
          'Último evento de inscripción ≥ último evento de cancelación → activo, si no → cancelado.',
        source: 'Tabla de eventos de BHI (gana el último evento).',
        anchor: 'En este momento.',
      },
      statusEffectiveDate: {
        label: 'Vigencia del estado',
        definition: 'Timestamp del evento que estableció el estado actual.',
        formula: 'Max(última inscripción, última cancelación).',
        source: 'Eventos de BHI.',
      },
      cancellationDate: {
        label: 'Fecha de cancelación',
        definition: 'Fecha del evento de cancelación más reciente, si existe.',
        formula: 'Timestamp máximo de cancelación.',
        source: 'Eventos de cancelación de BHI.',
        gotchas: 'Null para pacientes que nunca fueron cancelados.',
      },
      lastBhiActivityDate: {
        label: 'Última actividad',
        definition:
          'Actividad de BHI más reciente para este paciente (inscripción, cancelación o contacto del programa).',
        formula: 'Timestamp máximo de evento para este paciente en las tablas de eventos de BHI.',
        source: 'Eventos de BHI.',
      },
      compareDeltas: {
        label: 'Deltas de comparación',
        definition:
          'Informe de comparación entre dos ventanas de fechas elegidas libremente, desglosado por cada métrica principal.',
        formula:
          'delta = current − baseline. Período anterior: la ventana desplazada hacia atrás según su propia duración de calendario. Mismo período del año pasado: fechas idénticas menos un año. Las celdas de cambio se colorean según la dirección de la métrica: deterioro en rojo, mejora en verde.',
        source: 'Dos respuestas de los mismos endpoints de resumen; calculado en el cliente.',
        anchor: 'Ambas ventanas se resuelven al momento de la solicitud.',
        gotchas:
          'Los deltas se suprimen cuando la ventana de comparación comienza antes del evento BHI más antiguo conocido, y se muestran como «—» cuando falta cualquiera de los dos lados.',
      },
      l1DerivedCancellationRate: {
        label: 'Cancelación % (cartera)',
        definition:
          'Tasa de cancelación a nivel de cartera mostrada en el informe de comparación de períodos. El resumen de cartera no incluye una tasa propia, así que se deriva en el cliente.',
        formula: 'cancellations ÷ (openingActivePatients + newEnrollments) × 100',
        source: 'Derivado de los agregados del resumen.',
        gotchas: 'Se muestra como «—» cuando el denominador es 0.',
      },
      exceptionNoNewEnrollments: {
        label: 'Sin nuevas inscripciones',
        definition: 'Cuentas sin nuevas inscripciones BHI en el período seleccionado.',
        formula: 'newEnrollments === 0',
        source:
          'Filtro del lado del servidor: la solicitud de resumen envía el id del preajuste en su parámetro exception.',
      },
      exceptionDeclining: {
        label: 'En declive',
        definition:
          'Cuentas cuyo número de pacientes activos disminuyó durante el período (más cancelaciones que nuevas inscripciones).',
        formula: 'netChange < 0',
        source:
          'Filtro del lado del servidor: la solicitud de resumen envía el id del preajuste en su parámetro exception.',
      },
      exceptionNoActivePatients: {
        label: 'Sin pacientes activos',
        definition: 'Cuentas sin nadie activo en BHI al final del período.',
        formula: 'closingActivePatients === 0',
        source:
          'Filtro del lado del servidor: la solicitud de resumen envía el id del preajuste en su parámetro exception.',
      },
      exceptionHighCancellationRate: {
        label: 'Cancelación alta',
        definition: 'Cuentas cuya tasa de cancelación alcanza o supera el umbral de alerta.',
        formula: 'cancellationRate ≥ 20',
        source:
          'Filtro del lado del servidor: la solicitud de resumen envía el id del preajuste en su parámetro exception.',
        gotchas:
          'El panel envía el umbral 20 de forma explícita (el valor por defecto del servidor también es 20) y el servidor devuelve el valor aplicado como cancellationRateThreshold. Hacerlo configurable por cuenta es un seguimiento planificado.',
      },
      exceptionNoActivity: {
        label: 'Sin actividad en el período',
        definition: 'Cuentas sin ningún movimiento de inscripción durante el período.',
        formula: 'newEnrollments === 0 AND cancellations === 0 AND netChange === 0',
        source:
          'Filtro del lado del servidor: la solicitud de resumen envía el id del preajuste en su parámetro exception.',
      },
    },
  },
  // Pestaña Resumen del panel del paciente. Traducción pendiente de
  // revisión por un hablante nativo: la terminología clínica puede
  // necesitar ajuste de tono.
  patientOverview: {
    needsAttention: 'Requiere atención',
    needsAttentionEmpty: 'No hay nada pendiente.',
    loadFailed: 'No se pudieron cargar algunos registros de este paciente.',

    alert: 'Alerta de riesgo inminente sin confirmar',
    alertMany: '{{count}} alertas de riesgo inminente sin confirmar',
    alertDetail: 'Generada {{age}}',
    alertDetailNoDate: 'Sigue abierta.',
    alertAction: 'Ver alertas',

    declinedAssessment: 'El paciente rechazó una evaluación',
    declinedAssessmentMany: 'El paciente rechazó {{count}} evaluaciones',
    declinedAssessmentDetail: '{{subject}}, {{age}}',
    declinedAssessmentDetailNoDate: '{{subject}}',
    declinedAssessmentAction: 'Abrir evaluaciones',

    awaitingReview: 'Informe pendiente de un proveedor',
    awaitingReviewMany: '{{count}} informes pendientes de un proveedor',
    awaitingReviewDetail: '{{subject}}, completada {{age}}',
    awaitingReviewDetailNoDate: '{{subject}}',
    awaitingReviewAction: 'Abrir informe',
    awaitingReviewActionMany: 'Abrir evaluaciones',

    unopenedInvitation: 'Invitación a la evaluación sin abrir',
    unopenedInvitationMany: '{{count}} invitaciones a evaluaciones sin abrir',
    unopenedInvitationDetail: '{{subject}}, enviada {{age}}',
    unopenedInvitationDetailNoDate: '{{subject}}',
    unopenedInvitationAction: 'Abrir evaluaciones',

    abandonedAssessment: 'Evaluación empezada y sin terminar',
    abandonedAssessmentMany: '{{count}} evaluaciones empezadas y sin terminar',
    abandonedAssessmentDetail: '{{subject}}, enviada {{age}}',
    abandonedAssessmentDetailNoDate: '{{subject}}',
    abandonedAssessmentAction: 'Abrir evaluaciones',

    unopenedResource: 'Recurso sin abrir',
    unopenedResourceMany: '{{count}} recursos sin abrir',
    unopenedResourceDetail: '{{subject}}, enviado {{age}}',
    unopenedResourceDetailNoDate: '{{subject}}',
    unopenedResourceAction: 'Abrir recursos',

    overdueOrder: 'Pedido fuera de su fecha de entrega',
    overdueOrderMany: '{{count}} pedidos fuera de su fecha de entrega',
    overdueOrderDetail: 'Previsto para {{date}}, {{late}}',
    overdueOrderDetailNoDate: 'Previsto para {{date}}',
    overdueOrderAction: 'Abrir pedidos',

    stalledStep: 'El programa dejó de avanzar',
    stalledStepDetail: '{{subject}}, previsto {{age}}',
    stalledStepDetailNoDate: '{{subject}}',
    stalledStepAction: 'Abrir programas',

    failedJourney: 'El programa falló',
    failedJourneyDetail: '{{subject}} se detuvo. {{reason}}',
    failedJourneyAction: 'Abrir programas',

    failedUpload: 'El informe no llegó al EHR',
    failedUploadMany: '{{count}} informes no llegaron al EHR',
    failedUploadDetail: '{{subject}}, {{age}}. {{reason}}',
    failedUploadDetailNoDate: '{{subject}}. {{reason}}',
    failedUploadAction: 'Abrir evaluaciones',

    reasonUnknown: 'No consta ningún motivo.',

    unreachable: 'No hay forma de contactar con este paciente',
    unreachableDetail: 'No consta ni correo ni teléfono.',
    unreachableOneChannel: 'Solo hay una forma de contactar con este paciente',
    unreachableSmsOff: 'Los mensajes de texto están desactivados.',
    unreachableEmailOff: 'El correo está desactivado.',
    unreachableAction: 'Abrir ficha',

    engagementPaused: 'La comunicación con el paciente está en pausa',
    engagementPausedDetail: 'En pausa desde {{age}}',
    engagementPausedWithReason: 'En pausa desde {{age}}: {{reason}}',
    engagementPausedDetailNoDate: 'En pausa',
    engagementPausedWithReasonNoDate: 'En pausa: {{reason}}',

    ageToday: 'hoy',
    ageYesterday: 'ayer',
    ageDays: 'hace {{count}} días',
    lateOneDay: '1 día de retraso',
    lateDays: '{{count}} días de retraso',

    clinicalSnapshot: 'Resumen clínico',
    firstReading: 'Primera medición',
    noChange: 'Sin cambios',
    wasValue: 'antes {{value}}',
    riskNeedsAttention: 'Requiere atención',
    riskMonitor: 'Vigilar',
    riskClear: 'Sin riesgos detectados',
    scoredOn: 'Puntuada el {{date}}',
    riskNotScored: 'Sin puntuación de riesgo: {{subject}}',
    riskNoAssessment: 'Ninguna evaluación completada.',
    riskThisAssessment: 'La última evaluación',

    timeline: 'Cronología del paciente',
    timelineEmpty: 'Todavía no hay eventos.',
    timelineViewAll: 'Ver la cronología completa',
    timelineCaveat:
      'Muestra lo que pasó con los registros, no quién lo hizo. Los cambios en la ficha del paciente no se registran.',

    eventAssessmentOrdered: 'Evaluación creada',
    eventAssessmentInvited: 'Invitación enviada',
    eventAssessmentOpened: 'Evaluación abierta',
    eventAssessmentCompleted: 'Evaluación completada',
    eventAssessmentAccepted: 'Resultados aceptados por un proveedor',
    eventAssessmentUploadedToEhr: 'Informe cargado en el EHR',
    eventAssessmentEhrUploadFailed: 'Error al subir al EHR',
    eventAssessmentCanceled: 'Evaluación cancelada',
    eventAssessmentNoShow: 'Marcada como ausencia',
    eventResourceSent: 'Recurso enviado',
    eventResourceEngaged: 'Recurso abierto',
    eventOrderPlaced: 'Pedido realizado',
    eventProgramStarted: 'Programa iniciado',
    eventProgramStepCompleted: 'Paso del programa finalizado',
    eventProgramPaused: 'Programa en pausa',
    eventProgramCompleted: 'Programa completado',
    eventEngagementChanged: 'Cambió la comunicación con el paciente',
    eventBhiEnrolled: 'Inscrito en BHI',
    eventBhiCancelled: 'Inscripción en BHI cancelada',

    eventStatusAssessmentOrdered: 'Creada',
    eventStatusAssessmentInvited: 'Invitada',
    eventStatusAssessmentOpened: 'Abierta',
    eventStatusAssessmentCompleted: 'Completada',
    eventStatusAssessmentAccepted: 'Aceptada',
    eventStatusAssessmentUploadedToEhr: 'E-Transfer',
    eventStatusAssessmentEhrUploadFailed: 'Error de carga',
    eventStatusAssessmentCanceled: 'Cancelada',
    eventStatusAssessmentNoShow: 'No asistió',
    eventStatusResourceSent: 'Enviado',
    eventStatusResourceEngaged: 'Abierto',
    eventStatusOrderPlaced: 'Realizado',
    eventStatusProgramStarted: 'Iniciado',
    eventStatusProgramStepCompleted: 'Paso completado',
    eventStatusProgramPaused: 'En pausa',
    eventStatusProgramCompleted: 'Completado',
    eventStatusEngagementChanged: 'Modificada',
    eventStatusBhiEnrolled: 'Inscrito',
    eventStatusBhiCancelled: 'Cancelada',

    eventGroupAssessment: 'Evaluaciones',
    eventGroupResource: 'Recursos',
    eventGroupOrder: 'Pedidos',
    eventGroupProgram: 'Programas',
    eventGroupEngagement: 'Interacción',
    eventGroupBhi: 'BHI',
    eventGroupOther: 'Otros',

    bhi: 'Integración de salud conductual (BHI)',
    bhiActive: 'Inscrito',
    bhiCancelled: 'Cancelada',
    bhiEnrolledSince: 'Inscrito el {{date}}',
    bhiCancelledOn: 'Cancelada el {{date}}',
    bhiNoDate: 'Sin fecha registrada',
    bhiNoHistory: 'No constan fechas de inscripción.',
    bhiLastActivity: 'Última actividad el {{date}}',
    bhiNoActivity: 'Sin actividad registrada',
    bhiReason: 'Motivo',
    bhiMismatch: 'La ficha y los eventos no coinciden; las fechas siguen a los eventos.',

    patientRecord: 'Expediente del paciente',
    contactAndCare: 'Contacto y atención',
    activeProgram: 'Programa activo',
    noActiveProgram: 'Sin programa.',
    channelEmail: 'Correo electrónico',
    channelSms: 'Mensaje de texto',
    channelOptedOut: 'Baja',
    insuranceFromAssessment: 'De la evaluación del {{date}}',
    programStep: 'Paso {{current}} de {{total}}',
  },
  journeys: {
    patientJourneysTab: 'Programas de pacientes',
    journeyProgramsTab: 'Plantillas de programa',
    // lista
    colAccount: 'Cuenta',
    colPatient: 'Paciente',
    colProgram: 'Plantilla',
    colStatus: 'Estado',
    colStarted: 'Iniciado',
    colCompleted: 'Completado',
    filterStatus: 'Estado',
    filterProgram: 'Plantilla',
    allStatuses: 'Todos los estados',
    allPrograms: 'Todas las plantillas',
    listEmpty: 'Aún no hay programas. Inicia uno desde una plantilla publicada.',
    noPatientsFound: 'No se encontraron pacientes',
    searchingPatients: 'Buscando…',
    searchFirstName: 'Nombre',
    searchLastName: 'Apellido',
    searchMrn: 'MRN',
    colMrn: 'MRN',
    colDob: 'Fecha de nacimiento',
    // Start program panel (patient dashboard and Programs page)
    startStepPatient: 'Paciente',
    startStepChoose: 'Elegir',
    startStepReview: 'Revisar',
    startChoosePatientTitle: 'Elija un paciente',
    startChooseProgramTitle: 'Elija un programa',
    startReviewTitle: 'Revisar e iniciar',
    startChooseProgramSubtitle: 'Elija el programa que seguirá el paciente.',
    startReviewSubtitle: 'Revise el programa y sus pasos, luego inícielo.',
    startSearchPrograms: 'Buscar programas',
    startProgramsLabel: 'programas',
    startStepsCount: '{{count}} pasos',
    startOneStep: '1 paso',
    startChange: 'Cambiar',
    startChooseHint: 'Al seleccionar un programa pasará al paso de revisión.',
    startNoPrograms: 'Esta cuenta aún no tiene programas publicados disponibles.',
    startJourney: 'Iniciar programa',
    // etiquetas de ciclo de vida
    running: 'En curso',
    paused: 'En pausa',
    completed: 'Completado',
    failed: 'Fallido',
    // estados de paso
    stepPending: 'Pendiente',
    stepWaiting: 'En espera',
    stepActive: 'Activo',
    stepCompleted: 'Completado',
    stepSkipped: 'Omitido',
    stepFailed: 'Fallido',
    stepTimedOut: 'Tiempo agotado',
    // diálogo de inicio
    startDialogTitle: 'Iniciar un programa',
    startDialogSubtitle: 'El primer paso se envía al paciente de inmediato.',
    patientLabel: 'Paciente',
    programLabel: 'Plantilla',
    startBtn: 'Iniciar',
    started: 'Programa iniciado — el primer paso se envió al paciente.',
    // panel lateral
    progressLabel: 'Progreso',
    currentStepLabel: 'Paso actual',
    openAsset: 'Abrir {{assetType}}',
    expiresIn: 'Expira {{date}}',
    waitingCopy: 'Esperando a que el paciente complete este paso.',
    scheduledCopy: 'Programado: el siguiente paso se enviará el {{date}}.',
    scheduledStep: 'Se envía {{date}}',
    failedCopy:
      'Este programa falló y no puede continuar. Contacta con soporte si necesitas restaurarlo.',
    pausedCopy: 'Este programa está en pausa.',
    completedCopy: 'Este programa está completado.',
    pause: 'Pausar',
    resume: 'Reanudar',
    skipStep: 'Omitir paso',
    retryStep: 'Reintentar paso',
    reasonLabel: 'Motivo (opcional)',
    confirmBtn: 'Confirmar',
    pauseConfirmTitle: '¿Pausar este programa?',
    pauseConfirmBody: 'El temporizador del paso actual se cancela hasta que reanudes.',
    skipConfirmTitle: '¿Omitir el paso actual?',
    skipConfirmBody: 'El programa avanza por la ruta predeterminada. Esto no se puede deshacer.',
    retryConfirmTitle: '¿Reintentar el paso actual?',
    retryConfirmBody:
      'La acción del paso se envía de nuevo. El paciente puede recibir una nueva copia.',
    retryNewInstance: 'Se envió una nueva instancia al paciente.',
    // pestaña de programas
    colName: 'Nombre',
    colVersion: 'Versión',
    colSource: 'Origen',
    colSteps: 'Pasos',
    sourceGlobal: 'Global',
    sourceAccount: 'Esta cuenta',
    statusDraft: 'Borrador',
    statusPublished: 'Publicado',
    statusArchived: 'Archivado',
    draftNotOfferable: 'Publíquela para ofrecerla a las cuentas e inscribir pacientes en ella.',
    createProgram: 'Crear plantilla',
    seedMetabolic: 'Configurar Metabolic Lessons',
    seedDone: 'La plantilla Metabolic Lessons está lista. Publícala para iniciar programas.',
    edit: 'Editar',
    view: 'Ver',
    publish: 'Publicar',
    publishConfirmTitle: '¿Publicar esta plantilla?',
    publishConfirmBody:
      'Las plantillas publicadas quedan bloqueadas y ya no se pueden editar. Después se puede inscribir a los pacientes.',
    published: 'Plantilla publicada.',
    delete: 'Eliminar',
    deleteConfirmTitle: '¿Eliminar esta plantilla?',
    deleteConfirmBody:
      'El borrador y sus pasos se eliminan de forma permanente. Esta acción no se puede deshacer.',
    deleted: 'Plantilla eliminada.',
    deleteOnlyDrafts:
      'Solo se puede eliminar un borrador. Las plantillas publicadas pueden tener programas en curso.',
    deleteNotOwned: 'Esta plantilla pertenece a otra cuenta y no se puede eliminar aquí.',
    deleteNotDraft: 'Solo se puede eliminar un borrador. Esta plantilla ya se ha publicado.',
    deleteHasJourneys:
      'Esta plantilla no se puede eliminar: ya se han iniciado programas a partir de ella. Esto sigue siendo así aunque esos programas terminen.',
    programsEmpty: 'Aún no hay plantillas. Crea una o configura Metabolic Lessons.',
    // editor
    backToPrograms: 'Volver a Plantillas de programa',
    builderSubtitle:
      'Define la secuencia de pasos que sigue el paciente. Cada paso envía una evaluación, un recurso o un video y puede esperar a que se complete.',
    stepsSectionTitle: 'Pasos',
    stepsSectionSubtitle:
      'Los pasos se ejecutan en orden, de arriba abajo. Cada paso indica cuándo se envía, qué envía y si el programa espera al paciente antes de continuar.',
    builderCreateTitle: 'Crear plantilla de programa',
    builderEditTitle: 'Editar plantilla de programa',
    builderViewTitle: 'Plantilla de programa',
    programDescriptionLabel: 'Descripción',
    programDescriptionHelper:
      'Opcional. Se muestra al personal donde se lista el programa y al iniciarlo para un paciente. {{count}} de {{max}} caracteres.',
    programDescriptionTooLong: 'La descripción puede tener hasta {{max}} caracteres.',
    programNameLabel: 'Nombre de la plantilla',
    stepNameLabel: 'Nombre del paso',
    actionLabel: 'Acción',
    actionSendSurvey: 'Enviar evaluación',
    actionSendVideo: 'Enviar video',
    actionSendAudio: 'Enviar audio',
    actionSendArticle: 'Enviar artículo',
    // Program panel, step rows: the column caption over the one badge
    // (what the patient did with the item), the badge for a sent
    // resource / video, the engine's "waiting" as a plain phrase, and
    // the kind of each step's item.
    stepsPatientColumn: 'Paciente',
    stepSent: 'Enviado',
    stepWaitingForPatient: 'Esperando al paciente',
    stepKindVideo: 'Vídeo',
    stepKindAudio: 'Audio',
    stepKindArticle: 'Artículo',
    assetSurveyLabel: 'Evaluación',
    assetResourceLabel: 'Recurso',
    // Tarjeta de paso. Cada paso se lee como tres frases, Cuándo / Enviar /
    // Después, y la cabecera plegada las repite en una línea.
    templateSectionTitle: 'Datos de la plantilla',
    templateSectionDesc:
      'El nombre y la descripción que ve el personal donde se lista la plantilla.',
    stepFallbackName: 'Paso {{n}}',
    collapseStep: 'Plegar paso',
    expandStep: 'Desplegar paso',
    whenLabel: 'Cuándo',
    sendLabel: 'Enviar',
    thenLabel: 'Después',
    whenRightAway: 'De inmediato',
    whenAfterDelay: 'Tras un retraso',
    whenProgramStarts: 'cuando empieza el programa',
    whenPrevFinishes: 'en cuanto termina el paso anterior',
    whenAfterPrev: 'después de que termine el paso anterior',
    whenAfterStart: 'después de que empiece el programa',
    unitDays: 'días',
    unitHours: 'horas',
    thenNext: 'Ir al siguiente paso',
    thenWait: 'Esperar a que se complete',
    thenNextHint: 'El siguiente paso se envía en cuanto se envía este.',
    thenWithin: 'Si no se completa en',
    thenWaitHint:
      'El paciente tiene {{duration}} para completarlo; después, el programa {{outcome}}.',
    thenWaitNoLimitHint:
      'Sin límite de tiempo: el programa espera hasta que el paciente complete este paso. Indica días u horas para añadir uno.',
    onTimeoutSkip: 'omitirá este paso',
    onTimeoutFail: 'fallará',
    onTimeoutEscalate: 'escalará',
    resourceWaitHint:
      'Cualquier interacción del paciente con un recurso avanza este paso — la coincidencia por recurso específico aún no está disponible.',
    // Cabecera plegada: "Evaluación: Control semanal · se envía 7 días
    // después del paso anterior · espera hasta 3 días y luego omitirá este paso".
    summaryNoAsset: 'sin elemento elegido',
    summaryStart: 'se envía cuando empieza el programa',
    summaryRightAway: 'se envía justo después del paso anterior',
    summaryAfterDelay: 'se envía {{duration}} después del paso anterior',
    summaryAfterStart: 'se envía {{duration}} después del inicio del programa',
    summaryNext: 'el siguiente paso sigue de inmediato',
    summaryWait: 'espera a que se complete',
    summaryWaitLimit: 'espera hasta {{duration}} y luego {{outcome}}',
    // Línea de tiempo: el día en que se llega a cada paso y lo que hay
    // entre dos pasos.
    dayLabel: 'Día',
    dayStartLabel: 'inicio',
    gapRightAway: 'de inmediato',
    gapAfterFinishes: 'en cuanto termina el paso {{n}}',
    gapWaitAfter: 'después de que termine el paso {{n}}, espera {{duration}}',
    lengthSameDay: 'todo el primer día',
    lengthOpen: 'duración según el paciente',
    lengthDays: 'unos {{count}} días',
    lengthAtLeastDays: 'al menos {{count}} días',
    durationDay: '1 día',
    durationDays: '{{count}} días',
    durationHour: '1 hora',
    durationHours: '{{count}} horas',
    durationShortDays: '{{count}}d',
    durationShortHours: '{{count}}h',
    sendAfterTooShort: 'El retraso es de al menos 1 hora.',
    sendAfterTooLong: 'El retraso es de 365 días como máximo.',
    sendAfterInvalid: 'Revisa los retrasos de los pasos: mínimo 1 hora, máximo 365 días.',
    waitTooLong: 'La espera es de 365 días como máximo.',
    waitInvalid: 'Revisa las esperas de los pasos: máximo 365 días.',
    addStep: 'Añadir paso',
    removeStep: 'Eliminar paso',
    duplicateStep: 'Duplicar paso',
    moveUp: 'Mover arriba',
    moveDown: 'Mover abajo',
    createProgramBtn: 'Crear plantilla',
    saveChanges: 'Guardar cambios',
    draftSaved: 'Borrador guardado.',
    notLinearWarning:
      'Esta plantilla usa ramificaciones y aquí solo se puede ver. Edítala a través de la API.',
    atLeastOneStep: 'Añade al menos un paso.',
    fieldsRequired: 'Cada paso necesita un nombre y un recurso asignado.',
    // errores (mapeados vía getJourneyErrorKey)
    alreadyEnrolled: 'Este paciente ya está inscrito en este programa.',
    programNotAvailable: 'Esta plantilla no está disponible para iniciar.',
    programLocked:
      'Esta plantilla no se puede editar — las plantillas publicadas están bloqueadas.',
    programInvalid: 'La plantilla no pasó la validación. Revisa los pasos e inténtalo de nuevo.',
    programNotFound: 'Plantilla no encontrada.',
    actionNotAllowed: 'Esta acción no está disponible en el estado actual del programa.',
    viewAssessmentReport: 'Ver informe de la evaluación',
    journeyNotFound: 'Programa no encontrado.',
    concurrentChange: 'El programa cambió en segundo plano. La vista se ha actualizado.',
    genericError: 'Algo salió mal. Por favor, inténtalo de nuevo.',
  },
  // Matches en.js `assessmentDecline` — labels only; wire reasonCode
  // values stay English (see declineReasons.js).
  assessmentDecline: {
    title: 'Rechazar evaluación',
    subtitle: 'Selecciona el motivo por el que el paciente rechazó esta evaluación.',
    reasonDeclinedToday: 'Rechazada hoy',
    reasonNoTime: 'Sin tiempo',
    reasonTooFrequent: 'Las evaluaciones son demasiado frecuentes',
    reasonNotRelevant: 'La evaluación no es relevante',
    reasonPrivacyConcerns: 'Preocupaciones de privacidad',
    reasonPermanentRemoval:
      'El paciente solicitó la eliminación permanente de las comunicaciones de QHS',
    reasonOther: 'Otro',
    managerOnlyHint: 'Requiere permiso de gerente',
    otherLabel: 'Describe el motivo',
    otherHint: 'Entre 3 y 500 caracteres.',
    reasonRequired: 'Selecciona un motivo de rechazo.',
    confirmBtn: 'Rechazar',
  },
  claimsManager: {
    common: {
      activeBadge: 'Activa',
      unmappedTitle: 'Faltan en la configuración ISP: {{codes}}.',
      unmappedCptSingular: '{{count}} CPT no mapeado',
      unmappedCptPlural: '{{count}} CPT no mapeados',
      idPrefix: 'ID',
      dash: '—',
    },
    filters: {
      quickRangeLabel: 'Rango rápido',
      customRangeLabel: 'Rango personalizado',
      presetPreviousMonth: 'Mes anterior',
      presetCurrentMonth: 'Mes actual',
      presetPreviousQuarter: 'Trimestre anterior',
      presetCurrentQuarter: 'Trimestre actual',
      presetLast90Days: 'Últimos 90 días',
      presetYtd: 'Año en curso',
      presetCustom: 'Personalizado',
      applyPresetPlaceholder: 'Aplicar preajuste…',
      pickDatesPlaceholder: 'Seleccionar fechas',
      cptLabel: 'Códigos CPT',
      cptAllPlaceholder: 'Todos los CPT',
      cptSearchPlaceholder: 'Buscar códigos CPT',
      cptSelectedCount: '{{count}} seleccionados',
      cptNoResults: 'No se encontraron códigos CPT',
    },
    export: {
      csvBtn: 'Exportar CSV',
      xlsxBtn: 'Exportar xlsx',
    },
    help: {
      buttonLabel: 'Cómo se calcula',
      modalAriaLabel: 'Cómo se calculan las cifras del Gestor de reclamaciones',
      genericTitle: 'Cómo se calcula',
      gotItBtn: 'Entendido',
      l1Title: 'Gestor de reclamaciones — Cartera',
      l1Subtitle:
        'Qué significa cada columna e indicador de esta página y cómo lo calcula el backend.',
      l2Title: 'Gestor de reclamaciones — Detalle de cuenta',
      l2Subtitle:
        'Qué significa cada indicador y columna de CPT Mix en esta página y cómo lo calcula el backend.',
      l3Title: 'Gestor de reclamaciones — Detalle de CPT',
      l3Subtitle:
        'Qué significa cada columna e indicador de esta página y cómo lo calcula el backend.',
      sectionGlobalConventions: 'Convenciones globales',
      sectionAttentionBadges: 'Distintivos de atención',
      sectionFieldsOnThisPage: 'Campos de esta página',
      sectionAlsoWorthKnowing: 'Más información útil',
      metaSource: 'Fuente',
      metaFormula: 'Fórmula',
      metaAnchor: 'Ancla',
      metaNotes: 'Notas',
    },
    globalConventions: {
      period: {
        label: 'Filtro de período',
        text: 'Días naturales inclusivos, interpretados como UTC — [desde 00:00 UTC hasta 23:59:59 UTC].',
      },
      inScope: {
        label: 'Cuenta "en alcance"',
        text: 'Activa (no eliminada, no deshabilitada) Y con gestión de reclamaciones habilitada Y dentro de su conjunto de cuentas permitidas.',
      },
      softDeleted: {
        label: 'Filas eliminadas de forma lógica',
        text: 'Excluidas en todas partes — reclamaciones, notificables e informes.',
      },
      cptFilter: {
        label: 'Filtro de CPT',
        text: 'Cuando se aplica un filtro de CPT, todas las cifras se recalculan para incluir únicamente los códigos seleccionados. Las comprobaciones de integridad de datos son la única excepción (ignoran el filtro — véase la columna de atención).',
      },
      timeDrift: {
        label: 'Las cifras de pago siguen actualizándose',
        text: 'Los conteos y montos que dependen de los pagos del seguro reflejan el último estado conocido del trabajo del período — se siguen moviendo a medida que se contabilizan los pagos. Volver a ejecutar el informe de julio en octubre mostrará más reclamaciones pagadas que el 1 de agosto. Esto es normal.',
      },
    },
    badges: {
      unmappedBadge: {
        label: 'Círculo naranja con un número',
        text: 'Número de códigos CPT presentes en las reclamaciones de esta cuenta que no tienen precio en su configuración ISP. Problema de configuración para operaciones (añadir los precios faltantes); mientras sea > 0, los totales monetarios de esta cuenta están subestimados.',
      },
      attentionBadge: {
        label: 'Círculo rojo con "!"',
        text: 'Una o más comprobaciones de integridad de datos se activaron — CPT pagado sin notificable, filas duplicadas, notificables huérfanos o un informe de reclamación que referencia un notificable inexistente. Pase el cursor sobre el distintivo para ver los motivos exactos. Revise antes de facturar.',
      },
    },
    crossLevelNote:
      'Los campos con el mismo nombre coinciden al céntimo en L1 / L2 / L3 cuando se envían el mismo rango de fechas y el mismo filtro de CPT. La summaryRow de L2 la produce el mismo código de agregación que su fila de L1, solo que limitado a una cuenta. Si una solicitud de detalle omite el filtro que tenía la tabla, las cifras diferirán con razón — mantenga siempre los filtros activos al profundizar.',
    workedExample: {
      title: 'Ejemplo trabajado — Reconocido vs. Facturable',
      body: 'T3 2026, Mercy Health Partners: `qhsRevenueFromReportables = $21,420` significa que QHS registró 21 elementos facturables entre el 1 de julio y el 30 de septiembre con un precio promedio (snapshot) de $1,020. Seis de esos facturables pertenecen a reclamaciones generadas en junio — se contabilizan en el T3 porque es cuando QHS los reconoció. Mientras tanto, `qhsInvoiceBasis = $19,800` valora únicamente el trabajo de reclamaciones del propio T3 a los precios actuales — las dos columnas responden a "¿qué reconocimos?" frente a "¿cuánto ganó el trabajo de este trimestre?".',
    },
    l1: {
      pageSubtitle:
        'Rendimiento financiero a nivel de cartera en todas las cuentas de clientes. Persiga CPT no mapeados, notificables faltantes y facturas estancadas.',
      pickDateRangeTitle: 'Seleccione un rango de fechas',
      pickDateRangeHint:
        'Use el chip Rango rápido o Rango personalizado de arriba para establecer la ventana de la cartera.',
      hintInScope: '{{count}} en alcance',
      hintActive: '{{count}} activas',
      hintPaidClaims: '{{count}} reclamaciones pagadas',
      tableTitle: 'Gestor de reclamaciones',
      backAriaLabel: 'Volver a {{title}}',
      nonDs: {
        accountFallback: 'Su cuenta',
        opsClaims: 'Reclamaciones',
        opsPaid: 'Pagadas',
        opsPatients: 'Pacientes',
        opsReports: 'Informes',
        opsAvgPaid: 'Promedio $/Pagada',
        opsLastClaim: 'Última reclamación',
        viewCptBreakdownBtn: 'Ver desglose de CPT',
        unmappedNoteLeadSingular: '{{count}} CPT no mapeado:',
        unmappedNoteLeadPlural: '{{count}} CPT no mapeados:',
        unmappedNoteTailSingular:
          '— sin precio ISP, por lo que los totales monetarios de arriba están subestimados. Solicite a operaciones que añada el precio faltante.',
        unmappedNoteTailPlural:
          '— sin precio ISP, por lo que los totales monetarios de arriba están subestimados. Solicite a operaciones que añada los precios faltantes.',
        unmappedNoteNoCodes:
          'sin precio ISP — los totales monetarios de arriba están subestimados.',
      },
    },
    l2: {
      pageSubtitle:
        'Desglose financiero a nivel de cuenta. Haga clic en una fila de CPT con precio para ver qué aseguradoras lo reembolsaron, y luego en una aseguradora para ver sus líneas de reclamación.',
      tableTitle: 'CPT Mix',
      unmappedNoteHeadSingular: '{{count}} CPT no mapeado no mostrado abajo:',
      unmappedNoteHeadPlural: '{{count}} CPT no mapeados no mostrados abajo:',
      unmappedNoteTailSingular:
        '— sin precio ISP, por lo que no puede agregarse. Solicite a operaciones que añada el precio faltante.',
      unmappedNoteTailPlural:
        '— sin precio ISP, por lo que no pueden agregarse. Solicite a operaciones que añada los precios faltantes.',
      unmappedNoteNoCodes: 'sin precio ISP, por lo que la agregación no es posible.',
    },
    l3: {
      pageSubtitleWithAccount:
        'Cada reclamación en {{account}} que incluyó este CPT durante el período seleccionado.',
      pageSubtitleNoAccount:
        'Cada reclamación en la cuenta objetivo que incluyó este CPT durante el período seleccionado.',
      accountFallback: 'Detalle de cuenta',
      tableTitle: 'Reclamaciones de respaldo',
      cptPrefix: 'CPT',
      unmappedNoIspBadge: 'No mapeado (sin precio ISP)',
      ispPriceBadge: 'ISP ${{price}}',
      claimsCountBadgeSingular: '{{count}} reclamación',
      claimsCountBadgePlural: '{{count}} reclamaciones',
      ispLockedHint: 'Precio ISP fijado en ${{price}}.',
      ispNotPricedHint: 'Sin precio en la configuración ISP — totales monetarios ocultos.',
      insurancesTableTitle: 'Aseguradoras',
      insurancesSubtitleWithAccount:
        'Quién pagó este CPT en {{account}} durante el período seleccionado, una fila por aseguradora. Haz clic en una aseguradora para ver sus líneas de reclamación.',
      insurancesSubtitleNoAccount:
        'Quién pagó este CPT en la cuenta objetivo durante el período seleccionado, una fila por aseguradora.',
      claimsForPayerSubtitle:
        'Cada línea de reclamación en {{account}} de este CPT pagada por {{payer}} durante el período seleccionado.',
      unknownPayer: 'Desconocida',
      payersCountBadgeSingular: '{{count}} aseguradora',
      payersCountBadgePlural: '{{count}} aseguradoras',
      backToPayersAria: 'Volver a aseguradoras',
    },
    kpis: {
      reimbursement: 'Reembolso',
      invoicable: 'Facturable',
      recognized: 'Reconocido',
      invoicablePercent: 'Facturable %',
      claims: 'Reclamaciones',
      paid: 'Pagadas',
      ispPrice: 'Precio ISP',
      totalPaid: 'Total pagado',
    },
    columns: {
      account: 'Cuenta',
      customId: 'ID personalizado',
      claims: 'Reclamaciones',
      paid: 'Pagadas',
      patients: 'Pacientes',
      totalCpts: 'CPT totales',
      cptsPaid: 'CPT pagados',
      reimbursement: 'Reembolso',
      invoicable: 'Facturable',
      recognized: 'Reconocido',
      patientResponsibility: 'Responsabilidad del paciente',
      invPercent: 'Fact. %',
      avgPaid: 'Promedio $/Pagada',
      reports: 'Informes',
      lastClaim: 'Última reclamación',
      unmappedCpts: 'CPT no mapeados',
      cptHcpcs: 'CPT / HCPCS',
      ispPrice: 'Precio ISP',
      countClaims: 'Conteo (Reclamaciones)',
      countReportables: 'Conteo (Notificables)',
      providerOweUs: 'Proveedor nos debe',
      providerGain: 'Ganancia del proveedor',
      firstName: 'Nombre',
      lastName: 'Apellido',
      dos: 'DOS',
      cptStatus: 'Estado del CPT',
      price: 'Precio',
      claimGenerated: 'Reclamación generada',
      insurance: 'Aseguradora',
      unknownInsurance: 'Desconocida',
      lines: 'Líneas',
      paidLines: 'Líneas pagadas',
      avgPaidPerPaidLine: 'Promedio pagado / línea pagada',
    },
    cptStatus: {
      notProcessed: 'No procesado',
      paid: 'Pagado',
      partiallyPaid: 'Pagado parcialmente',
      billed: 'Facturado',
      inProcess: 'En proceso',
      pending: 'Pendiente',
      patientResponsibility: 'Responsabilidad del paciente',
      patientResponsibilityShort: 'Resp. paciente',
      denied: 'Denegado',
      resubmitted: 'Reenviado',
      notBillable: 'No facturable',
      unmapped: 'No mapeado',
    },
    dictionary: {
      totalClaims: {
        label: 'Reclamaciones',
        definition: 'Número de reclamaciones creadas para esta cuenta durante el período.',
        source: 'Tabla de reclamaciones.',
        formula:
          'Conteo de reclamaciones (con el filtro de CPT aplicado, una reclamación solo cuenta si incluye al menos un ítem de línea con un código seleccionado).',
        anchor: 'Reclamación generada.',
        gotchas: 'Se excluyen las reclamaciones eliminadas.',
      },
      paidClaimCount: {
        label: 'Pagadas',
        definition: 'Cuántas de esas reclamaciones han recibido al menos un pago del seguro.',
        source: 'Reclamaciones + sus ítems de línea de CPT (pagos).',
        formula:
          'Conteo de reclamaciones con ≥ 1 ítem de línea cuyo importe pagado > 0 (respetando el filtro de CPT si está definido).',
        anchor: 'Reclamación generada — NO fecha de pago.',
        gotchas:
          'Una reclamación generada en julio pero pagada en septiembre sigue contando para julio — y solo aparece aquí cuando el pago se contabiliza. Este número crece con el tiempo para un período fijo.',
      },
      patientsWithActivity: {
        label: 'Pacientes',
        definition: 'Número de pacientes únicos detrás de las reclamaciones del período.',
        source: 'Tabla de reclamaciones.',
        formula: 'Conteo distinto de pacientes en las reclamaciones contadas.',
        anchor: 'Reclamación generada.',
        gotchas:
          'Un paciente con 5 reclamaciones cuenta una vez. Respeta el filtro de CPT a través de las reclamaciones que conserva.',
      },
      insurancePaidToProvider: {
        label: 'Reembolso',
        definition:
          'Total en dólares que el seguro ha pagado a la práctica por el trabajo de reclamaciones del período.',
        source: 'Importes pagados en los ítems de línea de las reclamaciones.',
        formula:
          'Suma de `paid` en los ítems de línea cubiertos por ISP en las reclamaciones generadas en el período.',
        anchor: 'Reclamación generada (NO fecha de pago); montos actualizados.',
        gotchas:
          'Los pagos de códigos CPT no mapeados se excluyen de este total (el mismo universo que las cifras de QHS). Crece con el tiempo a medida que se contabilizan los pagos.',
      },
      qhsInvoiceBasis: {
        label: 'Facturable',
        definition:
          'Lo que QHS podría facturar hoy a esta cuenta, a los precios contractuales actuales, por el trabajo de reclamaciones del período.',
        source:
          'Lista de precios ISP de la cuenta (precios actuales en vivo) × ítems de línea de reclamaciones.',
        formula:
          'Suma del precio ISP actual de cada ítem de línea cubierto por ISP en las reclamaciones del período. Un precio por cada aparición del ítem.',
        anchor: 'Reclamación generada.',
        gotchas:
          'Usa el precio de hoy — si el precio de la cuenta para un código cambió a mitad del período, todo el período se valora al nuevo precio. Siempre se usa el Precio Regular (nunca el Precio Inicial de primera visita). Independiente de si ya existen pagos o facturas.',
      },
      qhsRevenueFromReportables: {
        label: 'Reconocido',
        definition:
          'Ingresos de QHS efectivamente asegurados durante el período — ítems facturables que QHS registró para facturación.',
        source:
          'Registro de notificables (una entrada por reclamación × CPT, creada cuando QHS reconoce un ítem facturable), cada uno con un snapshot de precio tomado al crearse.',
        formula: 'Suma del precio (snapshot) de los notificables creados en el período.',
        anchor:
          'Notificable registrado — NO reclamación generada. Un notificable registrado en julio para una reclamación de junio cuenta para julio.',
        gotchas:
          'El precio del snapshot es inmune a ediciones posteriores de precio (a diferencia del Potencial Facturable). Por eso las dos columnas de ingresos pueden diferir para el mismo trabajo.',
      },
      invoicablePercent: {
        label: 'Fact. %',
        definition:
          'Cuota de QHS: qué porción del reembolso del seguro del cliente podría facturar QHS.',
        source: 'Derivado.',
        formula: '(qhsInvoiceBasis ÷ insurancePaidToProvider) × 100, redondeado a 2 decimales.',
        anchor:
          'Igual que sus entradas — numerador sobre el trabajo realizado, denominador sobre los pagos recibidos hasta ahora.',
        gotchas:
          'Al inicio de un período el % parece inflado porque los pagos van con retraso. Se estabiliza a medida que se contabilizan los pagos. Se muestra como "—" (no 0 %) cuando el reembolso es cero.',
      },
      avgReimbursementPerPaidClaim: {
        label: 'Promedio $/Pagada',
        definition: 'Pago promedio del seguro por reclamación pagada.',
        source: 'Derivado.',
        formula: 'insurancePaidToProvider ÷ paidClaimCount, redondeado a 2 decimales.',
        anchor: 'Igual que sus entradas.',
        gotchas: 'Se muestra como "—" (no $0) cuando aún no se ha pagado ninguna reclamación.',
      },
      claimReportsIssued: {
        label: 'Informes',
        definition:
          'Número de informes de reclamaciones de QHS (paquetes de facturación) emitidos a esta cuenta durante el período.',
        source: 'Informes de reclamaciones.',
        formula: 'Conteo de informes de reclamaciones.',
        anchor: 'Informe emitido — tercera ancla distinta en la misma fila.',
        gotchas:
          'Con un filtro de CPT, solo cuentan los informes que contienen al menos un facturable con un código seleccionado.',
      },
      lastClaimGenerated: {
        label: 'Última reclamación',
        definition:
          'Fecha de la reclamación más reciente del período — una señal de "¿aún activo?".',
        source: 'Tabla de reclamaciones.',
        formula: 'Marca de tiempo máxima de generación entre las reclamaciones contadas.',
        anchor: 'Reclamación generada.',
      },
      unmappedCptCount: {
        label: 'CPT no mapeados',
        definition:
          'Número de códigos CPT distintos que aparecieron en las reclamaciones de esta cuenta pero no tienen precio en su configuración ISP.',
        source: 'Ítems de línea de reclamaciones × configuración ISP.',
        formula: 'Conteo distinto de códigos en los ítems de línea del período sin entrada ISP.',
        anchor: 'Reclamación generada.',
        gotchas:
          'Se comprueba contra la configuración ISP completa — un código que haya filtrado sigue estando "mapeado". Cuando > 0, los totales monetarios están subestimados: el distintivo de advertencia en la fila es una señal para que operaciones añada los precios faltantes. Los códigos concretos vienen aparte como `unmappedCptCodes` — véase esa entrada.',
      },
      unmappedCptCodes: {
        label: 'Códigos CPT no mapeados',
        definition:
          'Los códigos concretos a los que les falta un precio ISP — ordenados alfabéticamente. Mismo universo y filtros que `unmappedCptCount`; siempre se cumple `count === codes.length`.',
        source: 'Ítems de línea de reclamaciones × configuración ISP.',
        formula: 'Conjunto distinto de códigos en los ítems de línea del período sin entrada ISP.',
        anchor: 'Reclamación generada.',
        gotchas:
          'Array vacío (no null) cuando el conteo es cero. Use esta lista para indicar a operaciones exactamente qué códigos añadir a la configuración ISP de la cuenta.',
      },
      attentionReasons: {
        label: 'Atención',
        definition:
          'Problemas de integridad de datos encontrados en los datos del período de esta cuenta que deben revisarse antes de facturar. Vacío = limpio.',
        source:
          'Cinco sondas automatizadas sobre reclamaciones / notificables / informes de reclamaciones.',
        formula: [
          '"N CPT pagados sin notificable" — el seguro pagó un ítem de línea pero no se registró ningún facturable de QHS → QHS está dejando dinero sobre la mesa.',
          '"filas duplicadas" — la misma reclamación × CPT aparece más de una vez (actividades o notificables) → los totales pueden estar inflados.',
          '"notificables huérfanos" — existe un notificable sin un ítem de línea de reclamación que lo respalde.',
          '"informe de reclamación referencia notificable inexistente" — un informe emitido apunta a un facturable eliminado/inexistente.',
        ],
        anchor:
          'Cada sonda se ajusta al ancla de su propia capa (reclamaciones → reclamación generada; notificables → registrado; informes → emitido).',
        gotchas:
          'Ignora deliberadamente el filtro de CPT — un problema de integridad no desaparece porque el visor reduzca la vista. Los pagos lentos / bajo rendimiento intencionalmente NO se marcan (cadencia de pago normal).',
      },
      summaryTotals: {
        label: 'Totales de fila',
        definition:
          'Cada total de la fila de totales se calcula sumando sobre las filas devueltas — por lo que los totales siempre concuerdan con la tabla visible por construcción.',
        source: 'Las mismas filas que muestra la tabla.',
      },
      activeAccounts: {
        label: 'Cuentas activas',
        definition:
          'Número de filas en la tabla — cuentas en alcance con ≥ 1 reclamación generada en el período (respetando el filtro de CPT). Las cuentas con cero reclamaciones se ocultan.',
      },
      accountsInScope: {
        label: 'Cuentas en alcance',
        definition:
          'Todas las cuentas en alcance (gestión de reclamaciones habilitada + dentro de su conjunto permitido), independientemente de la actividad. `accountsInScope − activeAccounts` = cuentas sin actividad este período.',
      },
      summaryInvoicablePercent: {
        label: 'Facturable % de la fila de totales',
        definition:
          'Facturable total ÷ reembolso total (razón de las dos sumas, NO un promedio de los porcentajes por fila). Se muestra como "—" cuando el reembolso total es cero.',
      },
      ispPrice: {
        label: 'Precio ISP',
        definition: 'El precio contractual actual que QHS cobra a esta cuenta por este código CPT.',
        source: 'Configuración ISP de la cuenta (en vivo).',
        formula: 'Precio regular — nunca el InitialPrice de primera visita.',
        anchor: 'Ahora.',
        gotchas:
          'Los CPT de la configuración ISP sin actividad siguen apareciendo aquí (fila con todo en cero) — intencional, muestra los ítems del contrato sin usar. Los códigos presentes en reclamaciones pero NO en la configuración no aparecen aquí — se agrupan en unmappedCptCount.',
      },
      countFromClaims: {
        label: 'Conteo (Reclamaciones)',
        definition:
          'Ítems de línea con este código en reclamaciones generadas en el período (cualquier estado).',
        source: 'Ítems de línea de reclamaciones.',
        anchor: 'Reclamación generada.',
        gotchas:
          'Regla general: lado de reclamaciones = volumen de trabajo; lado de notificables = progreso de facturación.',
      },
      countFromReportables: {
        label: 'Conteo (Notificables)',
        definition: 'Facturables de QHS con este código registrados en el período.',
        source: 'Registro de notificables.',
        anchor: 'Notificable registrado.',
        gotchas:
          'Difiere de Conteo (Reclamaciones) porque (1) anclas distintas — el facturable de una reclamación de junio puede registrarse en julio; (2) no todos los ítems de línea producen un facturable (normalmente solo los pagados lo hacen); (3) un facturable eliminado lógicamente desaparece solo del lado de notificables. Una brecha persistente y grande = los facturables no se están registrando → aparece como "CPT pagados sin notificable" en la señal de atención.',
      },
      totalProviderOweUs: {
        label: 'Proveedor nos debe',
        definition:
          'Lo que QHS facturaría por el volumen del período de este código al precio actual.',
        source: 'Derivado.',
        formula: 'countFromReportables × ispPrice.',
        anchor: 'Reportable emitido.',
      },
      providerGain: {
        label: 'Ganancia del proveedor',
        definition: 'Lo que la práctica ha ganado del seguro por este código hasta ahora.',
        source: 'Importes pagados en los ítems de línea de las reclamaciones.',
        formula:
          'Suma de `paid` del seguro para los ítems de línea de este código en las reclamaciones del período.',
        anchor: 'Reclamación generada; montos actualizados.',
        gotchas: 'Crece con el tiempo a medida que se contabilizan los pagos.',
      },
      insurance: {
        label: 'Aseguradora',
        definition:
          'La aseguradora indicada en la línea de reclamación. Se agrupa por texto exacto tras recortar y colapsar espacios; distingue mayúsculas, así que "BCBS" y "Blue Cross Blue Shield" son dos aseguradoras.',
        gotchas:
          'Desconocida = la reclamación no tiene aseguradora. Los nombres vienen del desplegable del formulario de evaluación; si aparecen dos grafías de una misma aseguradora, es una cuestión de datos, no algo que el panel fusione.',
      },
      lineCount: {
        label: 'Líneas',
        definition: 'Líneas de reclamación de este CPT y aseguradora en el período.',
        formula:
          'Solo se cuentan las líneas cuyo CPT está en la configuración ISP de la cuenta — la misma regla que las columnas monetarias del portafolio.',
      },
      paidLineCount: {
        label: 'Líneas pagadas',
        definition: 'Líneas con pagado > 0.',
      },
      avgPaidPerPaidLine: {
        label: 'Promedio pagado / línea pagada',
        definition: 'La tarifa que esta aseguradora realmente reembolsa por este CPT.',
        formula: 'totalPaid / paidLineCount. Vacío cuando paidLineCount es 0.',
        gotchas:
          'En la vista de portafolio la fila de cabecera de la aseguradora usa los totales de grupo del backend, calculados sobre todo el conjunto filtrado, así que no cambia al cargar páginas. El precio ISP no se promedia en la cabecera a propósito: difiere por cuenta, y esa diferencia es el objetivo de la vista.',
      },
      cptStatus: {
        label: 'Estado del CPT',
        definition: 'Dónde se encuentra actualmente este ítem de línea en el flujo de facturación.',
        formula: [
          'paid — el seguro ha pagado este ítem de línea.',
          'billed — enviado al seguro, esperando adjudicación.',
          'inProcess — se está trabajando internamente, aún no se ha enviado.',
          'patientResponsibility — el saldo se trasladó al paciente (copago / deducible / denegación al paciente).',
          'denied — el seguro denegó este ítem de línea.',
          'resubmitted — denegado previamente, corregido y reenviado.',
          'notBillable — marcado como no facturable, excluido del flujo de facturación.',
        ],
      },
      paid: {
        label: 'Pagado',
        definition:
          'Dólares que el seguro efectivamente pagó a la práctica por este ítem de línea.',
        gotchas:
          'Puede ser 0 (aún no pagado / denegado / responsabilidad del paciente). El mismo dinero que Reembolso en L1 / Ganancia del proveedor en L2 — solo que a nivel de fila.',
      },
      price: {
        label: 'Precio',
        definition:
          'El precio contractual de QHS para este código según la configuración ISP de la cuenta — lo que QHS cobra a la cuenta por él.',
        gotchas:
          'Es 0 si el código no está en la configuración (no mapeado). Responde a una pregunta distinta que Pagado — Pagado = ingresos de la práctica; Precio = ingresos de QHS por unidad. No los sume.',
      },
    },
  },
  oauthConsent: {
    title: 'Autorizar acceso',
    subtitle: 'quiere acceder a su cuenta de QHS:',
    scopeSignedIn: 'Ver su nombre y la cuenta de QHS en la que ha iniciado sesión',
    scopeAnalytics:
      'Leer analíticas agregadas de rendimiento de evaluaciones a las que ya tiene acceso',
    unverifiedApp:
      'QHS no ha verificado esta aplicación. El nombre de arriba lo elige la propia aplicación; permita el acceso solo si usted inició esta conexión y confía en ella.',
    allow: 'Permitir',
    deny: 'Denegar',
    expiredMessage:
      'Esta solicitud ha expirado o ya no es válida. Inicie la conexión de nuevo desde su cliente MCP.',
    missingRequest:
      'No se encontró ninguna solicitud de conexión. Inicie la conexión de nuevo desde su cliente MCP.',
  },
  dateRangePicker: {
    today: 'Hoy',
    yesterday: 'Ayer',
    thisWeek: 'Esta semana',
    lastWeek: 'Semana pasada',
    thisMonth: 'Este mes',
    lastMonth: 'Mes pasado',
    daysUpToToday: 'días hasta hoy',
    daysStartingToday: 'días desde hoy',
  },
  patientOptions: {
    languageEnglish: 'Inglés',
    languageSpanish: 'Español',
    languageUnknown: 'Desconocido',
    raceNonHispanicWhite: 'Blanco no hispano / Caucásico',
    raceHispanicLatino: 'Hispano / Latino',
    raceAfricanAmericanBlack: 'Afroamericano / Negro',
    raceAsian: 'Asiático',
    raceAmericanIndianAlaskaNative: 'Indígena americano o nativo de Alaska',
    raceNativeHawaiianPacificIslander: 'Nativo de Hawái u otras islas del Pacífico',
    raceMiddleEasternNorthAfrican: 'De Oriente Medio o África del Norte',
    raceMultiracialOther: 'Multirracial o ninguna de las anteriores',
  },
  patientHero: {
    dob: 'F. nac.',
    mrn: 'MRN',
    phone: 'Teléfono',
    language: 'Idioma',
    insurance: 'Seguro',
    yearsOld: 'años',
    editPatient: 'Editar paciente',
    callPatient: 'Llamar al paciente',
    emailPatient: 'Enviar correo al paciente',
    noPhoneOnFile: 'Sin teléfono registrado',
    noEmailOnFile: 'Sin correo registrado',
    openInfoPane: 'Panel de información del paciente',
    drugAllergies: 'Alergias a medicamentos',
    anonymousPatient: 'Paciente anónimo',
    openDashboard: 'Abrir panel del paciente',
  },
  usStates: {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawái',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Luisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Misisipi',
    MO: 'Misuri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'Nuevo Hampshire',
    NJ: 'Nueva Jersey',
    NM: 'Nuevo México',
    NY: 'Nueva York',
    NC: 'Carolina del Norte',
    ND: 'Dakota del Norte',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregón',
    PA: 'Pensilvania',
    RI: 'Rhode Island',
    SC: 'Carolina del Sur',
    SD: 'Dakota del Sur',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'Virginia Occidental',
    WI: 'Wisconsin',
    WY: 'Wyoming',
    DC: 'Distrito de Columbia',
  },
  sidebar: {
    groupOrganization: 'Organización',
    groupMonitoring: 'Monitoreo',
    groupPatientCare: 'Atención al paciente',
    groupOperations: 'Operaciones',
    noNewAlerts: 'No hay alertas nuevas',
    seeAllAlerts: 'Ver todas las alertas',
    critical: 'Crítica',
    alertSingular: 'alerta',
    alertPlural: 'alertas',
    alertGroupImminentRisk: 'Riesgo inminente',
    alertGroupHelpSeekingBehavior: 'Búsqueda de ayuda',
    alertGroupRiskFactorsIdentified: 'Factores de riesgo identificados',
  },
};
